import { GET_TENANT_CONFIG, UPDATE_TENANT_CONFIG, UPDATE_TENANT_CONFIG_SUCCESS, UPDATE_TENANT_CONFIG_ERROR, ANALYTICS_UNIQUE_IDENTIFIERS, ITEM_ADD_HOPE, ITEM_CARRY_BAG, SETLOCATION_NAVIGATION, SETLOCATION_HOME_NAVIGATION, CHECKOUT_DISPOSTION_OPTIONS_INFO, } from '../../constants';
import { AnalyticsProviders, DeepLinkProviders, BrazeExternalIds } from '../../analytics/models/Event';
import { postalCodeRegExAU, postalCodeRegexCA, postalCodeRegexZA } from '../../constants/RegexConstant';
import Strings from '../../constants/Strings';
import { config } from '../../config/config.utils';
import App from '../../App';
import { BRAZE_EMAIL_SUBSCRIPTION_GROUP_ID, BRAZE_SMS_SUBSCRIPTION_GROUP_ID, GENERIC_MENU_NAME, GENERIC_MENU_NAME_CATERING, COUNTRY_CODES } from '../../config/config.constants';
const { GA4, GTM, Braze, EnhancedBraze, MParticle, FullStory } = AnalyticsProviders;
const { Firebase, Universal, Branch, MParticleBranchKit } = DeepLinkProviders;
const { PHONE_NUMBER, EMAIL } = ANALYTICS_UNIQUE_IDENTIFIERS;
const PHONE_NUMBER_FORMAT = '[000]-[000]-[0000]';
const fontFamilyRegular = 'National2Test-Regular';
const fontFamilyMedium = 'National2Test-Medium';
const RESTRICTED_BAD_WORDS = [
    'anal',
    'anus',
    'arse',
    'ass',
    'ass fuck',
    'ass hole',
    'assfucker',
    'asshole',
    'assshole',
    'bastard',
    'bitch',
    'black cock',
    'bloody hell',
    'cockfucker',
    'cocksuck',
    'cocksucker',
    'coon',
    'crap',
    'cunt',
    'cyberfuck',
    'erect',
    'erection',
    'faggot',
    'fuck',
    'Fuck off',
    'fuck you',
    'fuckass',
    'fuckhole',
    'god damn',
    'gook',
    'homoerotic',
    'lesbian',
    'lesbians',
    'mother fucker',
    'motherfuck',
    'motherfucker',
    'negro',
    'nigger',
    'orgasim',
    'orgasm',
    'penis',
    'penisfucker',
    'piss',
    'piss off',
    'porno',
    'pornography',
    'pussy',
    'retard',
    'sadist',
    'shit',
    'slut',
    'son of a bitch',
    'suck',
    'tits',
    'viagra',
    'whore',
];
const sentToPosCompleted = 'sent-to-pos-completed';
const riderStatus = 'deliveryDetails.riderStatus';
export const tenantData = {
    region: 'NA',
    imagebaseurl: 'images.kfc.in',
    gtmContainerName: '',
    analyticsProviders: {
        web: [GTM],
        mobile: [GA4, FullStory],
    },
    defaultAnalyticsProviders: {
        web: [GTM],
        mobile: [GA4, FullStory],
    },
    deepLinkProviders: {
        mobile: [Universal],
    },
    analyticsUniqueIdentifier: '',
    storeFilterTags: [],
    productFilterTags: [],
    appReviewMinOrdersToLaunch: 3,
    appReviewPromptDaysToWait: 180,
    mobilesecretmenuname: null,
    secretmenutime: null,
    ispolygonrequired: false,
    accountdashboardpreviousordercount: '3',
    orderstatusnotifications: false,
    cateringmaxorderfuturedaycount: '6',
    maxNoOfVoucher: 5,
    cateringminorderdaycount: '1',
    mobilecontactlessdeliveryenabled: true,
    storelocatormaxreturncount: '10',
    buffertimepmdelivery: '30',
    buffertimepmpickup: '30',
    secondarycontact: null,
    imageVersion: '1.0.0',
    authoredContent: {
        appUpdate: {
            currentVersion: {
                imageVersion: '1.10',
            },
            minSupportedVersion: {
                imageVersion: '1.10',
            },
        },
        supporteddispositions: ['Delivery', 'Takeaway', 'DineIn'],
        defaultdisposition: 'Takeaway',
        defaultcateringdisposition: 'Catering',
        Carousel: {},
        'General Routing Information': {},
        'Loyalty Sign Up': {},
        Header: {},
        Footer: {},
        'Generic Offers & Deals': {},
        'Generic Categories': {},
        i18n: {
            title: 'screen title',
            10001: 'Error message',
        },
    },
};
export const initialState = {
    [COUNTRY_CODES.IN]: {
        ...tenantData,
        allowXLanguage: false,
        disableOrderTypeAnalytic: false,
        reOrderCardDateFormat: 'ddd, MM/DD/YYYY',
        signUpEnabled: false,
        orderReadyDateTimeUpdate: true,
        autoSuggestionDeliveryFilter: ['address'],
        configTenantFlag: false,
        phoneNumberValidation: true,
        dateFormat: 'DD/MM/YYYY',
        promoDateFormat: 'DD/MM/YY',
        imageCacheBurstingTag: 'gdOZD5',
        orderServDateFormat: 'YYYY-MM-DD',
        orderservTime: 'HH:mm',
        pastOrderDateformat: 'MMM DD, YYYY',
        postOrderDateformat: 'MMM D, YYYY',
        timeFormat: 'h:mm a',
        timeFormatcaps: 'h:mm A',
        pastOrderTimeFormat: 'hh:mma',
        orderTrackingtimeFormat: 'h:mma',
        startTimeFormat: 'h:mm',
        startDateFormat: 'MMM D',
        orderServTimeFormat: 'LT',
        currencySymbol: '₹',
        addHope: ITEM_ADD_HOPE,
        carryBag: ITEM_CARRY_BAG,
        currencyShortName: 'INR',
        rupeeIcon: '\u20B9',
        minusSign: '\u2212',
        currencyFormat: 'en-IN',
        colonelsClubEnabled: false,
        currencyConversionFactor: 100,
        country: 'INDIA',
        countryNameInDefaultLang: 'INDIA',
        isEnabledTodayStringLiteral: true,
        is24HoursFormatEnabled: false,
        tenantId: '15895bb59f7b4bb588ee933f8cd5344a',
        genericMenuName: 'KFCIndiaMenu-Generic',
        brazeEmailGroupId: '123',
        brazeSMSGroupId: '123',
        brazeSMSMarketingOption: false,
        kfcPhoneNumber: '+918042754444',
        allowRemoteWipeOut: true,
        minutes: 'minutes',
        kilojoule: 'kJ',
        displayPriceWithoutTax: true,
        isZeroDollarEnabled: false,
        defaultLocation: {
            lat: 17,
            lng: 78,
        },
        deliveryProgressBar: 5,
        deliveryOrderStatus: {
            posCompleted: {
                status: sentToPosCompleted,
                progressIndex: 0,
                showdefault: true,
                showOrderDetails: true,
                showAddFav: true,
                title: 'orderReceived',
            },
            created: {
                status: 'delivery_created',
                progressIndex: 1,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                showAddFav: true,
                title: 'orderGettingReady',
                findingDriver: 'findingDriver',
            },
            assigned: {
                status: 'dasher_confirmed',
                progressIndex: 1,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                assignedStatus: true,
                showAddFav: true,
                title: 'foundDeliveryDriver',
                statusText: 'hasAcceptedToDeliverYourOrder',
            },
            pickedUp: {
                status: 'dasher_confirmed_store_arrival',
                progressIndex: 2,
                displayContactCard: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'makingOrderFresh',
                statusText: 'IsOnHisWayToTheRestaurant',
                showWebView: true,
            },
            outForDelivery: {
                status: 'dasher_picked_up',
                progressIndex: 3,
                displayContactCard: true,
                showdefault: false,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'orderOnTheWay',
                statusText: 'isOnTheWay',
                showWebView: true,
                collapseAccordion: true,
            },
            arrived: {
                status: 'dasher_confirmed_consumer_arrival',
                progressIndex: 4,
                displayContactCard: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'driverArriving',
                arrivedStatus: true,
                statusText: 'isAlmostThere',
                showWebView: true,
                collapseAccordion: true,
            },
            delivered: {
                status: 'dasher_dropped_off',
                showAddFav: true,
                displayHalfWebview: true,
            },
            cancel: {
                status: 'delivery_cancelled',
                showOrderDetails: true,
                displayHalfWebview: true,
            },
        },
        updateStoreDataFromBasket: false,
        deliveryOrderStatusKeyApi: 'status',
        updateStoreDataFromBasket: false,
        itemVisibleThresholdPercent: 80,
        basic: {
            //In future if we want to support multiple languages the allowedLanguages structure should be
            //[{ key: 'en-US', value: 'English', short_value: 'ENG' }] like this
            allowedLanguages: [],
            defaultLanguage: { key: 'en-US', value: 'Eng' },
            allowedChannels: ['web', 'app'],
            allowedServices: ['pickup', 'delivery', 'dine-in'],
            isCheckinAllowed: false,
        },
        errorScreenBtnClose: 'Close',
        countryCode: [COUNTRY_CODES.IN],
        maxItemCountPerLineItem: 0,
        paymentStatusMaxCallCount: 5,
        analyticsProviders: {
            web: [GTM],
            mobile: [GA4, Braze, AnalyticsProviders.Branch, FullStory],
        },
        defaultAnalyticsProviders: {
            web: [GTM],
            mobile: [GA4, Braze, AnalyticsProviders.Branch, FullStory],
        },
        analyticsUniqueIdentifier: PHONE_NUMBER,
        deepLinkProviders: {
            mobile: [Firebase, Branch],
        },
        deliveryAddressMapping: {
            pinCode: 'postal_code',
            country: 'country',
            state: 'administrative_area_level_1',
            city: 'administrative_area_level_2',
            addressLine0: '',
            addressLine1: 'premise+route+sublocality_level_3+sublocality_level_2+sublocality_level_1',
            addressLine2: 'locality',
        },
        storeSearch: {
            isPolygonRequired: false,
            maxDriveTimeMins: 12,
            distanceMetrics: 'km',
            maxDeliveryDistanceMtrs: 7500,
            maxPickupDistanceMtrs: 20000,
            geohashprecision: 4,
            boundingBoxSizeMeters: 10000,
            numOfStoresToShow: 5,
            showScheduleOrder: false,
            calculateDistance: 1000,
            storeEntities: {
                lsr: 'SFIPL',
                'ncr-aloha': 'EQUITY',
                lsrdil: 'DIL',
            },
            shouldCallGoogleDistanceApi: true,
            numOfStoresToShowDelivery: 2,
        },
        savedAddressPage: {
            shouldCheckDisposition: true,
        },
        showFootercopyrightNavLinks: false,
        componentOptions: {
            storeSelection: {
                signInLink: true,
                useMyLocation: true,
                placesSearchInput: true,
            },
            ScheduledDeliveryComponent: {
                allowScheduleOrder: true,
            },
            analyticsUtils: {
                loginMethodCheck: false,
            },
            appreviewPrompt: {
                showAppReviewPrompt: true,
            },
            coupons: {
                noOfCoupopnAllowed: 1,
                showCouponCopied: true,
                couponCopiedMessage: 'Coupon Copied',
            },
            routes: {
                Home: {
                    reactnavigation: 'name',
                    reactrouter: 'path',
                    Options: {
                        showicon: true,
                        hide: true,
                    },
                    offersAndDeals: {
                        showViewDetailsButton: true,
                        showRedeemButton: true,
                    },
                    crmSignUpEnabled: false,
                },
            },
            PlpProductCard: {
                allowAddToCartButton: true,
                allowClickOnProductCard: false,
                plp_AddToCartLabel: 'Add to cart',
                plp_disableScreenClick: true,
                plp_HideAddToCartButton: false,
                plpWarningMsg: false,
            },
            checkBalance: {
                emaildisbledFlag: true,
            },
            accountSettings: {
                phoneNumberMask: PHONE_NUMBER_FORMAT,
                communicationPreferenceComponent: true,
            },
            checkout: {
                phoneNumberLength: 10,
                phoneNumberMask: '[0000000000]',
                nameCharacterLimit: 200,
                emailCharacterLimit: 254,
                displayAddressLine2: true,
                addressCharacterLimit: 40,
                phoneNumberRegExp: /^\d*$/,
                displayDeliveryTipping: false,
                tippingRegex: /^(\d*\.{0,1}\d{0,2}$)/,
            },
            payment: {
                cardValidation: {
                    minCvvLength: 3,
                    maxCvvLength: 4,
                    minCardNumberLength: 13,
                    maxCardNumberLength: 16,
                    minNameLength: 1,
                    maxNameLength: 200,
                    expiryDateLength: 6,
                    expiryDateFormat: 'MM/YYYY',
                    creditCardNumberMask: '[0000]-[0000]-[0000]-[0000]',
                    expiryMask: '[00]/[0000]',
                    cvvMask: '[0000]',
                    giftCardMask: '[0000000000000000]',
                    pinNumberLength: 6,
                    pinNumberMask: '[000000]',
                },
                supportGPay: true,
                paymentProvider: 'billdesk',
                paygateSavedCard: false,
            },
            phoneNumberConstants: {
                phoneNumberMaxLength: 12,
                phoneNumberMinLength: 10,
                phoneNumberDigit11: 11,
                phoneNumberDigit6: 6,
                phoneNumberDigit91: '91',
                phoneNumberDigit0: '0',
                phoneNumberDigitEmpty: 0,
                phoneNumberLength: 12,
                phoneNumberMask: '[000000000000]',
                phoneRegexPattern: /(\d{4})(\d{3})(\d{3})/,
                splitPattern: '$1 $2 $3',
            },
            homePage: {
                pastorderFullOrderHistoryShowBtn: true,
            },
            cartPage: {
                cartWarningMsg: false,
                validateRemoveCoupon: true,
            },
            web: {
                global: {
                    allowOtpPopup: false,
                    supportGooglePaySpot: true,
                    showBlackStripWithOrderTracker: true,
                    showNeedhelpModal: false,
                    showSecondaryHeader: true,
                    hideOrderProgressHeader: false,
                    minLengthFullName: 2,
                    maxLengthFullName: 26,
                    minLengthFirstName: 2,
                    maxLengthFirstName: 26,
                    minLengthLastName: 2,
                    maxLengthLastName: 26,
                    maxLengthEmail: 26,
                    minLengthPhoneNumber: 10,
                    maxLengthPhoneNumber: 12,
                    validateRestrictedWords: false,
                    cateringNavigationAllowed: false,
                    showPriceWithTax: false,
                    privateRouteNotMemberRedirectToHome: true,
                    formattedDeliveryAddressFilterBy: 'long_name',
                    headerContentDataWithFieldsName: true,
                    enableLocalisationErrorAnalytic: false,
                    updateValueFromDispositionNew: false,
                    loadGlobalStyleClass: false,
                    pullToRefreshEnabled: true,
                    isEnablePostalCodeSignUp: false,
                    postalCodeRegex: /^(0[289][0-9]{2})|([1-7][0-9]{3})$/,
                    showVipContent: false,
                    showVipLogo: false,
                    showVipBanner: false,
                    showPostalCode: false,
                    showTermsConditions: false,
                    showTermsUsePwa: false,
                    showMandatoryItem: false,
                    showCreateAccountTitle: false,
                    showPersonalInfoAccountTitle: false,
                    showCreateAccountList: false,
                    postalCodeFormatNumber: 3,
                },
                pdp: {
                    productCustomizationUpsizeDropdown: true,
                    productCustomizationModifierAccordion: true,
                    productCustomizationAccordionDefaultOpen: true,
                    addToCartButton: true,
                    makeItComboButton: true,
                    showMaxBadge: false,
                    deltaPriceInAccordion: false,
                    showUpSellSection: true,
                    showCrossSellSection: true,
                    breadcrumbShowProduct: true,
                    shouldShowRecommendationCardCount: true,
                    showLegalInfo: false,
                    shouldFilterRecommendationListWithCartData: false,
                    showCartToastInPDP: true,
                    itemCountShouldAtModifierLevel: false,
                    showUpsizeDropdown: true,
                    cartErrorSingleLineMsg: false,
                },
                dispositionConfig: {
                    enableDispositionModuleOrderTypeAnalytics: false,
                    analyticsRequiredOnStoreSelection: false,
                    enableChangeStoreEventOnChange: false,
                    enableAutoSetLocation: false,
                    enableScheduleOrder: true,
                    enableClickCollectScheduleOrder: false,
                    enableOrderModeScreen: false,
                    autoSelectDeliveryStore: false,
                    disableChangeCTAForDelivery: false,
                    apartmentDetailsRegex: /^([a-zA-Z0-9/ .,]){0,40}$/,
                },
                shouldCheckDropOffAddress: false,
                cartPage: {
                    modifierDataFlag: false,
                    notificationFlagMobile: true,
                    cartExpiredUserLastActiveTimeInvalid: false,
                    showTaxLines: false,
                    enableAddGiftCardOrVoucher: false,
                    showPromoRewardsMessage: true,
                    showCarrybagCheckbox: true,
                    showAddHopeCheckbox: true,
                    allowLoggedInMember: true,
                },
                coupons: {
                    showErrorToast: true,
                    sendViewAllDealsEvent: false,
                },
                homePage: {
                    homePageUseBrowseMenu: false,
                    homePageSkipContant: true,
                },
                plp: {
                    compactMenuPlpDisclaimerReducerData: false,
                    menuItemsFilterNotHiddenProducts: false,
                    displayLargeCategoryName: false,
                    promosRewardsImage: false,
                },
                checkout: {
                    checkoutUpdatePaymentAnalytics: true,
                    enableValidateOrderAction: false,
                    validateCateringSomeOneElseContactDetails: false,
                    enableDispatchResetOrderAction: true,
                    enableBeginCheckoutAnalyticsWithUserType: false,
                    enableDoorDashRequest: false,
                    cartDataValidateionResultNullCheck: false,
                    checkoutDisplayFullName: true,
                    showSignUpBtn: false,
                    enableContinuePayment: false,
                    checkoutDispositionFirstOption: CHECKOUT_DISPOSTION_OPTIONS_INFO.LEAVE_AT_MY_DOOR,
                    checkoutDispositionDefaultOption: CHECKOUT_DISPOSTION_OPTIONS_INFO.LEAVE_AT_MY_DOOR,
                    showGiftCardOrVoucher: false,
                    showTaxExcluded: true,
                    showPromos: true,
                },
                orderPages: {
                    displayPOSOrderId: true,
                    enableDeliveryRiderStatus: false,
                    enablePickupOrderCheckedInStatus: false,
                    enableCateringOrderCheckedInStatus: false,
                    singleOrderTrackerRedirectToPaymentSuccess: true,
                    enableGlobalHeaderTrackOrder: false,
                    orderSummaryInfoPickupClosingSoonModal: false,
                    orderSummaryInfoDetailsEnableOpenAccordioncheck: false,
                    orderSummaryInfoShowToasterSaveYourOrderCompleted: true,
                    showOrderSummaryShowRefundWithBusinessDays: true,
                    showDeliveryTrackingIFramePanel: true,
                    orderSummaryShowPickupOrderCollectionMethodPanel: false,
                    displayPastOrderCardTotal: true,
                    enableKeepOrderAnalytic: false,
                    dispalyReorderAccordianItemAmount: true,
                    dispalyReorderAccordianTotalAmount: true,
                    hideCancelOrderPanel: false,
                    enableCancelOrderCallsupportModal: false,
                    pickupTrackOrderButtonLabel: 'pickupMethods',
                    enableGlobalOrderTracking: false,
                    enableRetryCountForPickupOrderTracking: false,
                    showOrderTrackingIFrame: false,
                    showDeliveryTrackingMap: true,
                    showDeliveryOrderRaiderDetailsView: true,
                    orderTrackingProgressBarCount: 7,
                    showDeliveryDriverDetails: false,
                    enableReadytoCollectLabel: false,
                    orderTrackingProgressBarScheduleOrdersCount: 2,
                    showOrderSummaryInfoDetails: false,
                    showGiftCardOrVoucherSummary: false,
                    showPromosSummary: true,
                    deliveryProgressBarAsapOrder: {
                        isDeliveryOrderPOSCompleted: 1,
                        isDeliveryOrderCreate: 2,
                        isDeliveryOrderAssign: 3,
                        isDeliveryOrderStoreArrival: 4,
                        isDeliveryOrderPickedUp: 5,
                        isDeliveryOrderOutForDelivery: 6,
                        isDeliveryOrderArrivedOrder: 7,
                    },
                    deliveryProgressBarScheduleOrders: {
                        isDeliveryOrderPOSCompleted: 1,
                        isDeliveryOrderCreate: 2,
                        isDeliveryOrderAssign: 3,
                        isDeliveryOrderStoreArrival: 4,
                        isDeliveryOrderPickedUp: 5,
                        isDeliveryOrderOutForDelivery: 6,
                        isDeliveryOrderArrivedOrder: 7,
                    },
                    hideEstimatedDeliveryTime: {
                        isDeliveryOrderCancelledOrRefund: true,
                    },
                    hideProgressBar: {},
                    getDeliveryActualPickupTime: false,
                    showOrderName: true,
                },
                payment: {
                    paymentFailedResetOrderAndBasket: true,
                    showFailedScreenOrderAccepted: false,
                    paymentCardValidateFailed: false,
                },
                accountPage: {
                    accountSettingsUpdateCustomerInfo: false,
                    termsConditionsCheckbox: false,
                    marketingCommunicationCheckbox: false,
                    showMyPaymentMethods: false,
                    addNewCreditOrDebitCard: false,
                    suggestStreetAddress: false,
                    suggestionFilter: ['address'],
                    maxSavedCardLimit: 0,
                    validateNameRegex: /^(?=.*[a-zA-Z].*)([a-zA-Z-']{1,100})$/,
                    showSavedCardCvv: false,
                },
                restaurantDetailPage: {
                    storeNumberFormat: /([0-9]{1,2})([0-9]{4})([0-9]{4}$)/,
                },
                contactKFC: {
                    isRenderIframeinContactUs: false,
                },
                scheduledDelivery: {
                    allowScheduleOrderForDispositions: [],
                },
                giftCardPageGlobal: false,
            },
            app: {
                home: {
                    callFetchMenu: true,
                    carousel: {
                        paginationColor: 'background',
                        backgroundColor: Strings.dark,
                    },
                    welcomeBanner: {
                        showOffersLink: true,
                        showMyAccountLink: false,
                    },
                    banner: {
                        validateUserTypeAndLoc: false,
                    },
                    marketingHero: {
                        checkLocalisationAndNavigation: false,
                    },
                },
                accountSettings: {
                    isAuthOtpRequired: true,
                    showNonEditableEmailField: false,
                    showPostalCodeField: false,
                    showDOBField: false,
                    showClonelsClubMember: true,
                    showEmailPreference: false,
                    showNotificationPreference: false,
                    showSmsPreference: true,
                    isFirstNameMandatoryField: false,
                    isLastNameMandatoryField: false,
                    isPostalCodeMandtoryField: false,
                    postalCodeLength: 4,
                    postalCodeRegEx: postalCodeRegExAU,
                    formatPostalCode: false,
                    isEmailMandatoryField: false,
                    showToolTip: false,
                    isPhoneNumberValidationEnabled: false,
                    addAdditionalAttribute: false,
                    phoneNumerText: 'phoneNumber',
                    isEmailPrefGroupSubscription: false,
                    brazeExternalId: BrazeExternalIds.PhoneNumber,
                },
                global: {
                    defaultLoaderImage: 'kfcLoaderGif',
                    cateringNavigationAllowed: false,
                    getImageFromContent: false,
                },
                headerComponent: {
                    navigateToHome: true,
                },
                account: {
                    isInTenant: true,
                    isSopacTenant: false,
                    showContentCards: true,
                    showLogoutModal: false,
                    addressText: 'addressPlaceHolder',
                    getDispositionFlag: true,
                    showMyPaymentMethods: false,
                    showAddNewCardOption: false,
                    useDefaultDispositionForFavStore: true,
                    showMaxSavedCardWarningToast: false,
                    maxSavedCardLimit: 1000,
                    limitSavedCardList: false,
                },
                orderHistory: {
                    showFavouriteItemIcon: true,
                    showOrderLookup: true,
                    showPickupMethods: false,
                    showItemDescription: true,
                    showCartLineItemImage: true,
                    viewReceiptMore: true,
                    showTrackOrderCTA: false,
                },
                SignedOutComponent: {
                    showSigninSignUpBtnAlways: false,
                },
                disposition: {
                    showDispostionWithActive: true,
                    showDispositionTimeView: true,
                    showMonthAndDate: false,
                    showKeepitModal: false,
                    dispositionButtonText: 'changeCap',
                    showDispositionHeaderStickyFlag: false,
                    showDispositionHeaderFlag: true,
                    delivery: {
                        displayTime: '',
                        navigateToProductNotAvailable: true,
                        shouldGetAvailableTimeslots: true,
                    },
                    activeOrderPayload_OrderMode: 'delivery',
                    showDispositionHeaderScrollableFlag: true,
                    showNonLocalization: true,
                },
                plp: {
                    checkIsProductAvailableFlag: true,
                    checkIsProductAvailableSopacFlag: false,
                    closingTimeFlag: false,
                    showStoreOfflineFlag: false,
                    isScrollDispositionFlag: true,
                    validateViewModeType: true,
                    showAddtoCartBtn: true,
                    navigateToPDP: false,
                    showFavouriteIcon: true,
                    showPromosSection: false,
                    showGenericMenu: true,
                    showLegalInfo: false,
                    getImageFromContent: false,
                    showProductDescription: true,
                    showFoodType: true,
                    showSecretMenu: false,
                    showCardBadge: true,
                    modelButtonText: 'continue',
                    showItemDetailsMultiline: false,
                },
                pdp: {
                    getImageFromContent: false,
                    showLegalInfo: false,
                    showAllergyNutrition: false,
                    showDispositionHeaderFlag: false,
                    getMealOptionsFromContent: false,
                    mealOptionsTitleTxt: 'insideYourMeal',
                    showHeader: false,
                },
                checkout: {
                    showCloseModalAndCloseSoonModal: false,
                    isProfileRequired: true,
                    isHOCRequired: true,
                    showSignUpBtn: false,
                    showMemberWarningMessage: false,
                    showContactInfo: true,
                    showOrderSummary: false,
                    showTimeSlot: true,
                    addressLineRequired: true,
                    paymentType: 'hosted',
                    paymentProvider: 'billdesk',
                    showGuestCheckout: false,
                    showDeliveryInstructionsAlways: false,
                    passDeliveryPartnerForPickup: false,
                    passDeliveryPartnerForDeliveryFromOS: false,
                    defaultDeliveryPartner: 'dista',
                    showFullDateTime: false,
                    showTaxExcluded: true,
                    paymentSectionTitleText: 'paymentSectionTitle',
                    tendertypeWithoutPayment: '',
                    callOrderApiOnCheckout: false,
                },
                cart: {
                    showRecommendationsView: {
                        showCalories: true,
                        showAddToCart: true,
                        showDescription: true,
                        showQuantityModifier: true,
                        showVeg: true,
                        showFav: true,
                        plpClickDisable: true,
                    },
                    enableApplyCoupon: false,
                    showRescheduleModalForStoreOpen: false,
                    showToastAfterItemCustomized: false,
                    showToastOnUpdateQuantity: true,
                    showToastOnRemoveItem: true,
                    showRemoveItemConfirmPopUp: true,
                    showCartBottomToast: true,
                    showRemoveAllBtn: true,
                    shouldShowCustomTextSopacFlag: false,
                    navigateUsingLocalization: false,
                    showRemoveButtonForPromoItem: false,
                    isDispositionHeaderSticky: false,
                    isDispositionHeaderScrollable: true,
                    showCouponAppliedToast: true,
                    showErrorToast: true,
                    checkEditMessagePopup: false,
                    checkOutTotalValue: 'total',
                    deliveryFee: true,
                    showGstValue: true,
                    cartGstText: 'cartGst',
                    removeInvalidatedCoupons: true,
                    callCreateOrder: false,
                    showEditButtonIfCustomizable: true,
                    showCustomiseBtnIfModData: false,
                    showUpdateQtyForPromoItem: false,
                    showPromosUnMetConditionToast: false,
                    showProductPromoFlag: false,
                    showPromosAppliedView: false,
                    showPromosInfoContainer: false,
                    showDiscountedPriceAfterLogin: false,
                    showDiscountText: true,
                    showErrorMessageForExpiredCoupon: true,
                    showCouponRemovalButton: true,
                    navigateToPromosTab: false,
                    offersAndDealsLinkText: 'cartOffersDeals',
                    // To be removed after toggle merge
                    showToastAtEditLineItemFlag: false,
                    showRemoveAllContainerFlag: true,
                    showEditButtonFlag: true,
                    showEditButtonCustom: false,
                    shouldShowModifierGroupsFlag: false,
                    showRecommendations: true,
                    shouldValidateStoreAndItemsAvailability: true,
                    shouldCheckIfStoreOpen: false,
                    shouldCheckIfStoreClose: false,
                    shouldValidateCheckoutButtonState: false,
                    showIndulgentAddOnsCrossCell: false,
                    shouldHideCartLabel: false,
                    shouldNavigateToMenu: false,
                    showThresholdError: false,
                    showProductEditedBanner: false,
                    qualityModifierStyle: 'addRemoveViewContainerIN',
                    itemPriceTextStyle: 'itemPriceTextIN',
                    unavailableItemPriceTextStyle: 'unavailableItemPriceTextIN',
                    removeLineItemViewContainerStyle: 'removeLineItemViewContainerIN',
                    toastImageStyle: '',
                    toastTextStyle: 'removeLineItemConfirmationTextIN',
                    toastImage: 'greenColorTick',
                    toastAccessibilityLabel: 'rightTick',
                    subAmountContainerStyle: 'subAmountContainerIN',
                    discountRemoveButton: false,
                    discountCardView: false,
                    showAsap: true,
                    showTaxLines: false,
                    // end ** to be removed//
                },
                more: {
                    getMoreDataLinksFromHeaderSection: false,
                    showSignInButton: false,
                    loginRedirectFromMore: '',
                    showSubHeadersInMiddle: false,
                },
                coupons: {
                    showAddToOrderBtn: false,
                    showRedeemBtn: true,
                    showViewAllPromosLink: false,
                    showMembersOnly: false,
                    showGotItBtn: false,
                    showRedeemBtnDetails: true,
                    showReviewConditions: false,
                    showLongDescription: true,
                    showLegalInfo: true,
                    cardImagePath: 'offers',
                    detailsImagePath: 'offers',
                    shouldCheckLocalization: false,
                    signInCardText: 'SignInToSeeOffers',
                    promosTitle: 'offerDeals',
                    nonLocalizedText: 'seeOffersForYou',
                    shouldGetOffersAndDeals: true,
                },
                help: {
                    contentPayload: 'Help',
                    headLineTitle: true,
                    showNeedHelpNow: false,
                    subHeading: true,
                    callDesc: true,
                    mainHeading: true,
                    showNearKfc: true,
                    showGetBackToMe: false,
                    showNeedToTalk: true,
                    showCallUsText: true,
                    showDropUsText: false,
                    showFqaText: false,
                    showContactText: true,
                    showFaqDes: false,
                    showcontactDesc: true,
                    showCallKfcStore: false,
                    showCallRestaurant: true,
                    showSendUsMsg: false,
                    showCallText: true,
                    showContactButtonText: true,
                    showViewAllButtonText: false,
                },
                reorder: {
                    useOrderId: true,
                    showReviewOrder: false,
                    showReOrder: true,
                    showViewDetails: true,
                },
                quickReorder: {
                    checkItemAvailabilityOnLoad: false,
                    createBasketOnLoad: true,
                    callTendersDataOnLoad: true,
                    modifierFilterForIsAdded: false,
                    unAvailableItemErrorOnTopRequired: true,
                    ItemPriceChangeErrorOnTopRequired: true,
                    whenOptionRequired: true,
                    orderTypeChangeRequired: false,
                    locationChangeRequired: false,
                    restaurantChangeRequired: false,
                    itemUmAvailableWarningRequired: false,
                    continuePaymentOption: true,
                    orderAgainButtonOption: false,
                    wantToAddModifyRequired: true,
                    expandCollapseRequired: true,
                    isPaymentTypeRequired: false,
                    showAmountView: true,
                    showModifier: true,
                },
                webView: {
                    titleJSX: 'renderTitleIn',
                },
                addToCart: {
                    shouldCheckSecretMenu: false,
                },
                modal: {
                    modalStyle: 'modalStyleIn',
                },
                minorUpdateComp: {
                    bottomSheetIcon: 'iconIn',
                },
                storeSearch: {
                    tradingHours: false,
                    showSearchFieldPlaceholder: true,
                    showStoreOpenStatus: true,
                    showOrderNowString: true,
                    enableScheduleOrderNowFunctionality: true,
                    showMoreInfoText: true,
                    showSheduledOrderCta: true,
                    showSheduledOrderCtaWhenStoreClosed: false,
                    showAdditionalView: false,
                    showOrderTypeError: false,
                    asapFlagFromOloAdminRequired: false,
                    autoSelectDeliveryStore: false,
                    showStoreListForOneStore: false,
                    isAdditionalAddressRequired: false,
                    addressErrorMessage: {
                        showIcon: true,
                        headerStyle: {
                            color: '#FF2E00',
                            fontFamily: fontFamilyRegular,
                        },
                    },
                },
                address: {
                    shouldRenderEmptyStoreList: false,
                    shouldshowflatSection: false,
                    showdeliveryOptions: false,
                    showdeliveryInstructionAddress: false,
                    nickNameOptional: false,
                    nickNameMandatory: true,
                    headerForAddress: 'address_title',
                    textForEmptyAddress: '',
                    disablePostalCodeField: true,
                },
                popNavigatorUtil: {
                    schedulrOrderTitle: 'scheduleOrder',
                },
                pickupTracking: {
                    showTrackingHeader: false,
                    showReceiptHeader: true,
                    showPickupMethods: false,
                    showCancelOrder: false,
                    showSaveOrderBottom: false,
                    showStorePhonenumber: true,
                    showViewDetails: true,
                    showAppRating: true,
                    orderRef: 'posOrderId',
                    showOperatingHrs: false,
                    showStoreAddress: true,
                    showDownArrow: false,
                    cancelOrderText: 'cancelOrderButtonText',
                    callSupportToCancelOrder: false,
                    enablePickupTracking: false,
                    showEmailText: false,
                    orderStatus: riderStatus,
                },
                scheduledDelivery: {
                    showKfcStoreNameForDelivery: false,
                    showScheduleDateTime: true,
                    showAusErrorMsgComponent: false,
                    showIndErrorMsgComponent: true,
                    dateFormat: 'DD/MM/YYYY',
                    initialDisplayTime: 'asap',
                    allowScheduleOrderForDispositions: ['pickup', 'delivery', 'dine-in'],
                    midnightOrderSupport: true,
                    showChangeCTAForRestaurant: true,
                    showStoreCardForClosedStore: false,
                    alwaysShowAsapInTimeslot: true,
                },
                deliveryTracking: {
                    displayScheduleProgressBar: false,
                    showDirections: true,
                    showStorePhoneNumber: false,
                    trackingUrl: 'tracking_url',
                    fetchContentfulData: false,
                    showStoreDetailsInContact: true,
                    showSMSviewInContact: false,
                    orderStatus: 'status',
                    riderName: 'rider_name',
                    riderPhone: 'rider_phone',
                    custmerCareNumber: '1800 958 316',
                },
                favouriteMenu: {
                    showFavItems: true,
                    buttonValueText: 'myOccasions',
                    sectionHeaderValue: false,
                    itemButtonText: 'delBtnOccasion',
                    favIcon: true,
                    unavailableErrorText: true,
                    checkIfNameExists: false,
                    delDescriptionValue: false,
                    submitButtonText: 'confirm',
                    deleteAddressItemText: 'delOccasionToastMsg',
                    showToastOnFavouriteOrder: false,
                    getImageFromContent: false,
                    showReviewOrderButton: false,
                    closeImageStyle: false,
                    buttonContainerStyle: false,
                },
                postOrderProcess: { backToCartBtnText: false },
            },
        },
    },
    [COUNTRY_CODES.AU]: {
        ...tenantData,
        allowXLanguage: false,
        disableOrderTypeAnalytic: false,
        signUpEnabled: true,
        orderReadyDateTimeUpdate: false,
        autoSuggestionPickupFilter: ['(regions)'],
        autoSuggestionDeliveryFilter: ['address'],
        configTenantFlag: true,
        isNavigateFromPromos: false,
        isNavigateFromHome: false,
        phoneNumberValidation: false,
        dateFormat: 'DD/MM/YYYY',
        promoDateFormat: 'DD/MM/YY',
        imageCacheBurstingTag: 'gdOZD5',
        orderServDateFormat: 'YYYY-MM-DD',
        orderservTime: 'HH:mm',
        pastOrderDateformat: 'MMM D, YYYY',
        cateringMonthDateFormat: 'MMMM DD',
        cateringMinPickupTime: '06:00:00',
        postOrderDateformat: 'MMM D, YYYY',
        itemAvailabilityTime: 'HHmm',
        timeFormat: 'h:mm a',
        timeFormatcaps: 'h:mm A',
        pastOrderTimeFormat: 'h:mma',
        orderTrackingtimeFormat: 'h:mma',
        startTimeFormat: 'h:mm',
        startDateFormat: 'MMM D',
        orderServTimeFormat: 'LT',
        currencySymbol: '$',
        addHope: ITEM_ADD_HOPE,
        carryBag: ITEM_CARRY_BAG,
        currencyShortName: 'AUD',
        rupeeIcon: '\u0024',
        minusSign: '\u2212',
        currencyFormat: 'en-AU',
        colonelsClubEnabled: true,
        currencyConversionFactor: 100,
        country: 'AUSTRALIA',
        countryNameInDefaultLang: 'AUSTRALIA',
        isEnabledTodayStringLiteral: true,
        is24HoursFormatEnabled: false,
        tenantId: 'afd3813afa364270bfd33f0a8d77252d',
        genericMenuName: 'KFCAustraliaMenu-677-web-pickup',
        brazeEmailGroupId: '123',
        brazeSMSGroupId: '123',
        brazeSMSMarketingOption: false,
        genericCateringName: 'KFCAustraliaMenu-677-web-catering',
        kfcPhoneNumber: '+918042754444',
        allowRemoteWipeOut: true,
        minutes: 'minutes',
        kilojoule: 'kJ',
        storeClosesSoonTimerInMinutes: 45,
        maximumCartTotal: 100,
        displayPriceWithoutTax: false,
        isZeroDollarEnabled: true,
        itemVisibleThresholdPercent: 80,
        defaultLocation: {
            lat: -35,
            lng: 149,
        },
        deliveryProgressBar: 5,
        deliveryOrderStatus: {
            posCompleted: {
                status: sentToPosCompleted,
                progressIndex: 0,
                showdefault: true,
                showOrderDetails: true,
                showAddFav: true,
                title: 'orderReceived',
            },
            created: {
                status: 'delivery_created',
                progressIndex: 1,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                showAddFav: true,
                title: 'orderGettingReady',
                findingDriver: 'findingDriver',
            },
            assigned: {
                status: 'dasher_confirmed',
                progressIndex: 1,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                assignedStatus: true,
                showAddFav: true,
                title: 'foundDeliveryDriver',
                statusText: 'hasAcceptedToDeliverYourOrder',
            },
            pickedUp: {
                status: 'dasher_confirmed_store_arrival',
                progressIndex: 2,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'makingOrderFresh',
                statusText: 'IsOnHisWayToTheRestaurant',
            },
            releaseOrder: {
                status: 'release_order_for_preparation',
                progressIndex: 2,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'makingOrderFresh',
                statusText: 'IsOnHisWayToTheRestaurant',
            },
            dasherEnroute: {
                status: 'dasher_enroute_to_pickup',
                progressIndex: 2,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'makingOrderFresh',
                statusText: 'IsOnHisWayToTheRestaurant',
            },
            outForDelivery: {
                status: 'dasher_picked_up',
                progressIndex: 3,
                displayContactCard: true,
                showMap: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'orderOnTheWay',
                statusText: 'isOnTheWay',
                collapseAccordion: true,
            },
            arrived: {
                status: 'dasher_confirmed_consumer_arrival',
                progressIndex: 4,
                displayContactCard: true,
                showMap: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'driverArriving',
                arrivedStatus: true,
                statusText: 'isAlmostThere',
                collapseAccordion: true,
            },
            delivered: {
                status: 'dasher_dropped_off',
                showDeliveredScreen: true,
                showAddFav: true,
            },
            cancel: {
                status: 'delivery_cancelled',
                showCancelledScreen: true,
                showOrderDetails: true,
            },
        },
        deliveryOrderStatusKeyApi: riderStatus,
        updateStoreDataFromBasket: true,
        basic: {
            allowedLanguages: [{ key: 'en-AU', value: 'English', short_value: 'ENG' }],
            defaultLanguage: { key: 'en-AU', value: 'Eng' },
            allowedChannels: ['web', 'app'],
            allowedServices: ['pickup', 'delivery'],
            isCheckinAllowed: false,
        },
        errorScreenBtnClose: 'Take Me Home',
        reOrderCardDateFormat: 'dddd, MMM DD',
        activeOrderDateFormat: 'dddd DD/MM/YY',
        countryCode: [COUNTRY_CODES.AU],
        maxItemCountPerLineItem: 0,
        paymentStatusMaxCallCount: 5,
        analyticsProviders: {
            web: [GTM],
            mobile: [MParticle, FullStory],
        },
        defaultAnalyticsProviders: {
            web: [GTM],
            mobile: [MParticle, FullStory],
        },
        analyticsUniqueIdentifier: EMAIL,
        deepLinkProviders: {
            mobile: [MParticleBranchKit],
        },
        deliveryAddressMapping: {
            pinCode: 'postal_code',
            country: 'country',
            state: 'administrative_area_level_1',
            city: 'locality|administrative_area_level_2',
            addressLine0: 'subpremise',
            addressLine1Prepend: 'street_number',
            addressLine1: 'route+street_address+neighborhood+sublocality_level_1+sublocality_level_2+sublocality_level_3',
            addressLine1Alt: 'sublocality+administrative_area_level_2',
            addressLine2: 'locality',
        },
        storeSearch: {
            isPolygonRequired: false,
            maxDriveTimeMins: 12,
            distanceMetrics: 'km',
            maxDeliveryDistanceMtrs: 6000,
            maxPickupDistanceMtrs: 15000,
            maxCateringDistanceMtrs: 30000,
            geohashprecision: 4,
            boundingBoxSizeMeters: 10000,
            boundingBoxSizeDivider: 500,
            numOfStoresToShow: 10,
            numOfStoresToShowDelivery: 7,
            showScheduleOrder: false,
            calculateDistance: 1000,
            shouldCallGoogleDistanceApi: false,
        },
        savedAddressPage: {
            shouldCheckDisposition: false,
        },
        showFootercopyrightNavLinks: true,
        componentOptions: {
            ScheduledDeliveryComponent: {
                allowScheduleOrder: true,
            },
            analyticsUtils: {
                loginMethodCheck: true,
            },
            appreviewPrompt: {
                showAppReviewPrompt: true,
            },
            coupons: {
                noOfCoupopnAllowed: 1,
                showCouponCopied: true,
                couponCopiedMessage: 'Coupon Copied',
            },
            storeSelection: {
                signInLink: true,
                useMyLocation: true,
                placesSearchInput: true,
            },
            routes: {
                Home: {
                    reactnavigation: 'name',
                    reactrouter: 'path',
                    Options: {
                        showicon: true,
                        hide: true,
                    },
                    offersAndDeals: {
                        showViewDetailsButton: true,
                        showRedeemButton: true,
                    },
                    crmSignUpEnabled: false,
                },
            },
            PlpProductCard: {
                allowAddToCartButton: true,
                allowClickOnProductCard: true,
                plp_AddToCartLabel: 'Add to cart',
                plp_disableScreenClick: false,
                plp_HideAddToCartButton: false,
                plpWarningMsg: true,
            },
            checkBalance: {
                emaildisbledFlag: true,
            },
            accountSettings: {
                phoneNumberMask: '[0000] [000] [000]',
                countDownTimer: 179,
                resendTime: 30,
                dobDateFormat: 'D MMMM YYYY',
                restrictedBadWordsList: RESTRICTED_BAD_WORDS,
                communicationPreferenceComponent: true,
            },
            checkout: {
                phoneNumberLength: 10,
                phoneNumberMask: PHONE_NUMBER_FORMAT,
                nameCharacterLimit: 100,
                emailCharacterLimit: 100,
                displayAddressLine2: true,
                addressCharacterLimit: 100,
                phoneNumberRegExp: /^0(4)\d{8}$/,
                displayDeliveryTipping: false,
                tippingRegex: /^(\d*\.{0,1}\d{0,2}$)/,
            },
            payment: {
                supportGPay: false,
                paymentProvider: 'braintree',
                paygateSavedCard: false,
            },
            phoneNumberConstants: {
                phoneNumberMaxLength: 12,
                phoneNumberMinLength: 10,
                phoneNumberDigit11: 11,
                phoneNumberDigit6: 6,
                phoneNumberDigit91: '91',
                phoneNumberDigit0: '0',
                phoneNumberDigitEmpty: 0,
                phoneNumberLength: 12,
                phoneNumberMask: '[000000000000]',
                phoneRegexPattern: /(\d{4})(\d{3})(\d{3})/,
                splitPattern: '$1 $2 $3',
            },
            homePage: {
                pastorderFullOrderHistoryShowBtn: false,
            },
            cartPage: {
                cartWarningMsg: true,
                validateRemoveCoupon: false,
            },
            web: {
                global: {
                    allowOtpPopup: false,
                    supportGooglePaySpot: false,
                    showBlackStripWithOrderTracker: false,
                    showNeedhelpModal: true,
                    showSecondaryHeader: false,
                    hideOrderProgressHeader: true,
                    minLengthFullName: 2,
                    maxLengthFullName: 100,
                    minLengthFirstName: 2,
                    maxLengthFirstName: 100,
                    minLengthLastName: 2,
                    maxLengthLastName: 100,
                    maxLengthEmail: 100,
                    minLengthPhoneNumber: 10,
                    maxLengthPhoneNumber: 10,
                    validateRestrictedWords: true,
                    cateringNavigationAllowed: true,
                    showPriceWithTax: true,
                    rdpPageAllowed: true,
                    privateRouteNotMemberRedirectToHome: false,
                    formattedDeliveryAddressFilterBy: 'long_name',
                    headerContentDataWithFieldsName: false,
                    enableLocalisationErrorAnalytic: true,
                    updateValueFromDispositionNew: true,
                    loadGlobalStyleClass: true,
                    pullToRefreshEnabled: false,
                    isEnablePostalCodeSignUp: true,
                    postalCodeRegex: /^(0[289][0-9]{2})|([1-7][0-9]{3})$/,
                    showVipContent: false,
                    showVipLogo: false,
                    showVipBanner: false,
                    showPostalCode: false,
                    showTermsConditions: false,
                    showTermsUsePwa: false,
                    showMandatoryItem: false,
                    showCreateAccountTitle: true,
                    showPersonalInfoAccountTitle: false,
                    showCreateAccountList: true,
                    postalCodeFormatNumber: 4,
                },
                rdpPage: {
                    rdpMap: true,
                    rdpAddress: true,
                    rdpHrsblock: true,
                    rdpAmenitiesBlk: true,
                    rdpDeliveryBlk: true,
                    rdpLickinFingerBlk: true,
                },
                pdp: {
                    productCustomizationUpsizeDropdown: false,
                    productCustomizationModifierAccordion: false,
                    productCustomizationAccordionDefaultOpen: false,
                    addToCartButton: true,
                    makeItComboButton: false,
                    showMaxBadge: true,
                    deltaPriceInAccordion: true,
                    showUpSellSection: true,
                    showCrossSellSection: false,
                    breadcrumbShowProduct: false,
                    shouldShowRecommendationCardCount: false,
                    showLegalInfo: true,
                    shouldFilterRecommendationListWithCartData: true,
                    showCartToastInPDP: false,
                    pdpToastShowDuration: 3000,
                    pdpCateringItemQuantityLimit: 999,
                    itemCountShouldAtModifierLevel: false,
                    showUpsizeDropdown: false,
                    cartErrorSingleLineMsg: false,
                },
                dispositionConfig: {
                    DELIVERY_FORM: {
                        shouldShowLocationWarning: true,
                        shouldShowDeliveryAddressLine: true,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: true,
                        shouldShowSingleStore: false,
                        shouldShowStoresList: false,
                        shouldShowSavedAddress: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: false,
                        shouldShowStoresLocation: false,
                        shouldShowMarkerWithText: false,
                        shouldIgnoreStoreList: true,
                        shouldShowKfcStoresCount: false,
                        shouldShowMapListToggleLink: false,
                        shouldShowLocationLink: true,
                        filteredTypes: ['address'],
                    },
                    PICKUP_FORM: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: ['(regions)'],
                    },
                    CATERING_FORM: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: ['(regions)'],
                    },
                    DELIVERY_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: true,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: false,
                        shouldShowSearchStore: true,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: false,
                        filteredTypes: ['address'],
                        shouldEnableConfirmButton: false,
                        ShouldShowAddDeliveryDetailsText: false,
                    },
                    PICKUP_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: ['(regions)'],
                    },
                    CATERING_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: ['(regions)'],
                    },
                    DELIVERY_SAVED: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: true,
                        shouldShowSingleStore: false,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: false,
                        shouldShowSearchStore: true,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: false,
                        filteredTypes: ['address'],
                    },
                    enableDispositionModuleOrderTypeAnalytics: true,
                    analyticsRequiredOnStoreSelection: false,
                    enableChangeStoreEventOnChange: true,
                    enableAutoSetLocation: true,
                    enableScheduleOrder: false,
                    enableClickCollectScheduleOrder: false,
                    enableOrderModeScreen: true,
                    autoSelectDeliveryStore: false,
                    disableChangeCTAForDelivery: false,
                    apartmentDetailsRegex: /^([a-zA-Z0-9/ .,]){0,40}$/,
                },
                shouldCheckDropOffAddress: true,
                cartPage: {
                    modifierDataFlag: true,
                    notificationFlagMobile: false,
                    cartExpiredUserLastActiveTimeInvalid: true,
                    showTaxLines: false,
                    enableAddGiftCardOrVoucher: false,
                    showPromoRewardsMessage: true,
                    showCarrybagCheckbox: false,
                    showAddHopeCheckbox: false,
                    allowLoggedInMember: false,
                },
                coupons: {
                    showErrorToast: false,
                    sendViewAllDealsEvent: true,
                },
                homePage: {
                    homePageUseBrowseMenu: true,
                    homePageSkipContant: false,
                },
                plp: {
                    compactMenuPlpDisclaimerReducerData: true,
                    menuItemsFilterNotHiddenProducts: true,
                    displayLargeCategoryName: true,
                    promosRewardsImage: false,
                },
                checkout: {
                    checkoutUpdatePaymentAnalytics: false,
                    enableValidateOrderAction: true,
                    validateCateringSomeOneElseContactDetails: true,
                    enableDispatchResetOrderAction: false,
                    enableBeginCheckoutAnalyticsWithUserType: true,
                    enableDoorDashRequest: true,
                    cartDataValidateionResultNullCheck: true,
                    checkoutDisplayFullName: false,
                    showSignUpBtn: false,
                    enableContinuePayment: true,
                    checkoutDispositionFirstOption: CHECKOUT_DISPOSTION_OPTIONS_INFO.LEAVE_AT_MY_DOOR,
                    checkoutDispositionDefaultOption: CHECKOUT_DISPOSTION_OPTIONS_INFO.LEAVE_AT_MY_DOOR,
                    showGiftCardOrVoucher: false,
                    showTaxExcluded: true,
                    showPromos: true,
                },
                orderPages: {
                    displayPOSOrderId: false,
                    enableDeliveryRiderStatus: true,
                    enablePickupOrderCheckedInStatus: true,
                    enableCateringOrderCheckedInStatus: true,
                    singleOrderTrackerRedirectToPaymentSuccess: false,
                    enableGlobalHeaderTrackOrder: true,
                    orderSummaryInfoPickupClosingSoonModal: true,
                    orderSummaryInfoDetailsEnableOpenAccordioncheck: true,
                    orderSummaryInfoShowToasterSaveYourOrderCompleted: false,
                    showOrderSummaryShowRefundWithBusinessDays: false,
                    showDeliveryTrackingIFramePanel: false,
                    orderSummaryShowPickupOrderCollectionMethodPanel: true,
                    displayPastOrderCardTotal: false,
                    enableKeepOrderAnalytic: true,
                    dispalyReorderAccordianItemAmount: false,
                    dispalyReorderAccordianTotalAmount: false,
                    hideCancelOrderPanel: false,
                    enableCancelOrderCallsupportModal: false,
                    pickupTrackOrderButtonLabel: 'pickupMethods',
                    enableGlobalOrderTracking: true,
                    enableRetryCountForPickupOrderTracking: false,
                    showOrderTrackingIFrame: false,
                    showDeliveryTrackingMap: true,
                    showDeliveryOrderRaiderDetailsView: true,
                    orderTrackingProgressBarCount: 7,
                    showDeliveryDriverDetails: true,
                    enableReadytoCollectLabel: true,
                    orderTrackingProgressBarScheduleOrdersCount: 2,
                    showOrderSummaryInfoDetails: false,
                    showGiftCardOrVoucherSummary: false,
                    showPromosSummary: true,
                    deliveryProgressBarAsapOrder: {
                        isDeliveryOrderPOSCompleted: 1,
                        isDeliveryOrderCreate: 2,
                        isDeliveryOrderAssign: 3,
                        isDeliveryOrderStoreArrival: 4,
                        isDeliveryOrderPickedUp: 5,
                        isDeliveryOrderOutForDelivery: 6,
                        isDeliveryOrderArrivedOrder: 7,
                    },
                    deliveryProgressBarScheduleOrders: {
                        isDeliveryOrderPOSCompleted: 1,
                        isDeliveryOrderCreate: 2,
                        isDeliveryOrderAssign: 3,
                        isDeliveryOrderStoreArrival: 4,
                        isDeliveryOrderPickedUp: 5,
                        isDeliveryOrderOutForDelivery: 6,
                        isDeliveryOrderArrivedOrder: 7,
                    },
                    hideEstimatedDeliveryTime: {
                        isDeliveryOrderCancelledOrRefund: true,
                    },
                    hideProgressBar: {},
                    getDeliveryActualPickupTime: false,
                    showOrderName: true,
                },
                payment: {
                    paymentFailedResetOrderAndBasket: false,
                    showFailedScreenOrderAccepted: true,
                    paymentCardValidateFailed: false,
                },
                accountPage: {
                    accountSettingsUpdateCustomerInfo: true,
                    termsConditionsCheckbox: false,
                    marketingCommunicationCheckbox: false,
                    showMyPaymentMethods: false,
                    addNewCreditOrDebitCard: false,
                    suggestStreetAddress: false,
                    suggestionFilter: ['address'],
                    maxSavedCardLimit: 0,
                    validateNameRegex: /^(?=.*[a-zA-Z].*)([a-zA-Z-']{1,100})$/,
                    showSavedCardCvv: false,
                },
                restaurantDetailPage: {
                    storeNumberFormat: /([0-9]{1,2})([0-9]{4})([0-9]{4}$)/,
                },
                contactKFC: {
                    isRenderIframeinContactUs: false,
                },
                scheduledDelivery: {
                    allowScheduleOrderForDispositions: ['catering'],
                },
                giftCardPageGlobal: false,
            },
            app: {
                home: {
                    callFetchMenu: false,
                    carousel: {
                        paginationColor: 'textColor',
                        backgroundColor: Strings.black,
                    },
                    welcomeBanner: {
                        showOffersLink: false,
                        showMyAccountLink: true,
                    },
                    banner: {
                        validateUserTypeAndLoc: true,
                    },
                    marketingHero: {
                        checkLocalisationAndNavigation: true,
                    },
                },
                accountSettings: {
                    isAuthOtpRequired: true,
                    showNonEditableEmailField: true,
                    showPostalCodeField: true,
                    showDOBField: true,
                    showClonelsClubMember: false,
                    showEmailPreference: true,
                    showNotificationPreference: true,
                    showSmsPreference: false,
                    isFirstNameMandatoryField: true,
                    isLastNameMandatoryField: true,
                    isPostalCodeMandtoryField: false,
                    postalCodeLength: 4,
                    postalCodeRegEx: postalCodeRegExAU,
                    formatPostalCode: false,
                    isEmailMandatoryField: true,
                    showToolTip: true,
                    isPhoneNumberValidationEnabled: true,
                    addAdditionalAttribute: true,
                    phoneNumerText: 'mobileNumberWithAstrick',
                    isEmailPrefGroupSubscription: false,
                    brazeExternalId: BrazeExternalIds.MParticleId,
                },
                global: {
                    defaultLoaderImage: 'kfcLoaderAUGif',
                    cateringNavigationAllowed: true,
                    getImageFromContent: true,
                },
                headerComponent: {
                    navigateToHome: false,
                },
                account: {
                    showContentCards: true,
                    showLogoutModal: true,
                    addressText: 'addresses',
                    getDispositionFlag: false,
                    showMyPaymentMethods: false,
                    showAddNewCardOption: false,
                    useDefaultDispositionForFavStore: false,
                    showMaxSavedCardWarningToast: false,
                    maxSavedCardLimit: 1000,
                    limitSavedCardList: false,
                },
                orderHistory: {
                    showFavouriteItemIcon: false,
                    showOrderLookup: false,
                    showPickupMethods: true,
                    showItemDescription: false,
                    showCartLineItemImage: false,
                    viewReceiptMore: false,
                    showTrackOrderCTA: false,
                },
                SignedOutComponent: {
                    showSigninSignUpBtnAlways: true,
                },
                disposition: {
                    showDispostionWithActive: false,
                    showDispositionTimeView: false,
                    showMonthAndDate: false,
                    showKeepitModal: true,
                    dispositionButtonText: 'changeStore',
                    showDispositionHeaderStickyFlag: true,
                    showDispositionHeaderFlag: false,
                    delivery: {
                        displayTime: 'asap',
                        navigateToProductNotAvailable: false,
                        shouldGetAvailableTimeslots: false,
                    },
                    activeOrderPayload_OrderMode: '',
                    showDispositionHeaderScrollableFlag: false,
                    showNonLocalization: false,
                },
                plp: {
                    checkIsProductAvailableFlag: false,
                    checkIsProductAvailableSopacFlag: true,
                    closingTimeFlag: true,
                    showStoreOfflineFlag: true,
                    isScrollDispositionFlag: true,
                    validateViewModeType: false,
                    showAddtoCartBtn: false,
                    navigateToPDP: true,
                    showFavouriteIcon: false,
                    showPromosSection: true,
                    showGenericMenu: false,
                    showLegalInfo: true,
                    getImageFromContent: true,
                    showProductDescription: false,
                    showFoodType: false,
                    showSecretMenu: true,
                    showCardBadge: false,
                    modelButtonText: 'BrowseStoreMenu',
                    showItemDetailsMultiline: false,
                },
                pdp: {
                    getImageFromContent: true,
                    showLegalInfo: true,
                    showAllergyNutrition: true,
                    showDispositionHeaderFlag: true,
                    getMealOptionsFromContent: true,
                    mealOptionsTitleTxt: 'mealOptions',
                    showHeader: true,
                },
                checkout: {
                    showCloseModalAndCloseSoonModal: false,
                    isProfileRequired: false,
                    isHOCRequired: false,
                    showSignUpBtn: true,
                    showMemberWarningMessage: true,
                    showContactInfo: false,
                    showOrderSummary: true,
                    showTimeSlot: false,
                    addressLineRequired: false,
                    paymentType: 'integrated',
                    paymentProvider: 'braintree',
                    showGuestCheckout: false,
                    showDeliveryInstructionsAlways: true,
                    passDeliveryPartnerForPickup: false,
                    passDeliveryPartnerForDeliveryFromOS: false,
                    defaultDeliveryPartner: 'doordash',
                    showFullDateTime: false,
                    showTaxExcluded: true,
                    paymentSectionTitleText: 'paymentOptions',
                    tendertypeWithoutPayment: 'coupon',
                    callOrderApiOnCheckout: false,
                },
                cart: {
                    showRecommendationsView: {
                        showCalories: true,
                        showAddToCart: false,
                        showDescription: false,
                        showQuantityModifier: true,
                        showVeg: true,
                        showFav: true,
                        plpClickDisable: false,
                    },
                    enableApplyCoupon: false,
                    showRescheduleModalForStoreOpen: false,
                    showToastAfterItemCustomized: true,
                    showToastOnUpdateQuantity: false,
                    showToastOnRemoveItem: false,
                    showRemoveItemConfirmPopUp: false,
                    showCartBottomToast: true,
                    showRemoveAllBtn: false,
                    showEditButtonFlag: false,
                    shouldShowCustomTextSopacFlag: true,
                    navigateUsingLocalization: true,
                    showRemoveButtonForPromoItem: true,
                    isDispositionHeaderSticky: true,
                    isDispositionHeaderScrollable: false,
                    checkEditMessagePopup: true,
                    showCouponAppliedToast: false,
                    showErrorToast: false,
                    checkOutTotalValue: 'subtotal',
                    deliveryFee: false,
                    showGstValue: false,
                    cartGstText: 'cartGstIncluded',
                    removeInvalidatedCoupons: false,
                    callCreateOrder: true,
                    showEditButtonIfCustomizable: false,
                    showCustomiseBtnIfModData: true,
                    showUpdateQtyForPromoItem: true,
                    showPromosUnMetConditionToast: true,
                    showProductPromoFlag: true,
                    showPromosAppliedView: true,
                    showPromosInfoContainer: true,
                    showDiscountedPriceAfterLogin: true,
                    showDiscountText: false,
                    showErrorMessageForExpiredCoupon: false,
                    showCouponRemovalButton: false,
                    navigateToPromosTab: true,
                    offersAndDealsLinkText: 'viewAllPromos',
                    // to be removed after toggle merge
                    showToastAtEditLineItemFlag: true,
                    showRemoveAllContainerFlag: false,
                    showEditButtonCustom: true,
                    shouldShowModifierGroupsFlag: true,
                    showRecommendations: false,
                    shouldValidateStoreAndItemsAvailability: false,
                    shouldCheckIfStoreOpen: true,
                    shouldCheckIfStoreClose: true,
                    shouldValidateCheckoutButtonState: true,
                    showIndulgentAddOnsCrossCell: true,
                    shouldHideCartLabel: true,
                    shouldNavigateToMenu: true,
                    showThresholdError: true,
                    showProductEditedBanner: true,
                    qualityModifierStyle: 'addRemoveViewContainerAU',
                    itemPriceTextStyle: 'itemPriceTextAU',
                    unavailableItemPriceTextStyle: 'unavailableItemPriceTextAU',
                    removeLineItemViewContainerStyle: 'removeLineItemViewContainerAU',
                    toastImageStyle: 'toastImageAU',
                    toastTextStyle: 'removeLineItemConfirmationTextAU',
                    toastImage: 'exclamationMark',
                    toastAccessibilityLabel: 'alert',
                    subAmountContainerStyle: 'subAmountContainerAU',
                    discountRemoveButton: true,
                    discountCardView: true,
                    showAsap: false,
                    showTaxLines: false,
                    // end to be removed after toggle merge ///
                },
                more: {
                    getMoreDataLinksFromHeaderSection: true,
                    showSignInButton: true,
                    loginRedirectFromMore: 'home',
                    showSubHeadersInMiddle: false,
                },
                coupons: {
                    showAddToOrderBtn: true,
                    showRedeemBtn: false,
                    showViewAllPromosLink: true,
                    showMembersOnly: true,
                    showGotItBtn: true,
                    showRedeemBtnDetails: false,
                    showReviewConditions: true,
                    showLongDescription: false,
                    showLegalInfo: true,
                    cardImagePath: 'offers/card',
                    detailsImagePath: 'offers/detail',
                    shouldCheckLocalization: true,
                    signInCardText: 'kfcSignInExclusivePromos',
                    promosTitle: 'promosRewards',
                    nonLocalizedText: 'seePromosForYou',
                    shouldGetOffersAndDeals: false,
                },
                help: {
                    contentPayload: 'Support Help',
                    headLineTitle: true,
                    showNearKfc: false,
                    subHeading: false,
                    callDesc: false,
                    mainHeading: false,
                    showNeedHelpNow: true,
                    showGetBackToMe: true,
                    showNeedToTalk: false,
                    showCallUsText: false,
                    showDropUsText: true,
                    showFqaText: true,
                    showContactText: false,
                    showFaqDes: true,
                    showcontactDesc: false,
                    showCallKfcStore: true,
                    showCallRestaurant: false,
                    showSendUsMsg: true,
                    showCallText: false,
                    showContactButtonText: false,
                    showViewAllButtonText: true,
                },
                reorder: {
                    useOrderId: false,
                    showReviewOrder: true,
                    showReOrder: false,
                    showViewDetails: false,
                },
                quickReorder: {
                    checkItemAvailabilityOnLoad: true,
                    createBasketOnLoad: false,
                    callTendersDataOnLoad: false,
                    modifierFilterForIsAdded: true,
                    unAvailableItemErrorOnTopRequired: false,
                    ItemPriceChangeErrorOnTopRequired: false,
                    whenOptionRequired: false,
                    orderTypeChangeRequired: true,
                    locationChangeRequired: true,
                    restaurantChangeRequired: true,
                    itemUmAvailableWarningRequired: true,
                    continuePaymentOption: false,
                    orderAgainButtonOption: true,
                    wantToAddModifyRequired: false,
                    expandCollapseRequired: true,
                    isPaymentTypeRequired: false,
                    showAmountView: false,
                    showModifier: false,
                },
                webView: {
                    titleJSX: 'renderTitleAu',
                },
                addToCart: {
                    shouldCheckSecretMenu: true,
                },
                modal: {
                    modalStyle: 'modalStyleAu',
                },
                minorUpdateComp: {
                    bottomSheetIcon: 'iconAu',
                },
                storeSearch: {
                    tradingHours: true,
                    showSearchFieldPlaceholder: false,
                    showStoreOpenStatus: false,
                    showOrderNowString: false,
                    enableScheduleOrderNowFunctionality: false,
                    showMoreInfoText: false,
                    showSheduledOrderCta: false,
                    showSheduledOrderCtaWhenStoreClosed: false,
                    showAdditionalView: true,
                    showOrderTypeError: true,
                    asapFlagFromOloAdminRequired: false,
                    autoSelectDeliveryStore: false,
                    showStoreListForOneStore: false,
                    isAdditionalAddressRequired: false,
                    addressErrorMessage: {
                        showIcon: true,
                        headerStyle: {
                            color: '#FF2E00',
                            fontFamily: fontFamilyRegular,
                        },
                    },
                },
                address: {
                    shouldRenderEmptyStoreList: true,
                    shouldshowflatSection: true,
                    showdeliveryOptions: true,
                    showdeliveryInstructionAddress: true,
                    nickNameOptional: true,
                    nickNameMandatory: false,
                    headerForAddress: 'savedAddressHeaderTitle',
                    textForEmptyAddress: 'emptySavedStore',
                    disablePostalCodeField: true,
                },
                popNavigatorUtil: {
                    schedulrOrderTitle: 'orderMode',
                },
                pickupTracking: {
                    showTrackingHeader: true,
                    showReceiptHeader: false,
                    showPickupMethods: true,
                    showCancelOrder: true,
                    showSaveOrderBottom: true,
                    showStorePhonenumber: false,
                    showViewDetails: false,
                    showAppRating: false,
                    orderRef: 'referenceNumber',
                    showOperatingHrs: true,
                    showStoreAddress: false,
                    showDownArrow: true,
                    cancelOrderText: 'cancelOrderButtonText',
                    callSupportToCancelOrder: false,
                    enablePickupTracking: false,
                    showEmailText: false,
                    orderStatus: riderStatus,
                },
                scheduledDelivery: {
                    showKfcStoreNameForDelivery: true,
                    showScheduleDateTime: false,
                    showAusErrorMsgComponent: true,
                    showIndErrorMsgComponent: false,
                    dateFormat: 'DD/MM/YYYY',
                    initialDisplayTime: 'asap',
                    allowScheduleOrderForDispositions: [],
                    midnightOrderSupport: false,
                    showChangeCTAForRestaurant: true,
                    showStoreCardForClosedStore: false,
                    alwaysShowAsapInTimeslot: false,
                },
                deliveryTracking: {
                    displayScheduleProgressBar: false,
                    showStorePhonenumber: false,
                    showStoreDetailsInContact: false,
                    fetchContentfulData: false,
                    trackingUrl: 'deliveryTrackingUrl',
                    showSMSviewInContact: true,
                    orderStatus: riderStatus,
                    riderName: 'riderName',
                    riderPhone: 'riderPhoneForCustomer',
                    custmerCareNumber: '1800 958 316',
                },
                favouriteMenu: {
                    showFavItems: false,
                    buttonValueText: 'orderAgain',
                    sectionHeaderValue: true,
                    itemButtonText: 'removeFavourites',
                    favIcon: false,
                    unavailableErrorText: false,
                    checkIfNameExists: true,
                    delDescriptionValue: true,
                    submitButtonText: 'cartRemove',
                    deleteAddressItemText: 'removedFromFav',
                    showToastOnFavouriteOrder: true,
                    getImageFromContent: true,
                    showReviewOrderButton: true,
                    closeImageStyle: true,
                    buttonContainerStyle: true,
                },
            },
        },
        hasMultipleItems: ['dipping-sauces'],
    },
    [COUNTRY_CODES.CA]: {
        ...tenantData,
        allowXLanguage: true,
        disableOrderTypeAnalytic: false,
        signUpEnabled: true,
        orderReadyDateTimeUpdate: true,
        autoSuggestionPickupFilter: [],
        autoSuggestionDeliveryFilter: ['address'],
        deliveryAddressFilter: ['street_address', 'subpremise', 'premise'],
        configTenantFlag: true,
        isNavigateFromPromos: false,
        isNavigateFromHome: false,
        phoneNumberValidation: false,
        dateFormat: 'DD/MM/YYYY',
        promoDateFormat: 'DD/MM/YY',
        imageCacheBurstingTag: 'gdOZD5',
        orderServDateFormat: 'YYYY-MM-DD',
        orderservTime: 'HH:mm',
        pastOrderDateformat: 'MMM D, YYYY',
        cateringMonthDateFormat: 'MMMM DD',
        cateringMinPickupTime: '06:00:00',
        postOrderDateformat: 'MMM D, YYYY',
        itemAvailabilityTime: 'HHmm',
        timeFormat: 'h:mm a',
        timeFormatcaps: 'h:mm A',
        pastOrderTimeFormat: 'h:mma',
        orderTrackingtimeFormat: 'h:mma',
        startTimeFormat: 'h:mm',
        startDateFormat: 'MMM D',
        orderServTimeFormat: 'LT',
        currencySymbol: '$',
        addHope: ITEM_ADD_HOPE,
        carryBag: ITEM_CARRY_BAG,
        currencyShortName: 'CAD',
        rupeeIcon: '\u0024',
        minusSign: '\u2212',
        currencyFormat: 'en-CA',
        colonelsClubEnabled: true,
        currencyConversionFactor: 100,
        country: 'CANADA',
        countryNameInDefaultLang: 'CANADA',
        isEnabledTodayStringLiteral: false,
        is24HoursFormatEnabled: false,
        tenantId: 'a087813cef074625a8341e162356a1e5',
        genericMenuName: 'KFCCanadaMenu-10-web-pickup-en',
        brazeEmailGroupId: '123',
        brazeSMSGroupId: '123',
        brazeSMSMarketingOption: true,
        genericCateringName: 'KFCCanadaMenu-10-web-pickup-en',
        kfcPhoneNumber: '+918042754444',
        allowRemoteWipeOut: true,
        minutes: 'minutes',
        kilojoule: '',
        storeClosesSoonTimerInMinutes: 45,
        maximumCartTotal: 100,
        displayPriceWithoutTax: false,
        isZeroDollarEnabled: false,
        itemVisibleThresholdPercent: 80,
        defaultLocation: {
            lat: -35,
            lng: 149,
        },
        deliveryProgressBar: 3,
        deliveryOrderStatus: {
            posCompleted: {
                status: sentToPosCompleted,
                progressIndex: 0,
                showdefault: true,
                showOrderDetails: true,
                showAddFav: true,
                showEsimatedArrival: false,
                showCancelOrder: true,
            },
            dasherEnroute: {
                status: 'dasher_enroute_to_pickup',
                progressIndex: 1,
                showdefault: true,
                showOrderDetails: true,
                showAddFav: true,
                showEsimatedArrival: false,
                showCancelOrder: true,
            },
            outForDelivery: {
                status: 'dasher_enroute_to_dropoff',
                progressIndex: 2,
                showdefault: true,
                showOrderDetails: true,
                showAddFav: true,
                showMapWebView: true,
                collapseAccordion: true,
            },
            unassigned: {
                status: 'unassigned',
                progressIndex: 1,
                showdefault: true,
                showOrderDetails: true,
                showAddFav: true,
                showEsimatedArrival: false,
                collapseAccordion: true,
            },
            undelivered: {
                status: 'undelivered',
                progressIndex: 2,
                showdefault: true,
                showOrderDetails: true,
                showAddFav: true,
                showMapWebView: true,
                collapseAccordion: true,
            },
            delivered: {
                status: 'dasher_dropped_off',
                showDeliveredScreen: true,
                showAddFav: true,
            },
            cancel: {
                status: 'delivery_cancelled',
                showCancelledScreen: true,
                showOrderDetails: true,
            },
        },
        deliveryOrderStatusKeyApi: riderStatus,
        updateStoreDataFromBasket: false,
        basic: {
            allowedLanguages: [
                { key: 'fr-CA', value: 'French', short_value: 'FR' },
                { key: 'en-CA', value: 'English', short_value: 'EN' },
            ],
            defaultLanguage: { key: 'en-CA', value: 'English', short_value: 'EN' },
            languagePath: {
                'en-CA': import('../../i18n/en-CA'),
            },
            allowedChannels: ['web', 'app'],
            allowedServices: ['pickup', 'delivery'],
            isCheckinAllowed: false,
        },
        errorScreenBtnClose: 'Take Me Home',
        reOrderCardDateFormat: 'dddd, MMM DD',
        activeOrderDateFormat: 'dddd DD/MM/YY',
        countryCode: [COUNTRY_CODES.CA],
        maxItemCountPerLineItem: 0,
        paymentStatusMaxCallCount: 5,
        analyticsProviders: {
            web: [GTM],
            mobile: [Braze, FullStory, GA4],
        },
        defaultAnalyticsProviders: {
            web: [GTM],
            mobile: [Braze, FullStory, GA4],
        },
        analyticsProvidersConsentMap: {
            functional: [Braze],
            performance: [GA4],
            target: [FullStory],
        },
        analyticsUniqueIdentifier: EMAIL,
        deepLinkProviders: {
            mobile: [MParticleBranchKit],
        },
        deliveryAddressMapping: {
            pinCode: 'postal_code',
            country: 'country',
            state: 'administrative_area_level_1',
            city: 'locality|administrative_area_level_2',
            addressLine0: 'subpremise',
            addressLine1Prepend: 'street_number',
            addressLine1: 'route+street_address+neighborhood+sublocality_level_1+sublocality_level_2+sublocality_level_3',
            addressLine1Alt: 'sublocality+administrative_area_level_2',
            addressLine2: 'locality',
        },
        storeSearch: {
            isPolygonRequired: false,
            maxDriveTimeMins: 12,
            distanceMetrics: 'km',
            maxDeliveryDistanceMtrs: 6000,
            maxPickupDistanceMtrs: 15000,
            maxCateringDistanceMtrs: 30000,
            geohashprecision: 4,
            boundingBoxSizeMeters: 10000,
            boundingBoxSizeDivider: 1000,
            numOfStoresToShow: 10,
            numOfStoresToShowDelivery: 3,
            showScheduleOrder: false,
            calculateDistance: 1000,
            shouldCallGoogleDistanceApi: false,
        },
        savedAddressPage: {
            shouldCheckDisposition: false,
        },
        showFootercopyrightNavLinks: true,
        componentOptions: {
            ScheduledDeliveryComponent: {
                allowScheduleOrder: true,
            },
            analyticsUtils: {
                loginMethodCheck: false,
            },
            appreviewPrompt: {
                showAppReviewPrompt: false,
            },
            coupons: {
                noOfCoupopnAllowed: 1,
                showCouponCopied: true,
                couponCopiedMessage: 'Coupon Copied',
            },
            storeSelection: {
                signInLink: true,
                useMyLocation: true,
                placesSearchInput: true,
            },
            routes: {
                Home: {
                    reactnavigation: 'name',
                    reactrouter: 'path',
                    Options: {
                        showicon: true,
                        hide: true,
                    },
                    offersAndDeals: {
                        showViewDetailsButton: true,
                        showRedeemButton: true,
                    },
                    crmSignUpEnabled: false,
                },
            },
            PlpProductCard: {
                allowAddToCartButton: true,
                allowClickOnProductCard: true,
                plp_AddToCartLabel: 'Add to cart',
                plp_disableScreenClick: false,
                plp_HideAddToCartButton: false,
                plpWarningMsg: true,
            },
            checkBalance: {
                emaildisbledFlag: true,
            },
            accountSettings: {
                phoneNumberMask: '[0000] [000] [000]',
                countDownTimer: 179,
                resendTime: 30,
                dobDateFormat: 'D MMMM YYYY',
                restrictedBadWordsList: RESTRICTED_BAD_WORDS,
                communicationPreferenceComponent: true,
            },
            checkout: {
                phoneNumberLength: 10,
                phoneNumberMask: PHONE_NUMBER_FORMAT,
                nameCharacterLimit: 100,
                emailCharacterLimit: 100,
                displayAddressLine2: true,
                addressCharacterLimit: 100,
                phoneNumberRegExp: /^\d{10}$/,
                displayDeliveryTipping: true,
                tippingRegex: /^(\d*\.{0,1}\d{0,2}$)/,
                isMandatoryCheck: true,
            },
            payment: {
                cardValidation: {
                    minCvvLength: 3,
                    maxCvvLength: 4,
                    minCardNumberLength: 13,
                    maxCardNumberLength: 16,
                    minNameLength: 1,
                    maxNameLength: 200,
                    expiryDateLength: 6,
                    expiryDateFormat: 'MM/YYYY',
                    creditCardNumberMask: '[0000]-[0000]-[0000]-[0000]',
                    expiryMask: '[00]/[0000]',
                    cvvMask: '[0000]',
                    giftCardMask: '[0000000000000000]',
                    pinNumberLength: 6,
                    pinNumberMask: '[000000]',
                },
                supportGPay: false,
                paymentProvider: 'globalpayment',
                paygateSavedCard: false,
            },
            phoneNumberConstants: {
                phoneNumberMaxLength: 12,
                phoneNumberMinLength: 10,
                phoneNumberDigit11: 11,
                phoneNumberDigit6: 6,
                phoneNumberDigit91: '91',
                phoneNumberDigit0: '0',
                phoneNumberDigitEmpty: 0,
                phoneNumberLength: 12,
                phoneNumberMask: '[000000000000]',
                phoneRegexPattern: /(\d{3})(\d{3})(\d{4})/,
                splitPattern: '$1 $2 $3',
            },
            homePage: {
                pastorderFullOrderHistoryShowBtn: false,
            },
            cartPage: {
                cartWarningMsg: true,
                validateRemoveCoupon: false,
            },
            web: {
                global: {
                    allowOtpPopup: false,
                    supportGooglePaySpot: false,
                    showBlackStripWithOrderTracker: false,
                    showNeedhelpModal: true,
                    showSecondaryHeader: false,
                    hideOrderProgressHeader: true,
                    minLengthFullName: 2,
                    maxLengthFullName: 100,
                    minLengthFirstName: 2,
                    maxLengthFirstName: 100,
                    minLengthLastName: 2,
                    maxLengthLastName: 100,
                    maxLengthEmail: 100,
                    minLengthPhoneNumber: 10,
                    maxLengthPhoneNumber: 10,
                    validateRestrictedWords: true,
                    cateringNavigationAllowed: true,
                    showPriceWithTax: true,
                    rdpPageAllowed: true,
                    privateRouteNotMemberRedirectToHome: false,
                    formattedDeliveryAddressFilterBy: 'short_name',
                    headerContentDataWithFieldsName: false,
                    enableLocalisationErrorAnalytic: true,
                    updateValueFromDispositionNew: true,
                    loadGlobalStyleClass: true,
                    pullToRefreshEnabled: false,
                    isEnablePostalCodeSignUp: true,
                    postalCodeRegex: /^(?!.*[DFIOQU])[A-VXY]\d[A-Z] ?\d[A-Z]\d$/,
                    showVipContent: true,
                    showVipLogo: true,
                    showVipBanner: true,
                    showPostalCode: true,
                    showTermsConditions: true,
                    showTermsUsePwa: true,
                    showMandatoryItem: true,
                    showCreateAccountTitle: false,
                    showPersonalInfoAccountTitle: true,
                    showCreateAccountList: false,
                    postalCodeFormatNumber: 3,
                },
                rdpPage: {
                    rdpMap: true,
                    rdpAddress: true,
                    rdpHrsblock: true,
                    rdpAmenitiesBlk: true,
                    rdpDeliveryBlk: true,
                    rdpLickinFingerBlk: true,
                },
                pdp: {
                    productCustomizationUpsizeDropdown: false,
                    productCustomizationModifierAccordion: false,
                    productCustomizationAccordionDefaultOpen: false,
                    addToCartButton: true,
                    makeItComboButton: false,
                    showMaxBadge: true,
                    deltaPriceInAccordion: true,
                    showUpSellSection: true,
                    showCrossSellSection: false,
                    breadcrumbShowProduct: false,
                    shouldShowRecommendationCardCount: false,
                    showLegalInfo: true,
                    shouldFilterRecommendationListWithCartData: true,
                    showCartToastInPDP: false,
                    pdpToastShowDuration: 3000,
                    pdpCateringItemQuantityLimit: 999,
                    itemCountShouldAtModifierLevel: false,
                    showUpsizeDropdown: false,
                    cartErrorSingleLineMsg: false,
                },
                dispositionConfig: {
                    DELIVERY_FORM: {
                        shouldShowLocationWarning: true,
                        shouldShowDeliveryAddressLine: true,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: true,
                        shouldShowSingleStore: true,
                        shouldShowStoresList: false,
                        shouldShowSavedAddress: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: false,
                        shouldShowStoresLocation: false,
                        shouldShowMarkerWithText: false,
                        shouldIgnoreStoreList: true,
                        shouldShowKfcStoresCount: false,
                        shouldShowMapListToggleLink: false,
                        shouldShowLocationLink: true,
                        filteredTypes: ['address'],
                        filterConditions: ['street_address', 'subpremise', 'premise']
                    },
                    PICKUP_FORM: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: [],
                    },
                    CATERING_FORM: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: ['(regions)'],
                    },
                    DELIVERY_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: true,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: false,
                        shouldShowSearchStore: true,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: false,
                        filteredTypes: ['address'],
                        filterConditions: ['street_address', 'subpremise', 'premise'],
                        shouldEnableConfirmButton: false,
                        ShouldShowAddDeliveryDetailsText: false,
                    },
                    PICKUP_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: [],
                    },
                    CATERING_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: ['(regions)'],
                    },
                    DELIVERY_SAVED: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: true,
                        shouldShowSingleStore: false,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: false,
                        shouldShowSearchStore: true,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: false,
                        filteredTypes: ['address'],
                        filterConditions: ['street_address', 'subpremise', 'premise']
                    },
                    enableDispositionModuleOrderTypeAnalytics: true,
                    analyticsRequiredOnStoreSelection: true,
                    enableChangeStoreEventOnChange: false,
                    enableAutoSetLocation: false,
                    enableScheduleOrder: true,
                    enableClickCollectScheduleOrder: false,
                    enableOrderModeScreen: true,
                    autoSelectDeliveryStore: false,
                    disableChangeCTAForDelivery: false,
                    apartmentDetailsRegex: /^([a-zA-Z0-9/ .,]){0,40}$/,
                },
                shouldCheckDropOffAddress: true,
                cartPage: {
                    modifierDataFlag: true,
                    notificationFlagMobile: false,
                    cartExpiredUserLastActiveTimeInvalid: true,
                    showTaxLines: true,
                    enableAddGiftCardOrVoucher: true,
                    showPromoRewardsMessage: true,
                    showCarrybagCheckbox: false,
                    showAddHopeCheckbox: false,
                    allowLoggedInMember: false,
                },
                coupons: {
                    showErrorToast: false,
                    sendViewAllDealsEvent: false,
                },
                homePage: {
                    homePageUseBrowseMenu: true,
                    homePageSkipContant: false,
                },
                plp: {
                    compactMenuPlpDisclaimerReducerData: true,
                    menuItemsFilterNotHiddenProducts: true,
                    displayLargeCategoryName: true,
                },
                checkout: {
                    checkoutUpdatePaymentAnalytics: false,
                    enableValidateOrderAction: true,
                    validateCateringSomeOneElseContactDetails: true,
                    enableDispatchResetOrderAction: false,
                    enableBeginCheckoutAnalyticsWithUserType: true,
                    enableDoorDashRequest: true,
                    cartDataValidateionResultNullCheck: true,
                    checkoutDisplayFullName: false,
                    showSignUpBtn: true,
                    enableContinuePayment: false,
                    checkoutDispositionFirstOption: CHECKOUT_DISPOSTION_OPTIONS_INFO.HAND_IT_TO_ME,
                    checkoutDispositionDefaultOption: CHECKOUT_DISPOSTION_OPTIONS_INFO.HAND_IT_TO_ME,
                    showGiftCardOrVoucher: false,
                    showTaxExcluded: true,
                    showPromos: true,
                },
                orderPages: {
                    displayPOSOrderId: false,
                    enableDeliveryRiderStatus: true,
                    enablePickupOrderCheckedInStatus: true,
                    enableCateringOrderCheckedInStatus: true,
                    singleOrderTrackerRedirectToPaymentSuccess: false,
                    enableGlobalHeaderTrackOrder: true,
                    orderSummaryInfoPickupClosingSoonModal: true,
                    orderSummaryInfoDetailsEnableOpenAccordioncheck: true,
                    orderSummaryInfoShowToasterSaveYourOrderCompleted: false,
                    showOrderSummaryShowRefundWithBusinessDays: false,
                    showDeliveryTrackingIFramePanel: false,
                    orderSummaryShowPickupOrderCollectionMethodPanel: false,
                    displayPastOrderCardTotal: false,
                    enableKeepOrderAnalytic: true,
                    dispalyReorderAccordianItemAmount: false,
                    dispalyReorderAccordianTotalAmount: false,
                    hideCancelOrderPanel: false,
                    enableCancelOrderCallsupportModal: true,
                    pickupTrackOrderButtonLabel: 'trackOrder',
                    enableGlobalOrderTracking: true,
                    enableRetryCountForPickupOrderTracking: true,
                    showOrderTrackingIFrame: true,
                    showDeliveryTrackingMap: true,
                    showDeliveryOrderRaiderDetailsView: true,
                    orderTrackingProgressBarCount: 3,
                    showDeliveryDriverDetails: false,
                    enableReadytoCollectLabel: false,
                    orderTrackingProgressBarScheduleOrdersCount: 2,
                    showOrderSummaryInfoDetails: true,
                    showGiftCardOrVoucherSummary: false,
                    showPromosSummary: true,
                    deliveryProgressBarAsapOrder: {
                        isSentPosCompletedOrder: 1,
                        isDasherEnrouteToPickup: 2,
                        isDasherEnrouteToDropOff: 3,
                        isUnassigned: 2,
                        isUndelivered: 3,
                    },
                    deliveryProgressBarScheduleOrders: {
                        isDasherEnrouteToPickup: 1,
                        isDasherEnrouteToDropOff: 2,
                        isUnassigned: 1,
                        isUndelivered: 2,
                    },
                    hideEstimatedDeliveryTime: {
                        isSentPosCompletedOrder: true,
                        isDasherEnrouteToPickup: true,
                        isUnassigned: true,
                    },
                    hideProgressBar: {
                        isSentPosCompletedOrder: true,
                    },
                    getDeliveryActualPickupTime: true,
                    showOrderName: false,
                },
                payment: {
                    paymentFailedResetOrderAndBasket: false,
                    showFailedScreenOrderAccepted: true,
                    paymentCardValidateFailed: true,
                },
                accountPage: {
                    accountSettingsUpdateCustomerInfo: true,
                    termsConditionsCheckbox: true,
                    marketingCommunicationCheckbox: true,
                    showMyPaymentMethods: true,
                    suggestStreetAddress: true,
                    filteredTypes: ['address'],
                    filterConditions: ['street_address', 'subpremise', 'premise'],
                    addNewCreditOrDebitCard: true,
                    maxSavedCardLimit: 5,
                    validateNameRegex: /^(?=.*[a-zA-Z].*)([a-zA-Z-']{1,100})$/,
                    showSavedCardCvv: true,
                },
                restaurantDetailPage: {
                    storeNumberFormat: /([0-9]{1,3})([0-9]{3})([0-9]{4}$)/,
                },
                contactKFC: {
                    isRenderIframeinContactUs: true,
                },
                scheduledDelivery: {
                    allowScheduleOrderForDispositions: ['pickup', 'delivery'],
                },
                giftCardPageGlobal: false,
            },
            app: {
                home: {
                    callFetchMenu: false,
                    carousel: {
                        paginationColor: 'textColor',
                        backgroundColor: Strings.black,
                    },
                    welcomeBanner: {
                        showOffersLink: false,
                        showMyAccountLink: true,
                    },
                    banner: {
                        validateUserTypeAndLoc: true,
                    },
                    marketingHero: {
                        checkLocalisationAndNavigation: true,
                    },
                },
                accountSettings: {
                    isAuthOtpRequired: true,
                    showNonEditableEmailField: true,
                    showPostalCodeField: true,
                    showDOBField: true,
                    showClonelsClubMember: false,
                    showEmailPreference: true,
                    showNotificationPreference: true,
                    showSmsPreference: true,
                    isFirstNameMandatoryField: true,
                    isLastNameMandatoryField: true,
                    isPostalCodeMandtoryField: true,
                    postalCodeLength: 7,
                    postalCodeRegEx: postalCodeRegexCA,
                    formatPostalCode: true,
                    isEmailMandatoryField: true,
                    showToolTip: true,
                    isPhoneNumberValidationEnabled: true,
                    addAdditionalAttribute: true,
                    phoneNumerText: 'mobileNumberWithAstrick',
                    isEmailPrefGroupSubscription: true,
                    brazeExternalId: BrazeExternalIds.CustomerId,
                },
                global: {
                    defaultLoaderImage: 'kfcLoaderAUGif',
                    cateringNavigationAllowed: true,
                    getImageFromContent: true,
                },
                headerComponent: {
                    navigateToHome: false,
                },
                account: {
                    showContentCards: true,
                    showLogoutModal: true,
                    addressText: 'addresses',
                    getDispositionFlag: false,
                    showMyPaymentMethods: true,
                    showAddNewCardOption: true,
                    useDefaultDispositionForFavStore: false,
                    showMaxSavedCardWarningToast: true,
                    maxSavedCardLimit: 5,
                    limitSavedCardList: true,
                },
                orderHistory: {
                    showFavouriteItemIcon: false,
                    showOrderLookup: false,
                    showPickupMethods: false,
                    showItemDescription: false,
                    showCartLineItemImage: false,
                    viewReceiptMore: false,
                    showTrackOrderCTA: true,
                },
                SignedOutComponent: {
                    showSigninSignUpBtnAlways: true,
                },
                disposition: {
                    showDispostionWithActive: false,
                    showDispositionTimeView: true,
                    showMonthAndDate: true,
                    showKeepitModal: true,
                    dispositionButtonText: 'changeStore',
                    showDispositionHeaderStickyFlag: true,
                    showDispositionHeaderFlag: false,
                    delivery: {
                        displayTime: 'asap',
                        navigateToProductNotAvailable: false,
                        shouldGetAvailableTimeslots: false,
                    },
                    activeOrderPayload_OrderMode: '',
                    showDispositionHeaderScrollableFlag: false,
                    showNonLocalization: false,
                },
                plp: {
                    checkIsProductAvailableFlag: false,
                    checkIsProductAvailableSopacFlag: true,
                    closingTimeFlag: true,
                    showStoreOfflineFlag: true,
                    isScrollDispositionFlag: true,
                    validateViewModeType: false,
                    showAddtoCartBtn: false,
                    navigateToPDP: true,
                    showFavouriteIcon: false,
                    showPromosSection: true,
                    showGenericMenu: false,
                    showLegalInfo: true,
                    getImageFromContent: true,
                    showProductDescription: false,
                    showFoodType: false,
                    showSecretMenu: false,
                    showCardBadge: false,
                    modelButtonText: 'BrowseStoreMenu',
                    promosRewardsImage: false,
                    showItemDetailsMultiline: true,
                },
                pdp: {
                    getImageFromContent: true,
                    showLegalInfo: true,
                    showAllergyNutrition: true,
                    showDispositionHeaderFlag: true,
                    getMealOptionsFromContent: true,
                    mealOptionsTitleTxt: 'mealOptions',
                    showHeader: true,
                },
                checkout: {
                    showCloseModalAndCloseSoonModal: true,
                    isProfileRequired: false,
                    isHOCRequired: false,
                    showSignUpBtn: true,
                    showMemberWarningMessage: true,
                    showContactInfo: false,
                    showOrderSummary: true,
                    showTimeSlot: true,
                    addressLineRequired: false,
                    paymentType: 'hosted',
                    paymentProvider: 'globalpayment',
                    showGuestCheckout: false,
                    showDeliveryInstructionsAlways: true,
                    passDeliveryPartnerForPickup: true,
                    passDeliveryPartnerForDeliveryFromOS: true,
                    defaultDeliveryPartner: '',
                    showFullDateTime: true,
                    showTaxExcluded: true,
                    paymentSectionTitleText: 'paymentSectionTitle',
                    tendertypeWithoutPayment: '',
                    callOrderApiOnCheckout: true,
                },
                cart: {
                    showRecommendationsView: {
                        showCalories: true,
                        showAddToCart: false,
                        showDescription: false,
                        showQuantityModifier: true,
                        showVeg: true,
                        showFav: true,
                        plpClickDisable: false,
                    },
                    enableApplyCoupon: true,
                    applyCoupon: {
                        discountLineAttribute: 'discountLines',
                        couponCodeAttribute: 'couponCode',
                        showCouponsInLineItem: false,
                        showCouponRemovedToast: false,
                        showCouponValAppliedMsg: false,
                        showInlineAlert: false,
                    },
                    showRescheduleModalForStoreOpen: false,
                    showToastAfterItemCustomized: true,
                    showToastOnUpdateQuantity: false,
                    showToastOnRemoveItem: false,
                    showRemoveItemConfirmPopUp: false,
                    showCartBottomToast: true,
                    showRemoveAllBtn: false,
                    showEditButtonFlag: false,
                    shouldShowCustomTextSopacFlag: true,
                    navigateUsingLocalization: true,
                    showRemoveButtonForPromoItem: true,
                    isDispositionHeaderSticky: true,
                    isDispositionHeaderScrollable: false,
                    checkEditMessagePopup: true,
                    showCouponAppliedToast: false,
                    showErrorToast: false,
                    checkOutTotalValue: 'total',
                    deliveryFee: false,
                    showGstValue: false,
                    cartGstText: 'cartGstIncluded',
                    removeInvalidatedCoupons: false,
                    callCreateOrder: true,
                    showEditButtonIfCustomizable: false,
                    showCustomiseBtnIfModData: true,
                    showUpdateQtyForPromoItem: true,
                    showPromosUnMetConditionToast: true,
                    showProductPromoFlag: true,
                    showPromosAppliedView: true,
                    showPromosInfoContainer: true,
                    showDiscountedPriceAfterLogin: true,
                    showDiscountText: false,
                    showErrorMessageForExpiredCoupon: false,
                    showCouponRemovalButton: false,
                    navigateToPromosTab: true,
                    offersAndDealsLinkText: 'viewAllPromos',
                    // to be removed after toggle merge
                    showToastAtEditLineItemFlag: true,
                    showRemoveAllContainerFlag: false,
                    showEditButtonCustom: true,
                    shouldShowModifierGroupsFlag: true,
                    showRecommendations: false,
                    shouldValidateStoreAndItemsAvailability: false,
                    shouldCheckIfStoreOpen: true,
                    shouldCheckIfStoreClose: true,
                    shouldValidateCheckoutButtonState: true,
                    showIndulgentAddOnsCrossCell: true,
                    shouldHideCartLabel: true,
                    shouldNavigateToMenu: true,
                    showThresholdError: true,
                    showProductEditedBanner: true,
                    qualityModifierStyle: 'addRemoveViewContainerAU',
                    itemPriceTextStyle: 'itemPriceTextAU',
                    unavailableItemPriceTextStyle: 'unavailableItemPriceTextAU',
                    removeLineItemViewContainerStyle: 'removeLineItemViewContainerAU',
                    toastImageStyle: 'toastImageAU',
                    toastTextStyle: 'removeLineItemConfirmationTextAU',
                    toastImage: 'exclamationMark',
                    toastAccessibilityLabel: 'alert',
                    subAmountContainerStyle: 'subAmountContainerAU',
                    discountRemoveButton: true,
                    discountCardView: true,
                    showAsap: false,
                    showTaxLines: true,
                    // end to be removed after toggle merge ///
                },
                more: {
                    getMoreDataLinksFromHeaderSection: true,
                    showSignInButton: true,
                    loginRedirectFromMore: '',
                    showSubHeadersInMiddle: true,
                },
                coupons: {
                    showAddToOrderBtn: true,
                    showRedeemBtn: false,
                    showViewAllPromosLink: true,
                    showMembersOnly: true,
                    showGotItBtn: true,
                    showRedeemBtnDetails: false,
                    showReviewConditions: true,
                    showLongDescription: false,
                    showLegalInfo: true,
                    cardImagePath: 'offers/card',
                    detailsImagePath: 'offers/detail',
                    shouldCheckLocalization: true,
                    signInCardText: 'kfcSignInExclusivePromos',
                    promosTitle: 'promosRewards',
                    nonLocalizedText: 'seePromosForYou',
                    shouldGetOffersAndDeals: false,
                },
                help: {
                    contentPayload: 'Support Help',
                    headLineTitle: true,
                    showNearKfc: false,
                    subHeading: false,
                    callDesc: false,
                    mainHeading: false,
                    showNeedHelpNow: true,
                    showGetBackToMe: true,
                    showNeedToTalk: false,
                    showCallUsText: false,
                    showDropUsText: true,
                    showFqaText: true,
                    showContactText: false,
                    showFaqDes: true,
                    showcontactDesc: false,
                    showCallKfcStore: true,
                    showCallRestaurant: false,
                    showSendUsMsg: true,
                    showCallText: false,
                    showContactButtonText: false,
                    showViewAllButtonText: true,
                },
                reorder: {
                    useOrderId: false,
                    showReviewOrder: true,
                    showReOrder: false,
                    showViewDetails: false,
                },
                quickReorder: {
                    checkItemAvailabilityOnLoad: true,
                    createBasketOnLoad: false,
                    callTendersDataOnLoad: false,
                    modifierFilterForIsAdded: true,
                    unAvailableItemErrorOnTopRequired: false,
                    ItemPriceChangeErrorOnTopRequired: false,
                    whenOptionRequired: false,
                    orderTypeChangeRequired: true,
                    locationChangeRequired: true,
                    restaurantChangeRequired: true,
                    itemUmAvailableWarningRequired: true,
                    continuePaymentOption: false,
                    orderAgainButtonOption: true,
                    wantToAddModifyRequired: false,
                    expandCollapseRequired: true,
                    isPaymentTypeRequired: false,
                    showAmountView: false,
                    showModifier: false,
                },
                webView: {
                    titleJSX: 'renderTitleAu',
                },
                addToCart: {
                    shouldCheckSecretMenu: true,
                },
                modal: {
                    modalStyle: 'modalStyleAu',
                },
                minorUpdateComp: {
                    bottomSheetIcon: 'iconAu',
                },
                storeSearch: {
                    tradingHours: true,
                    showSearchFieldPlaceholder: false,
                    showStoreOpenStatus: false,
                    showOrderNowString: true,
                    enableScheduleOrderNowFunctionality: false,
                    showMoreInfoText: false,
                    showSheduledOrderCta: true,
                    showSheduledOrderCtaWhenStoreClosed: true,
                    showAdditionalView: true,
                    showOrderTypeError: true,
                    asapFlagFromOloAdminRequired: true,
                    autoSelectDeliveryStore: false,
                    showStoreListForOneStore: true,
                    isAdditionalAddressRequired: false,
                    addressErrorMessage: {
                        showIcon: true,
                        headerStyle: {
                            color: '#FF2E00',
                            fontFamily: fontFamilyRegular,
                        },
                    },
                },
                address: {
                    shouldRenderEmptyStoreList: true,
                    shouldshowflatSection: true,
                    showdeliveryOptions: true,
                    showdeliveryInstructionAddress: true,
                    nickNameOptional: true,
                    nickNameMandatory: false,
                    headerForAddress: 'savedAddressHeaderTitle',
                    textForEmptyAddress: 'emptySavedStore',
                    disablePostalCodeField: true,
                },
                popNavigatorUtil: {
                    schedulrOrderTitle: 'orderMode',
                },
                pickupTracking: {
                    showTrackingHeader: true,
                    showReceiptHeader: true,
                    showPickupMethods: false,
                    showCancelOrder: true,
                    showSaveOrderBottom: true,
                    showStorePhonenumber: true,
                    showViewDetails: false,
                    showAppRating: false,
                    orderRef: 'referenceNumber',
                    showOperatingHrs: true,
                    showStoreAddress: false,
                    showDownArrow: true,
                    cancelOrderText: 'callSupport',
                    callSupportToCancelOrder: true,
                    enablePickupTracking: true,
                    showEmailText: false,
                    orderStatus: riderStatus,
                },
                scheduledDelivery: {
                    showKfcStoreNameForDelivery: true,
                    showScheduleDateTime: true,
                    showAusErrorMsgComponent: true,
                    showIndErrorMsgComponent: false,
                    dateFormat: 'dddd MMMM DD',
                    initialDisplayTime: 'selectPickupTime',
                    allowScheduleOrderForDispositions: ['pickup', 'delivery'],
                    midnightOrderSupport: false,
                    showChangeCTAForRestaurant: true,
                    showStoreCardForClosedStore: true,
                    alwaysShowAsapInTimeslot: false,
                },
                deliveryTracking: {
                    displayScheduleProgressBar: true,
                    showDirections: false,
                    showStorePhoneNumber: true,
                    trackingUrl: 'deliveryTrackingUrl',
                    fetchContentfulData: true,
                    showStoreDetailsInContact: false,
                    showSMSviewInContact: true,
                    orderStatus: riderStatus,
                    riderName: 'riderName',
                    riderPhone: 'riderPhoneForCustomer',
                    custmerCareNumber: '1800 958 316',
                },
                favouriteMenu: {
                    showFavItems: false,
                    buttonValueText: 'orderAgain',
                    sectionHeaderValue: true,
                    itemButtonText: 'removeFavourites',
                    favIcon: false,
                    unavailableErrorText: false,
                    checkIfNameExists: true,
                    delDescriptionValue: true,
                    submitButtonText: 'cartRemove',
                    deleteAddressItemText: 'removedFromFav',
                    showToastOnFavouriteOrder: true,
                    getImageFromContent: true,
                    showReviewOrderButton: true,
                    closeImageStyle: true,
                    buttonContainerStyle: true,
                },
            },
        },
        hasMultipleItems: ['dipping-sauces'],
    },
    [COUNTRY_CODES.ZA]: {
        ...tenantData,
        allowXLanguage: false,
        disableOrderTypeAnalytic: false,
        signUpEnabled: true,
        orderReadyDateTimeUpdate: true,
        autoSuggestionPickupFilter: [],
        autoSuggestionDeliveryFilter: [],
        configTenantFlag: true,
        isNavigateFromPromos: false,
        isNavigateFromHome: false,
        phoneNumberValidation: false,
        dateFormat: 'DD/MM/YYYY',
        promoDateFormat: 'DD/MM/YY',
        imageCacheBurstingTag: 'gdOZD5',
        orderServDateFormat: 'YYYY-MM-DD',
        orderservTime: 'HH:mm',
        pastOrderDateformat: 'MMM D, YYYY',
        cateringMonthDateFormat: 'MMMM DD',
        cateringMinPickupTime: '06:00:00',
        postOrderDateformat: 'MMM D, YYYY',
        itemAvailabilityTime: 'HHmm',
        timeFormat: 'h:mm a',
        timeFormatcaps: 'h:mm A',
        pastOrderTimeFormat: 'h:mma',
        orderTrackingtimeFormat: 'h:mma',
        startTimeFormat: 'h:mm',
        startDateFormat: 'MMM D',
        orderServTimeFormat: 'LT',
        currencySymbol: 'R',
        addHope: ITEM_ADD_HOPE,
        carryBag: ITEM_CARRY_BAG,
        currencyShortName: 'ZAR',
        rupeeIcon: '\u0024',
        minusSign: '\u2212',
        currencyFormat: 'en-ZA',
        colonelsClubEnabled: true,
        currencyConversionFactor: 100,
        country: 'SOUTH AFRICA',
        countryNameInDefaultLang: 'SOUTH AFRICA',
        isEnabledTodayStringLiteral: false,
        is24HoursFormatEnabled: false,
        tenantId: '5f89a603781e4df48d31337a6c1252a8',
        genericMenuName: 'KFCSouthAfricaMenu-KSA8888-web-pickup',
        brazeEmailGroupId: '123',
        brazeSMSGroupId: '123',
        brazeSMSMarketingOption: false,
        genericCateringName: 'KFCSouthAfricaMenu-KSA8888-web-catering',
        kfcPhoneNumber: '+918042754444',
        allowRemoteWipeOut: true,
        minutes: 'minutes',
        kilojoule: 'kJ',
        storeClosesSoonTimerInMinutes: 45,
        maximumCartTotal: 100,
        displayPriceWithoutTax: false,
        isZeroDollarEnabled: false,
        itemVisibleThresholdPercent: 80,
        defaultLocation: {
            lat: -35,
            lng: 149,
        },
        deliveryProgressBar: 5,
        deliveryOrderStatus: {
            posCompleted: {
                status: sentToPosCompleted,
                progressIndex: 0,
                showdefault: true,
                showOrderDetails: true,
                showAddFav: true,
                title: 'orderReceived',
            },
            readyToPosInjection: {
                status: Strings.readyForPosInjection,
                progressIndex: 0,
                showdefault: true,
                showOrderDetails: true,
                showAddFav: true,
                title: 'orderReceived',
            },
            created: {
                status: 'delivery_created',
                progressIndex: 1,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                showAddFav: true,
                title: 'orderGettingReady',
                findingDriver: 'findingDriver',
            },
            assigned: {
                status: 'dasher_confirmed',
                progressIndex: 1,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                assignedStatus: true,
                showAddFav: true,
                title: 'foundDeliveryDriver',
                statusText: 'hasAcceptedToDeliverYourOrder',
            },
            pickedUp: {
                status: 'dasher_confirmed_store_arrival',
                progressIndex: 2,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'makingOrderFresh',
                statusText: 'IsOnHisWayToTheRestaurant',
            },
            releaseOrder: {
                status: 'release_order_for_preparation',
                progressIndex: 2,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'makingOrderFresh',
                statusText: 'IsOnHisWayToTheRestaurant',
            },
            dasherEnroute: {
                status: 'dasher_enroute_to_pickup',
                progressIndex: 2,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'makingOrderFresh',
                statusText: 'IsOnHisWayToTheRestaurant',
            },
            outForDelivery: {
                status: 'dasher_picked_up',
                progressIndex: 3,
                displayContactCard: true,
                showMap: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'orderOnTheWay',
                statusText: 'isOnTheWay',
                collapseAccordion: true,
            },
            arrived: {
                status: 'dasher_confirmed_consumer_arrival',
                progressIndex: 4,
                displayContactCard: true,
                showMap: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'driverArriving',
                arrivedStatus: true,
                statusText: 'isAlmostThere',
                collapseAccordion: true,
            },
            delivered: {
                status: 'dasher_dropped_off',
                showDeliveredScreen: true,
                showAddFav: true,
            },
            cancel: {
                status: 'delivery_cancelled',
                showCancelledScreen: true,
                showOrderDetails: true,
            },
            unassignedCancel: {
                status: 'dasher_unassigned_delivery_cancelled',
                showCancelledScreen: true,
                showOrderDetails: true,
            },
            undeliveredCancel: {
                status: 'dasher_undelivered_delivery_cancelled',
                showCancelledScreen: true,
                showOrderDetails: true,
            },
        },
        deliveryOrderStatusKeyApi: riderStatus,
        updateStoreDataFromBasket: false,
        basic: {
            allowedLanguages: [{ key: 'en-ZA', value: 'English', short_value: 'ENG' }],
            defaultLanguage: { key: 'en-ZA', value: 'Eng' },
            allowedChannels: ['web', 'app'],
            allowedServices: ['pickup', 'delivery'],
            isCheckinAllowed: false,
        },
        errorScreenBtnClose: 'Take Me Home',
        reOrderCardDateFormat: 'dddd, MMM DD',
        activeOrderDateFormat: 'dddd DD/MM/YY',
        countryCode: [COUNTRY_CODES.ZA],
        maxItemCountPerLineItem: 0,
        paymentStatusMaxCallCount: 5,
        analyticsProviders: {
            web: [GTM],
            mobile: [MParticle, FullStory, GA4],
        },
        defaultAnalyticsProviders: {
            web: [GTM],
            mobile: [MParticle, FullStory, GA4],
        },
        analyticsProvidersConsentMap: {
            functional: [MParticle],
            performance: [GA4],
            target: [FullStory],
        },
        analyticsUniqueIdentifier: EMAIL,
        deepLinkProviders: {
            mobile: [MParticleBranchKit],
        },
        deliveryAddressMapping: {
            pinCode: 'postal_code',
            country: 'country',
            state: 'administrative_area_level_1',
            city: 'locality|administrative_area_level_2',
            addressLine0: 'subpremise',
            addressLine1Prepend: 'street_number',
            addressLine1: 'route+street_address+neighborhood+sublocality_level_1+sublocality_level_2+sublocality_level_3',
            addressLine1Alt: 'sublocality+administrative_area_level_2',
            addressLine2: 'locality',
        },
        storeSearch: {
            isPolygonRequired: false,
            maxDriveTimeMins: 12,
            distanceMetrics: 'km',
            maxDeliveryDistanceMtrs: 6000,
            maxPickupDistanceMtrs: 15000,
            maxCateringDistanceMtrs: 30000,
            geohashprecision: 4,
            boundingBoxSizeMeters: 10000,
            boundingBoxSizeDivider: 1000,
            numOfStoresToShow: 10,
            numOfStoresToShowDelivery: 3,
            showScheduleOrder: false,
            calculateDistance: 1000,
            shouldCallGoogleDistanceApi: false,
        },
        savedAddressPage: {
            shouldCheckDisposition: false,
        },
        showFootercopyrightNavLinks: true,
        componentOptions: {
            ScheduledDeliveryComponent: {
                allowScheduleOrder: true,
            },
            analyticsUtils: {
                loginMethodCheck: false,
            },
            appreviewPrompt: {
                showAppReviewPrompt: false,
            },
            coupons: {
                noOfCoupopnAllowed: 1,
                showCouponCopied: true,
                couponCopiedMessage: 'Coupon Copied',
            },
            storeSelection: {
                signInLink: true,
                useMyLocation: true,
                placesSearchInput: true,
            },
            routes: {
                Home: {
                    reactnavigation: 'name',
                    reactrouter: 'path',
                    Options: {
                        showicon: true,
                        hide: true,
                    },
                    offersAndDeals: {
                        showViewDetailsButton: true,
                        showRedeemButton: true,
                    },
                    crmSignUpEnabled: false,
                },
            },
            PlpProductCard: {
                allowAddToCartButton: true,
                allowClickOnProductCard: true,
                plp_AddToCartLabel: 'Add to cart',
                plp_disableScreenClick: false,
                plp_HideAddToCartButton: false,
                plpWarningMsg: true,
            },
            checkBalance: {
                emaildisbledFlag: true,
            },
            accountSettings: {
                phoneNumberMask: '[0000] [000] [000]',
                countDownTimer: 179,
                resendTime: 30,
                dobDateFormat: 'D MMMM YYYY',
                restrictedBadWordsList: RESTRICTED_BAD_WORDS,
                communicationPreferenceComponent: true,
            },
            checkout: {
                phoneNumberLength: 10,
                phoneNumberMask: PHONE_NUMBER_FORMAT,
                nameCharacterLimit: 100,
                emailCharacterLimit: 100,
                displayAddressLine2: true,
                addressCharacterLimit: 100,
                phoneNumberRegExp: /^[0]{1}(?!0+$)\d{9}$/,
                displayDeliveryTipping: true,
                tippingRegex: /^(\d*\,{0,1}\d{0,2}$)/,
            },
            payment: {
                supportGPay: false,
                paymentProvider: 'paygate',
                paygateSavedCard: true,
            },
            phoneNumberConstants: {
                phoneNumberMaxLength: 12,
                phoneNumberMinLength: 10,
                phoneNumberDigit11: 11,
                phoneNumberDigit6: 6,
                phoneNumberDigit91: '91',
                phoneNumberDigit0: '0',
                phoneNumberDigitEmpty: 0,
                phoneNumberLength: 12,
                phoneNumberMask: '[000000000000]',
                phoneRegexPattern: /(\d{4})(\d{3})(\d{3})/,
                splitPattern: '$1 $2 $3',
            },
            homePage: {
                pastorderFullOrderHistoryShowBtn: false,
            },
            cartPage: {
                cartWarningMsg: true,
                validateRemoveCoupon: false,
            },
            web: {
                global: {
                    allowOtpPopup: false,
                    supportGooglePaySpot: false,
                    showBlackStripWithOrderTracker: false,
                    showNeedhelpModal: true,
                    showSecondaryHeader: false,
                    hideOrderProgressHeader: true,
                    minLengthFullName: 2,
                    maxLengthFullName: 100,
                    minLengthFirstName: 2,
                    maxLengthFirstName: 100,
                    minLengthLastName: 2,
                    maxLengthLastName: 100,
                    maxLengthEmail: 100,
                    minLengthPhoneNumber: 10,
                    maxLengthPhoneNumber: 10,
                    validateRestrictedWords: true,
                    cateringNavigationAllowed: true,
                    showPriceWithTax: true,
                    rdpPageAllowed: true,
                    privateRouteNotMemberRedirectToHome: false,
                    formattedDeliveryAddressFilterBy: 'short_name',
                    headerContentDataWithFieldsName: false,
                    enableLocalisationErrorAnalytic: true,
                    updateValueFromDispositionNew: true,
                    loadGlobalStyleClass: true,
                    pullToRefreshEnabled: false,
                    isEnablePostalCodeSignUp: false,
                    postalCodeRegex: /^(0[289][0-9]{2})|([1-7][0-9]{3})$/,
                    showVipContent: false,
                    showVipLogo: false,
                    showVipBanner: false,
                    showPostalCode: false,
                    showTermsConditions: true,
                    showTermsUsePwa: true,
                    showMandatoryItem: true,
                    showCreateAccountTitle: true,
                    showPersonalInfoAccountTitle: false,
                    showCreateAccountList: true,
                    postalCodeFormatNumber: 4,
                },
                rdpPage: {
                    rdpMap: true,
                    rdpAddress: true,
                    rdpHrsblock: true,
                    rdpAmenitiesBlk: true,
                    rdpDeliveryBlk: true,
                    rdpLickinFingerBlk: true,
                },
                pdp: {
                    productCustomizationUpsizeDropdown: false,
                    productCustomizationModifierAccordion: false,
                    productCustomizationAccordionDefaultOpen: false,
                    addToCartButton: true,
                    makeItComboButton: false,
                    showMaxBadge: true,
                    deltaPriceInAccordion: true,
                    showUpSellSection: true,
                    showCrossSellSection: false,
                    breadcrumbShowProduct: false,
                    shouldShowRecommendationCardCount: false,
                    showLegalInfo: true,
                    shouldFilterRecommendationListWithCartData: true,
                    showCartToastInPDP: false,
                    pdpToastShowDuration: 3000,
                    pdpCateringItemQuantityLimit: 999,
                    itemCountShouldAtModifierLevel: true,
                    showUpsizeDropdown: false,
                    cartErrorSingleLineMsg: true,
                },
                dispositionConfig: {
                    DELIVERY_FORM: {
                        shouldShowLocationWarning: true,
                        shouldShowDeliveryAddressLine: true,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: true,
                        shouldShowSingleStore: false,
                        shouldShowStoresList: false,
                        shouldShowSavedAddress: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: false,
                        shouldShowStoresLocation: false,
                        shouldShowMarkerWithText: false,
                        shouldIgnoreStoreList: true,
                        shouldShowKfcStoresCount: false,
                        shouldShowMapListToggleLink: false,
                        shouldShowLocationLink: true,
                        filteredTypes: [],
                    },
                    PICKUP_FORM: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: [],
                    },
                    CATERING_FORM: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: [],
                    },
                    DELIVERY_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: true,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: false,
                        shouldShowSearchStore: true,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: false,
                        filteredTypes: [],
                        shouldEnableConfirmButton: true,
                        ShouldShowAddDeliveryDetailsText: true,
                    },
                    PICKUP_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: [],
                    },
                    CATERING_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: [],
                    },
                    DELIVERY_SAVED: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: true,
                        shouldShowSingleStore: false,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: false,
                        shouldShowSearchStore: true,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: false,
                        filteredTypes: [],
                    },
                    enableDispositionModuleOrderTypeAnalytics: true,
                    analyticsRequiredOnStoreSelection: false,
                    enableChangeStoreEventOnChange: true,
                    enableAutoSetLocation: false,
                    enableScheduleOrder: false,
                    enableClickCollectScheduleOrder: true,
                    enableOrderModeScreen: true,
                    autoSelectDeliveryStore: true,
                    disableChangeCTAForDelivery: true,
                    apartmentDetailsRegex: /^([a-zA-Z0-9/ .,]){0,40}$/,
                },
                shouldCheckDropOffAddress: true,
                cartPage: {
                    modifierDataFlag: true,
                    notificationFlagMobile: false,
                    cartExpiredUserLastActiveTimeInvalid: true,
                    showTaxLines: false,
                    enableAddGiftCardOrVoucher: true,
                    showPromoRewardsMessage: false,
                    showCarrybagCheckbox: false,
                    showAddHopeCheckbox: false,
                    allowLoggedInMember: false,
                },
                coupons: {
                    showErrorToast: false,
                    sendViewAllDealsEvent: false,
                },
                homePage: {
                    homePageUseBrowseMenu: true,
                    homePageSkipContant: false,
                },
                plp: {
                    compactMenuPlpDisclaimerReducerData: true,
                    menuItemsFilterNotHiddenProducts: true,
                    displayLargeCategoryName: true,
                    promosRewardsImage: false,
                },
                checkout: {
                    checkoutUpdatePaymentAnalytics: false,
                    enableValidateOrderAction: true,
                    validateCateringSomeOneElseContactDetails: true,
                    enableDispatchResetOrderAction: false,
                    enableBeginCheckoutAnalyticsWithUserType: true,
                    enableDoorDashRequest: true,
                    cartDataValidateionResultNullCheck: true,
                    checkoutDisplayFullName: false,
                    showSignUpBtn: false,
                    enableContinuePayment: false,
                    checkoutDispositionFirstOption: CHECKOUT_DISPOSTION_OPTIONS_INFO.HAND_IT_TO_ME,
                    checkoutDispositionDefaultOption: CHECKOUT_DISPOSTION_OPTIONS_INFO.HAND_IT_TO_ME,
                    showGiftCardOrVoucher: true,
                    showTaxExcluded: false,
                    showPromos: false,
                },
                orderPages: {
                    displayPOSOrderId: false,
                    enableDeliveryRiderStatus: true,
                    enablePickupOrderCheckedInStatus: true,
                    enableCateringOrderCheckedInStatus: true,
                    singleOrderTrackerRedirectToPaymentSuccess: false,
                    enableGlobalHeaderTrackOrder: true,
                    orderSummaryInfoPickupClosingSoonModal: true,
                    orderSummaryInfoDetailsEnableOpenAccordioncheck: true,
                    orderSummaryInfoShowToasterSaveYourOrderCompleted: false,
                    showOrderSummaryShowRefundWithBusinessDays: false,
                    showDeliveryTrackingIFramePanel: false,
                    orderSummaryShowPickupOrderCollectionMethodPanel: false,
                    displayPastOrderCardTotal: false,
                    enableKeepOrderAnalytic: true,
                    dispalyReorderAccordianItemAmount: false,
                    dispalyReorderAccordianTotalAmount: false,
                    hideCancelOrderPanel: true,
                    enableCancelOrderCallsupportModal: false,
                    pickupTrackOrderButtonLabel: 'trackOrder',
                    enableGlobalOrderTracking: true,
                    enableRetryCountForPickupOrderTracking: true,
                    showOrderTrackingIFrame: true,
                    showDeliveryTrackingMap: true,
                    showDeliveryOrderRaiderDetailsView: true,
                    orderTrackingProgressBarCount: 7,
                    showDeliveryDriverDetails: true,
                    enableReadytoCollectLabel: false,
                    orderTrackingProgressBarScheduleOrdersCount: 2,
                    showOrderSummaryInfoDetails: true,
                    showGiftCardOrVoucherSummary: true,
                    showPromosSummary: false,
                    deliveryProgressBarAsapOrder: {
                        isDeliveryOrderPOSCompleted: 1,
                        isDeliveryOrderCreate: 2,
                        isDeliveryOrderAssign: 3,
                        isDeliveryOrderStoreArrival: 4,
                        isDeliveryOrderPickedUp: 5,
                        isDeliveryOrderOutForDelivery: 6,
                        isDeliveryOrderArrivedOrder: 7,
                    },
                    deliveryProgressBarScheduleOrders: {
                        isDeliveryOrderPOSCompleted: 1,
                        isDeliveryOrderCreate: 2,
                        isDeliveryOrderAssign: 3,
                        isDeliveryOrderStoreArrival: 4,
                        isDeliveryOrderPickedUp: 5,
                        isDeliveryOrderOutForDelivery: 6,
                        isDeliveryOrderArrivedOrder: 7,
                    },
                    hideEstimatedDeliveryTime: {
                        isDeliveryOrderCancelledOrRefund: true,
                    },
                    hideProgressBar: {},
                    getDeliveryActualPickupTime: false,
                    showOrderName: true,
                },
                payment: {
                    paymentFailedResetOrderAndBasket: false,
                    showFailedScreenOrderAccepted: true,
                    paymentCardValidateFailed: false,
                },
                accountPage: {
                    accountSettingsUpdateCustomerInfo: true,
                    termsConditionsCheckbox: true,
                    marketingCommunicationCheckbox: true,
                    showMyPaymentMethods: true,
                    addNewCreditOrDebitCard: false,
                    suggestStreetAddress: false,
                    suggestionFilter: ['address'],
                    maxSavedCardLimit: 0,
                    validateNameRegex: /^(?=.*[a-zA-Z].*)([a-zA-Z-']{1,100})$/,
                    showSavedCardCvv: false,
                },
                restaurantDetailPage: {
                    storeNumberFormat: /([0-9]{1,2})([0-9]{4})([0-9]{4}$)/,
                },
                contactKFC: {
                    isRenderIframeinContactUs: false,
                },
                scheduledDelivery: {
                    allowScheduleOrderForDispositions: ['pickup'],
                },
                giftCardPageGlobal: true,
            },
            app: {
                home: {
                    callFetchMenu: false,
                    carousel: {
                        paginationColor: 'textColor',
                        backgroundColor: Strings.black,
                    },
                    welcomeBanner: {
                        showOffersLink: false,
                        showMyAccountLink: true,
                    },
                    banner: {
                        validateUserTypeAndLoc: true,
                    },
                    marketingHero: {
                        checkLocalisationAndNavigation: true,
                    },
                },
                accountSettings: {
                    isAuthOtpRequired: true,
                    showNonEditableEmailField: true,
                    showPostalCodeField: true,
                    showDOBField: true,
                    showClonelsClubMember: false,
                    showEmailPreference: true,
                    showNotificationPreference: true,
                    showSmsPreference: false,
                    isFirstNameMandatoryField: true,
                    isLastNameMandatoryField: true,
                    isPostalCodeMandtoryField: true,
                    postalCodeLength: 4,
                    postalCodeRegEx: postalCodeRegexZA,
                    formatPostalCode: false,
                    isEmailMandatoryField: true,
                    showToolTip: true,
                    isPhoneNumberValidationEnabled: true,
                    addAdditionalAttribute: true,
                    phoneNumerText: 'mobileNumberWithAstrick',
                    isEmailPrefGroupSubscription: false,
                    brazeExternalId: BrazeExternalIds.CustomerId,
                },
                global: {
                    defaultLoaderImage: 'kfcLoaderAUGif',
                    cateringNavigationAllowed: true,
                    getImageFromContent: true,
                },
                headerComponent: {
                    navigateToHome: false,
                },
                account: {
                    showContentCards: true,
                    showLogoutModal: true,
                    addressText: 'addresses',
                    getDispositionFlag: false,
                    showMyPaymentMethods: true,
                    showAddNewCardOption: false,
                    useDefaultDispositionForFavStore: false,
                    showMaxSavedCardWarningToast: false,
                    maxSavedCardLimit: 1000,
                    limitSavedCardList: false,
                },
                orderHistory: {
                    showFavouriteItemIcon: false,
                    showOrderLookup: false,
                    showPickupMethods: false,
                    showItemDescription: false,
                    showCartLineItemImage: false,
                    viewReceiptMore: false,
                    showTrackOrderCTA: true,
                },
                SignedOutComponent: {
                    showSigninSignUpBtnAlways: true,
                },
                disposition: {
                    showDispostionWithActive: false,
                    showDispositionTimeView: true,
                    showMonthAndDate: true,
                    showKeepitModal: true,
                    dispositionButtonText: 'changeStore',
                    showDispositionHeaderStickyFlag: true,
                    showDispositionHeaderFlag: false,
                    delivery: {
                        displayTime: 'asap',
                        navigateToProductNotAvailable: false,
                        shouldGetAvailableTimeslots: false,
                    },
                    activeOrderPayload_OrderMode: '',
                    showDispositionHeaderScrollableFlag: false,
                    showNonLocalization: false,
                },
                plp: {
                    checkIsProductAvailableFlag: false,
                    checkIsProductAvailableSopacFlag: true,
                    closingTimeFlag: true,
                    showStoreOfflineFlag: true,
                    isScrollDispositionFlag: true,
                    validateViewModeType: false,
                    showAddtoCartBtn: false,
                    navigateToPDP: true,
                    showFavouriteIcon: false,
                    showPromosSection: true,
                    showGenericMenu: false,
                    showLegalInfo: true,
                    getImageFromContent: true,
                    showProductDescription: false,
                    showFoodType: false,
                    showSecretMenu: false,
                    showCardBadge: false,
                    modelButtonText: 'BrowseStoreMenu',
                    showItemDetailsMultiline: false,
                },
                pdp: {
                    getImageFromContent: true,
                    showLegalInfo: true,
                    showAllergyNutrition: true,
                    showDispositionHeaderFlag: true,
                    getMealOptionsFromContent: true,
                    mealOptionsTitleTxt: 'mealOptions',
                    showHeader: true,
                },
                checkout: {
                    showCloseModalAndCloseSoonModal: true,
                    isProfileRequired: false,
                    isHOCRequired: false,
                    showSignUpBtn: true,
                    showMemberWarningMessage: true,
                    showContactInfo: false,
                    showOrderSummary: true,
                    showTimeSlot: true,
                    addressLineRequired: false,
                    paymentType: 'hosted',
                    paymentProvider: 'paygate',
                    showGuestCheckout: false,
                    showDeliveryInstructionsAlways: true,
                    passDeliveryPartnerForPickup: false,
                    passDeliveryPartnerForDeliveryFromOS: false,
                    defaultDeliveryPartner: '',
                    showFullDateTime: true,
                    showTaxExcluded: false,
                    paymentSectionTitleText: 'paymentSectionTitle',
                    tendertypeWithoutPayment: 'wi-code',
                    callOrderApiOnCheckout: false,
                },
                cart: {
                    showRecommendationsView: {
                        showCalories: true,
                        showAddToCart: false,
                        showDescription: false,
                        showQuantityModifier: true,
                        showVeg: true,
                        showFav: true,
                        plpClickDisable: false,
                    },
                    enableApplyCoupon: true,
                    applyCoupon: {
                        discountLineAttribute: 'paymentDiscountLines',
                        couponCodeAttribute: 'paymentDiscountCode',
                        showCouponsInLineItem: true,
                        showCouponRemovedToast: true,
                        showCouponValAppliedMsg: true,
                        showInlineAlert: true,
                    },
                    showRescheduleModalForStoreOpen: true,
                    showToastAfterItemCustomized: true,
                    showToastOnUpdateQuantity: false,
                    showToastOnRemoveItem: false,
                    showRemoveItemConfirmPopUp: false,
                    showCartBottomToast: true,
                    showRemoveAllBtn: false,
                    showEditButtonFlag: false,
                    shouldShowCustomTextSopacFlag: true,
                    navigateUsingLocalization: true,
                    showRemoveButtonForPromoItem: true,
                    isDispositionHeaderSticky: true,
                    isDispositionHeaderScrollable: false,
                    checkEditMessagePopup: true,
                    showCouponAppliedToast: false,
                    showErrorToast: false,
                    checkOutTotalValue: 'subtotal',
                    deliveryFee: false,
                    showGstValue: false,
                    cartGstText: 'cartGstIncluded',
                    removeInvalidatedCoupons: false,
                    callCreateOrder: true,
                    showEditButtonIfCustomizable: false,
                    showCustomiseBtnIfModData: true,
                    showUpdateQtyForPromoItem: true,
                    showPromosUnMetConditionToast: true,
                    showProductPromoFlag: true,
                    showPromosAppliedView: true,
                    showPromosInfoContainer: true,
                    showDiscountedPriceAfterLogin: true,
                    showDiscountText: false,
                    showErrorMessageForExpiredCoupon: false,
                    showCouponRemovalButton: false,
                    navigateToPromosTab: true,
                    offersAndDealsLinkText: 'viewAllPromos',
                    // to be removed after toggle merge
                    showToastAtEditLineItemFlag: true,
                    showRemoveAllContainerFlag: false,
                    showEditButtonCustom: true,
                    shouldShowModifierGroupsFlag: true,
                    showRecommendations: false,
                    shouldValidateStoreAndItemsAvailability: false,
                    shouldCheckIfStoreOpen: true,
                    shouldCheckIfStoreClose: true,
                    shouldValidateCheckoutButtonState: true,
                    showIndulgentAddOnsCrossCell: true,
                    shouldHideCartLabel: true,
                    shouldNavigateToMenu: true,
                    showThresholdError: true,
                    showProductEditedBanner: true,
                    qualityModifierStyle: 'addRemoveViewContainerAU',
                    itemPriceTextStyle: 'itemPriceTextAU',
                    unavailableItemPriceTextStyle: 'unavailableItemPriceTextAU',
                    removeLineItemViewContainerStyle: 'removeLineItemViewContainerAU',
                    toastImageStyle: 'toastImageAU',
                    toastTextStyle: 'removeLineItemConfirmationTextAU',
                    toastImage: 'exclamationMark',
                    toastAccessibilityLabel: 'alert',
                    subAmountContainerStyle: 'subAmountContainerAU',
                    discountRemoveButton: true,
                    discountCardView: true,
                    showAsap: false,
                    showTaxLines: false,
                    // end to be removed after toggle merge ///
                },
                more: {
                    getMoreDataLinksFromHeaderSection: true,
                    showSignInButton: true,
                    loginRedirectFromMore: '',
                    showSubHeadersInMiddle: false,
                },
                coupons: {
                    showAddToOrderBtn: true,
                    showRedeemBtn: false,
                    showViewAllPromosLink: true,
                    showMembersOnly: true,
                    showGotItBtn: true,
                    showRedeemBtnDetails: false,
                    showReviewConditions: true,
                    showLongDescription: false,
                    showLegalInfo: true,
                    cardImagePath: 'offers/card',
                    detailsImagePath: 'offers/detail',
                    shouldCheckLocalization: true,
                    signInCardText: 'kfcSignInExclusivePromos',
                    promosTitle: 'promosRewards',
                    nonLocalizedText: 'seePromosForYou',
                    shouldGetOffersAndDeals: false,
                },
                help: {
                    contentPayload: 'Support Help',
                    headLineTitle: true,
                    showNearKfc: false,
                    subHeading: false,
                    callDesc: false,
                    mainHeading: false,
                    showNeedHelpNow: true,
                    showGetBackToMe: true,
                    showNeedToTalk: false,
                    showCallUsText: false,
                    showDropUsText: true,
                    showFqaText: true,
                    showContactText: false,
                    showFaqDes: true,
                    showcontactDesc: false,
                    showCallKfcStore: true,
                    showCallRestaurant: false,
                    showSendUsMsg: true,
                    showCallText: false,
                    showContactButtonText: false,
                    showViewAllButtonText: true,
                },
                reorder: {
                    useOrderId: false,
                    showReviewOrder: true,
                    showReOrder: false,
                    showViewDetails: false,
                },
                quickReorder: {
                    checkItemAvailabilityOnLoad: true,
                    createBasketOnLoad: false,
                    callTendersDataOnLoad: false,
                    modifierFilterForIsAdded: true,
                    unAvailableItemErrorOnTopRequired: false,
                    ItemPriceChangeErrorOnTopRequired: false,
                    whenOptionRequired: false,
                    orderTypeChangeRequired: true,
                    locationChangeRequired: true,
                    restaurantChangeRequired: true,
                    itemUmAvailableWarningRequired: true,
                    continuePaymentOption: false,
                    orderAgainButtonOption: true,
                    wantToAddModifyRequired: false,
                    expandCollapseRequired: true,
                    isPaymentTypeRequired: false,
                    showAmountView: false,
                    showModifier: false,
                },
                webView: {
                    titleJSX: 'renderTitleAu',
                },
                addToCart: {
                    shouldCheckSecretMenu: true,
                },
                modal: {
                    modalStyle: 'modalStyleAu',
                },
                minorUpdateComp: {
                    bottomSheetIcon: 'iconAu',
                },
                storeSearch: {
                    tradingHours: true,
                    showSearchFieldPlaceholder: false,
                    showStoreOpenStatus: false,
                    showOrderNowString: true,
                    enableScheduleOrderNowFunctionality: true,
                    showMoreInfoText: false,
                    showSheduledOrderCta: false,
                    showSheduledOrderCtaWhenStoreClosed: false,
                    showAdditionalView: true,
                    showOrderTypeError: true,
                    asapFlagFromOloAdminRequired: false,
                    autoSelectDeliveryStore: true,
                    showStoreListForOneStore: false,
                    isAdditionalAddressRequired: true,
                    addressErrorMessage: {
                        showIcon: false,
                        headerStyle: {
                            color: '#202124',
                            fontFamily: fontFamilyMedium,
                        },
                    },
                },
                address: {
                    shouldRenderEmptyStoreList: true,
                    shouldshowflatSection: true,
                    showdeliveryOptions: true,
                    showdeliveryInstructionAddress: true,
                    nickNameOptional: true,
                    nickNameMandatory: false,
                    headerForAddress: 'savedAddressHeaderTitle',
                    textForEmptyAddress: 'emptySavedStore',
                    disablePostalCodeField: true,
                },
                popNavigatorUtil: {
                    schedulrOrderTitle: 'orderMode',
                },
                pickupTracking: {
                    showTrackingHeader: true,
                    showReceiptHeader: true,
                    showPickupMethods: false,
                    showCancelOrder: false,
                    showSaveOrderBottom: true,
                    showStorePhonenumber: false,
                    showViewDetails: false,
                    showAppRating: false,
                    orderRef: 'referenceNumber',
                    showOperatingHrs: true,
                    showStoreAddress: false,
                    showDownArrow: true,
                    cancelOrderText: 'cancelOrderButtonText',
                    callSupportToCancelOrder: false,
                    enablePickupTracking: true,
                    showEmailText: true,
                    orderStatus: 'status',
                },
                scheduledDelivery: {
                    showKfcStoreNameForDelivery: true,
                    showScheduleDateTime: false,
                    showAusErrorMsgComponent: true,
                    showIndErrorMsgComponent: false,
                    dateFormat: 'DD/MM/YYYY',
                    initialDisplayTime: 'asap',
                    allowScheduleOrderForDispositions: ['pickup'],
                    midnightOrderSupport: false,
                    showChangeCTAForRestaurant: false,
                    showStoreCardForClosedStore: false,
                    alwaysShowAsapInTimeslot: false,
                },
                deliveryTracking: {
                    displayScheduleProgressBar: false,
                    showDirections: false,
                    showStorePhoneNumber: false,
                    fetchContentfulData: false,
                    trackingUrl: 'deliveryTrackingUrl',
                    showStoreDetailsInContact: false,
                    showSMSviewInContact: true,
                    orderStatus: riderStatus,
                    riderName: 'riderName',
                    riderPhone: 'riderPhoneForCustomer',
                    custmerCareNumber: '1800 958 316',
                },
                favouriteMenu: {
                    showFavItems: false,
                    buttonValueText: 'orderAgain',
                    sectionHeaderValue: true,
                    itemButtonText: 'removeFavourites',
                    favIcon: false,
                    unavailableErrorText: false,
                    checkIfNameExists: true,
                    delDescriptionValue: true,
                    submitButtonText: 'cartRemove',
                    deleteAddressItemText: 'removedFromFav',
                    showToastOnFavouriteOrder: true,
                    getImageFromContent: true,
                    showReviewOrderButton: true,
                    closeImageStyle: true,
                    buttonContainerStyle: true,
                },
            },
        },
        hasMultipleItems: ['dipping-sauces'],
    },
    [COUNTRY_CODES.JP]: {
        ...tenantData,
        allowXLanguage: false,
        disableOrderTypeAnalytic: false,
        signUpEnabled: true,
        orderReadyDateTimeUpdate: false,
        autoSuggestionPickupFilter: ['(regions)'],
        autoSuggestionDeliveryFilter: ['address'],
        configTenantFlag: true,
        isNavigateFromPromos: false,
        isNavigateFromHome: false,
        phoneNumberValidation: false,
        dateFormat: 'DD/MM/YYYY',
        promoDateFormat: 'DD/MM/YY',
        imageCacheBurstingTag: 'gdOZD5',
        orderServDateFormat: 'YYYY-MM-DD',
        orderservTime: 'HH:mm',
        pastOrderDateformat: 'MMM D, YYYY',
        cateringMonthDateFormat: 'MMMM DD',
        cateringMinPickupTime: '06:00:00',
        postOrderDateformat: 'MMM D, YYYY',
        itemAvailabilityTime: 'HHmm',
        timeFormat: 'h:mm a',
        timeFormatcaps: 'h:mm A',
        pastOrderTimeFormat: 'h:mma',
        orderTrackingtimeFormat: 'h:mma',
        startTimeFormat: 'h:mm',
        startDateFormat: 'MMM D',
        orderServTimeFormat: 'LT',
        currencySymbol: '¥‎',
        addHope: ITEM_ADD_HOPE,
        carryBag: ITEM_CARRY_BAG,
        currencyShortName: 'JPY',
        rupeeIcon: '\u0024',
        minusSign: '\u2212',
        currencyFormat: 'ja-JP',
        colonelsClubEnabled: true,
        currencyConversionFactor: 100,
        country: 'JAPAN',
        countryNameInDefaultLang: '日本',
        isEnabledTodayStringLiteral: true,
        is24HoursFormatEnabled: false,
        tenantId: '895d54ccf1154279af8237e95b925cfc',
        genericMenuName: 'KFCJapanMenu-4238-web-pickup',
        brazeEmailGroupId: '123',
        brazeSMSGroupId: '123',
        brazeSMSMarketingOption: false,
        genericCateringName: 'KFCJapanMenu-4238-web-pickup',
        kfcPhoneNumber: '+918042754444',
        allowRemoteWipeOut: true,
        minutes: 'minutes',
        kilojoule: 'kJ',
        storeClosesSoonTimerInMinutes: 45,
        maximumCartTotal: 100,
        displayPriceWithoutTax: false,
        isZeroDollarEnabled: false,
        itemVisibleThresholdPercent: 80,
        defaultLocation: {
            lat: -35,
            lng: 149,
        },
        deliveryProgressBar: 5,
        deliveryOrderStatus: {
            posCompleted: {
                status: sentToPosCompleted,
                progressIndex: 0,
                showdefault: true,
                showOrderDetails: true,
                showAddFav: true,
                title: 'orderReceived',
            },
            created: {
                status: 'delivery_created',
                progressIndex: 1,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                showAddFav: true,
                title: 'orderGettingReady',
                findingDriver: 'findingDriver',
            },
            assigned: {
                status: 'dasher_confirmed',
                progressIndex: 1,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                assignedStatus: true,
                showAddFav: true,
                title: 'foundDeliveryDriver',
                statusText: 'hasAcceptedToDeliverYourOrder',
            },
            pickedUp: {
                status: 'dasher_confirmed_store_arrival',
                progressIndex: 2,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'makingOrderFresh',
                statusText: 'IsOnHisWayToTheRestaurant',
            },
            releaseOrder: {
                status: 'release_order_for_preparation',
                progressIndex: 2,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'makingOrderFresh',
                statusText: 'IsOnHisWayToTheRestaurant',
            },
            dasherEnroute: {
                status: 'dasher_enroute_to_pickup',
                progressIndex: 2,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'makingOrderFresh',
                statusText: 'IsOnHisWayToTheRestaurant',
            },
            outForDelivery: {
                status: 'dasher_picked_up',
                progressIndex: 3,
                displayContactCard: true,
                showMap: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'orderOnTheWay',
                statusText: 'isOnTheWay',
                collapseAccordion: true,
            },
            arrived: {
                status: 'dasher_confirmed_consumer_arrival',
                progressIndex: 4,
                displayContactCard: true,
                showMap: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'driverArriving',
                arrivedStatus: true,
                statusText: 'isAlmostThere',
                collapseAccordion: true,
            },
            delivered: {
                status: 'dasher_dropped_off',
                showDeliveredScreen: true,
                showAddFav: true,
            },
            cancel: {
                status: 'delivery_cancelled',
                showCancelledScreen: true,
                showOrderDetails: true,
            },
        },
        deliveryOrderStatusKeyApi: riderStatus,
        updateStoreDataFromBasket: false,
        basic: {
            allowedLanguages: [{ key: 'ja-JP', value: 'Japanese', short_value: 'JPN' }],
            defaultLanguage: { key: 'ja-JP', value: 'Japanese' },
            allowedChannels: ['web', 'app'],
            allowedServices: ['pickup', 'delivery'],
            isCheckinAllowed: false,
        },
        errorScreenBtnClose: 'Take Me Home',
        reOrderCardDateFormat: 'dddd, MMM DD',
        activeOrderDateFormat: 'dddd DD/MM/YY',
        countryCode: [COUNTRY_CODES.JP],
        maxItemCountPerLineItem: 0,
        paymentStatusMaxCallCount: 5,
        analyticsProviders: {
            web: [EnhancedBraze, GTM],
            mobile: [EnhancedBraze, FullStory],
        },
        defaultAnalyticsProviders: {
            web: [EnhancedBraze, GTM],
            mobile: [EnhancedBraze, FullStory],
        },
        analyticsUniqueIdentifier: EMAIL,
        deepLinkProviders: {
            mobile: [MParticleBranchKit],
        },
        deliveryAddressMapping: {
            pinCode: 'postal_code',
            country: 'country',
            state: 'administrative_area_level_1',
            city: 'locality|administrative_area_level_2',
            addressLine0: 'subpremise',
            addressLine1Prepend: 'street_number',
            addressLine1: 'route+street_address+neighborhood+sublocality_level_1+sublocality_level_2+sublocality_level_3',
            addressLine1Alt: 'sublocality+administrative_area_level_2',
            addressLine2: 'locality',
        },
        storeSearch: {
            isPolygonRequired: false,
            maxDriveTimeMins: 12,
            distanceMetrics: 'km',
            maxDeliveryDistanceMtrs: 6000,
            maxPickupDistanceMtrs: 15000,
            maxCateringDistanceMtrs: 30000,
            geohashprecision: 4,
            boundingBoxSizeMeters: 10000,
            boundingBoxSizeDivider: 1000,
            numOfStoresToShow: 10,
            numOfStoresToShowDelivery: 3,
            showScheduleOrder: false,
            calculateDistance: 1000,
            shouldCallGoogleDistanceApi: false,
        },
        savedAddressPage: {
            shouldCheckDisposition: false,
        },
        showFootercopyrightNavLinks: true,
        componentOptions: {
            ScheduledDeliveryComponent: {
                allowScheduleOrder: true,
            },
            analyticsUtils: {
                loginMethodCheck: false,
            },
            appreviewPrompt: {
                showAppReviewPrompt: false,
            },
            coupons: {
                noOfCoupopnAllowed: 1,
                showCouponCopied: true,
                couponCopiedMessage: 'Coupon Copied',
            },
            storeSelection: {
                signInLink: true,
                useMyLocation: true,
                placesSearchInput: true,
            },
            routes: {
                Home: {
                    reactnavigation: 'name',
                    reactrouter: 'path',
                    Options: {
                        showicon: true,
                        hide: true,
                    },
                    offersAndDeals: {
                        showViewDetailsButton: true,
                        showRedeemButton: true,
                    },
                    crmSignUpEnabled: false,
                },
            },
            PlpProductCard: {
                allowAddToCartButton: true,
                allowClickOnProductCard: true,
                plp_AddToCartLabel: 'Add to cart',
                plp_disableScreenClick: false,
                plp_HideAddToCartButton: false,
                plpWarningMsg: true,
            },
            checkBalance: {
                emaildisbledFlag: true,
            },
            accountSettings: {
                phoneNumberMask: '[0000] [000] [000]',
                countDownTimer: 179,
                resendTime: 30,
                dobDateFormat: 'D MMMM YYYY',
                restrictedBadWordsList: RESTRICTED_BAD_WORDS,
                communicationPreferenceComponent: true,
            },
            checkout: {
                phoneNumberLength: 11,
                phoneNumberMask: PHONE_NUMBER_FORMAT,
                nameCharacterLimit: 100,
                emailCharacterLimit: 100,
                displayAddressLine2: true,
                addressCharacterLimit: 100,
                phoneNumberRegExp: /^[0][7-9][0]\d{8}$/,
                displayDeliveryTipping: false,
                tippingRegex: /^(\d*\.{0,1}\d{0,2}$)/,
            },
            payment: {
                supportGPay: false,
                paymentProvider: 'paygate',
                paygateSavedCard: false,
            },
            phoneNumberConstants: {
                phoneNumberMaxLength: 12,
                phoneNumberMinLength: 10,
                phoneNumberDigit11: 11,
                phoneNumberDigit6: 6,
                phoneNumberDigit91: '91',
                phoneNumberDigit0: '0',
                phoneNumberDigitEmpty: 0,
                phoneNumberLength: 12,
                phoneNumberMask: '[000000000000]',
                phoneRegexPattern: /(\d{4})(\d{3})(\d{3})/,
                splitPattern: '$1 $2 $3',
            },
            homePage: {
                pastorderFullOrderHistoryShowBtn: false,
            },
            cartPage: {
                cartWarningMsg: true,
                validateRemoveCoupon: false,
            },
            web: {
                global: {
                    allowOtpPopup: true,
                    supportGooglePaySpot: false,
                    showBlackStripWithOrderTracker: false,
                    showNeedhelpModal: true,
                    showSecondaryHeader: false,
                    hideOrderProgressHeader: true,
                    minLengthFullName: 2,
                    maxLengthFullName: 100,
                    minLengthFirstName: 2,
                    maxLengthFirstName: 100,
                    minLengthLastName: 2,
                    maxLengthLastName: 100,
                    maxLengthEmail: 100,
                    minLengthPhoneNumber: 10,
                    maxLengthPhoneNumber: 11,
                    validateRestrictedWords: true,
                    cateringNavigationAllowed: true,
                    showPriceWithTax: true,
                    rdpPageAllowed: true,
                    privateRouteNotMemberRedirectToHome: false,
                    formattedDeliveryAddressFilterBy: 'short_name',
                    headerContentDataWithFieldsName: false,
                    enableLocalisationErrorAnalytic: true,
                    updateValueFromDispositionNew: true,
                    loadGlobalStyleClass: true,
                    pullToRefreshEnabled: false,
                    isEnablePostalCodeSignUp: false,
                    postalCodeRegex: /^(0[289][0-9]{2})|([1-7][0-9]{3})$/,
                    showVipContent: false,
                    showVipLogo: false,
                    showVipBanner: false,
                    showPostalCode: false,
                    showTermsConditions: false,
                    showTermsUsePwa: false,
                    showMandatoryItem: false,
                    showCreateAccountTitle: true,
                    showPersonalInfoAccountTitle: false,
                    showCreateAccountList: true,
                    postalCodeFormatNumber: null,
                },
                rdpPage: {
                    rdpMap: true,
                    rdpAddress: true,
                    rdpHrsblock: true,
                    rdpAmenitiesBlk: true,
                    rdpDeliveryBlk: true,
                    rdpLickinFingerBlk: true,
                },
                pdp: {
                    productCustomizationUpsizeDropdown: false,
                    productCustomizationModifierAccordion: false,
                    productCustomizationAccordionDefaultOpen: false,
                    addToCartButton: true,
                    makeItComboButton: false,
                    showMaxBadge: true,
                    deltaPriceInAccordion: true,
                    showUpSellSection: true,
                    showCrossSellSection: false,
                    breadcrumbShowProduct: false,
                    shouldShowRecommendationCardCount: false,
                    showLegalInfo: true,
                    shouldFilterRecommendationListWithCartData: true,
                    showCartToastInPDP: false,
                    pdpToastShowDuration: 3000,
                    pdpCateringItemQuantityLimit: 999,
                    itemCountShouldAtModifierLevel: false,
                    showUpsizeDropdown: false,
                    cartErrorSingleLineMsg: false,
                },
                dispositionConfig: {
                    DELIVERY_FORM: {
                        shouldShowLocationWarning: true,
                        shouldShowDeliveryAddressLine: true,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: true,
                        shouldShowSingleStore: false,
                        shouldShowStoresList: false,
                        shouldShowSavedAddress: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: false,
                        shouldShowStoresLocation: false,
                        shouldShowMarkerWithText: false,
                        shouldIgnoreStoreList: true,
                        shouldShowKfcStoresCount: false,
                        shouldShowMapListToggleLink: false,
                        shouldShowLocationLink: true,
                        filteredTypes: ['address'],
                    },
                    PICKUP_FORM: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: ['(regions)'],
                    },
                    CATERING_FORM: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: ['(regions)'],
                    },
                    CHRISTMAS_ORDERING_FORM: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                    },
                    DELIVERY_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: true,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: false,
                        shouldShowSearchStore: true,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: false,
                        filteredTypes: ['address'],
                        shouldEnableConfirmButton: false,
                        ShouldShowAddDeliveryDetailsText: false,
                    },
                    PICKUP_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: ['(regions)'],
                    },
                    CATERING_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: ['(regions)'],
                    },
                    CHRISTMAS_ORDERING_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                    },
                    DELIVERY_SAVED: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: true,
                        shouldShowSingleStore: false,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: false,
                        shouldShowSearchStore: true,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: false,
                        filteredTypes: ['address'],
                    },
                    enableDispositionModuleOrderTypeAnalytics: true,
                    analyticsRequiredOnStoreSelection: false,
                    enableChangeStoreEventOnChange: false,
                    enableAutoSetLocation: false,
                    enableScheduleOrder: false,
                    enableClickCollectScheduleOrder: false,
                    enableOrderModeScreen: true,
                    autoSelectDeliveryStore: false,
                    disableChangeCTAForDelivery: false,
                    apartmentDetailsRegex: /([a-zA-Z0-9/ .,]|[\u3040-\u309f]|[\u30a0-\u30ff]|[\u2e80-\u2fd5]|[\u4e00-\u9fbf]|[\uff5f-\uff9f]|[\u3000-\u303f]){0,40}/,
                },
                shouldCheckDropOffAddress: true,
                cartPage: {
                    modifierDataFlag: true,
                    notificationFlagMobile: false,
                    cartExpiredUserLastActiveTimeInvalid: true,
                    showTaxLines: false,
                    enableAddGiftCardOrVoucher: false,
                    showPromoRewardsMessage: true,
                    showCarrybagCheckbox: false,
                    showAddHopeCheckbox: false,
                    allowLoggedInMember: false,
                },
                coupons: {
                    showErrorToast: false,
                    sendViewAllDealsEvent: true,
                },
                homePage: {
                    homePageUseBrowseMenu: true,
                    homePageSkipContant: false,
                },
                plp: {
                    compactMenuPlpDisclaimerReducerData: true,
                    menuItemsFilterNotHiddenProducts: true,
                    displayLargeCategoryName: true,
                    promosRewardsImage: false,
                },
                checkout: {
                    checkoutUpdatePaymentAnalytics: false,
                    enableValidateOrderAction: true,
                    validateCateringSomeOneElseContactDetails: true,
                    enableDispatchResetOrderAction: false,
                    enableBeginCheckoutAnalyticsWithUserType: true,
                    enableDoorDashRequest: true,
                    cartDataValidateionResultNullCheck: true,
                    checkoutDisplayFullName: false,
                    showSignUpBtn: false,
                    enableContinuePayment: false,
                    checkoutDispositionFirstOption: CHECKOUT_DISPOSTION_OPTIONS_INFO.LEAVE_AT_MY_DOOR,
                    checkoutDispositionDefaultOption: CHECKOUT_DISPOSTION_OPTIONS_INFO.LEAVE_AT_MY_DOOR,
                    showGiftCardOrVoucher: false,
                    showTaxExcluded: true,
                    showPromos: true,
                },
                orderPages: {
                    displayPOSOrderId: false,
                    enableDeliveryRiderStatus: true,
                    enablePickupOrderCheckedInStatus: true,
                    enableCateringOrderCheckedInStatus: true,
                    singleOrderTrackerRedirectToPaymentSuccess: false,
                    enableGlobalHeaderTrackOrder: true,
                    orderSummaryInfoPickupClosingSoonModal: true,
                    orderSummaryInfoDetailsEnableOpenAccordioncheck: true,
                    orderSummaryInfoShowToasterSaveYourOrderCompleted: false,
                    showOrderSummaryShowRefundWithBusinessDays: false,
                    showDeliveryTrackingIFramePanel: false,
                    orderSummaryShowPickupOrderCollectionMethodPanel: true,
                    displayPastOrderCardTotal: false,
                    enableKeepOrderAnalytic: true,
                    dispalyReorderAccordianItemAmount: false,
                    dispalyReorderAccordianTotalAmount: false,
                    hideCancelOrderPanel: false,
                    enableCancelOrderCallsupportModal: false,
                    pickupTrackOrderButtonLabel: 'pickupMethods',
                    enableGlobalOrderTracking: true,
                    enableRetryCountForPickupOrderTracking: false,
                    showOrderTrackingIFrame: false,
                    showDeliveryTrackingMap: false,
                    showDeliveryOrderRaiderDetailsView: false,
                    orderTrackingProgressBarCount: 7,
                    showDeliveryDriverDetails: true,
                    enableReadytoCollectLabel: true,
                    orderTrackingProgressBarScheduleOrdersCount: 2,
                    showOrderSummaryInfoDetails: false,
                    showGiftCardOrVoucherSummary: false,
                    showPromosSummary: true,
                    deliveryProgressBarAsapOrder: {
                        isDeliveryOrderPOSCompleted: 1,
                        isDeliveryOrderCreate: 2,
                        isDeliveryOrderAssign: 3,
                        isDeliveryOrderStoreArrival: 4,
                        isDeliveryOrderPickedUp: 5,
                        isDeliveryOrderOutForDelivery: 6,
                        isDeliveryOrderArrivedOrder: 7,
                    },
                    deliveryProgressBarScheduleOrders: {
                        isDeliveryOrderPOSCompleted: 1,
                        isDeliveryOrderCreate: 2,
                        isDeliveryOrderAssign: 3,
                        isDeliveryOrderStoreArrival: 4,
                        isDeliveryOrderPickedUp: 5,
                        isDeliveryOrderOutForDelivery: 6,
                        isDeliveryOrderArrivedOrder: 7,
                    },
                    hideEstimatedDeliveryTime: {
                        isDeliveryOrderCancelledOrRefund: true,
                    },
                    hideProgressBar: {},
                    getDeliveryActualPickupTime: false,
                    showOrderName: true,
                },
                payment: {
                    paymentFailedResetOrderAndBasket: false,
                    showFailedScreenOrderAccepted: true,
                    paymentCardValidateFailed: false,
                },
                accountPage: {
                    accountSettingsUpdateCustomerInfo: true,
                    termsConditionsCheckbox: false,
                    marketingCommunicationCheckbox: false,
                    showMyPaymentMethods: false,
                    addNewCreditOrDebitCard: false,
                    suggestStreetAddress: false,
                    suggestionFilter: ['address'],
                    maxSavedCardLimit: 0,
                    validateNameRegex: /^(?=.*[a-zA-Z\u30a0-\u30ff\uff5f-\uff9f].*)([a-zA-Z-'\u30a0-\u30ff\uff5f-\uff9f]{1,100})$/,
                    showSavedCardCvv: false,
                },
                restaurantDetailPage: {
                    storeNumberFormat: /([0-9]{1,2})([0-9]{4})([0-9]{4}$)/,
                },
                contactKFC: {
                    isRenderIframeinContactUs: false,
                },
                scheduledDelivery: {
                    allowScheduleOrderForDispositions: [],
                },
                giftCardPageGlobal: false,
            },
            app: {
                home: {
                    callFetchMenu: false,
                    carousel: {
                        paginationColor: 'textColor',
                        backgroundColor: Strings.black,
                    },
                    welcomeBanner: {
                        showOffersLink: false,
                        showMyAccountLink: true,
                    },
                    banner: {
                        validateUserTypeAndLoc: true,
                    },
                    marketingHero: {
                        checkLocalisationAndNavigation: true,
                    },
                },
                accountSettings: {
                    isAuthOtpRequired: false,
                    showNonEditableEmailField: true,
                    showPostalCodeField: true,
                    showDOBField: true,
                    showClonelsClubMember: false,
                    showEmailPreference: true,
                    showSmsPreference: false,
                    showNotificationPreference: true,
                    isFirstNameMandatoryField: true,
                    isLastNameMandatoryField: true,
                    isPostalCodeMandtoryField: false,
                    postalCodeLength: 4,
                    postalCodeRegEx: postalCodeRegExAU,
                    formatPostalCode: false,
                    isEmailMandatoryField: true,
                    showToolTip: true,
                    isPhoneNumberValidationEnabled: true,
                    addAdditionalAttribute: true,
                    phoneNumerText: 'mobileNumberWithAstrick',
                    isEmailPrefGroupSubscription: false,
                    brazeExternalId: BrazeExternalIds.CustomerId,
                },
                global: {
                    defaultLoaderImage: 'kfcLoaderAUGif',
                    cateringNavigationAllowed: true,
                    getImageFromContent: true,
                },
                headerComponent: {
                    navigateToHome: false,
                },
                account: {
                    showContentCards: true,
                    showLogoutModal: true,
                    addressText: 'addresses',
                    getDispositionFlag: false,
                    showMyPaymentMethods: false,
                    showAddNewCardOption: false,
                    useDefaultDispositionForFavStore: false,
                    showMaxSavedCardWarningToast: false,
                    maxSavedCardLimit: 1000,
                    limitSavedCardList: false,
                },
                orderHistory: {
                    showFavouriteItemIcon: false,
                    showOrderLookup: false,
                    showPickupMethods: true,
                    showItemDescription: false,
                    showCartLineItemImage: false,
                    viewReceiptMore: false,
                    showTrackOrderCTA: false,
                },
                SignedOutComponent: {
                    showSigninSignUpBtnAlways: true,
                },
                disposition: {
                    showDispostionWithActive: false,
                    showDispositionTimeView: false,
                    showMonthAndDate: false,
                    showKeepitModal: true,
                    dispositionButtonText: 'changeStore',
                    showDispositionHeaderStickyFlag: true,
                    showDispositionHeaderFlag: false,
                    delivery: {
                        displayTime: 'asap',
                        navigateToProductNotAvailable: false,
                        shouldGetAvailableTimeslots: false,
                    },
                    activeOrderPayload_OrderMode: '',
                    showDispositionHeaderScrollableFlag: false,
                    showNonLocalization: false,
                },
                plp: {
                    checkIsProductAvailableFlag: false,
                    checkIsProductAvailableSopacFlag: true,
                    closingTimeFlag: true,
                    showStoreOfflineFlag: true,
                    isScrollDispositionFlag: true,
                    validateViewModeType: false,
                    showAddtoCartBtn: false,
                    navigateToPDP: true,
                    showFavouriteIcon: false,
                    showPromosSection: true,
                    showGenericMenu: false,
                    showLegalInfo: true,
                    getImageFromContent: true,
                    showProductDescription: false,
                    showFoodType: false,
                    showSecretMenu: true,
                    showCardBadge: false,
                    modelButtonText: 'BrowseStoreMenu',
                    showItemDetailsMultiline: false,
                },
                pdp: {
                    getImageFromContent: true,
                    showLegalInfo: true,
                    showAllergyNutrition: true,
                    showDispositionHeaderFlag: true,
                    getMealOptionsFromContent: true,
                    mealOptionsTitleTxt: 'mealOptions',
                    showHeader: true,
                },
                checkout: {
                    showCloseModalAndCloseSoonModal: false,
                    isProfileRequired: false,
                    isHOCRequired: false,
                    showSignUpBtn: true,
                    showMemberWarningMessage: true,
                    showContactInfo: false,
                    showOrderSummary: true,
                    showTimeSlot: false,
                    addressLineRequired: false,
                    paymentType: 'integrated',
                    paymentProvider: 'braintree',
                    showGuestCheckout: false,
                    showDeliveryInstructionsAlways: true,
                    passDeliveryPartnerForPickup: false,
                    passDeliveryPartnerForDeliveryFromOS: false,
                    defaultDeliveryPartner: '',
                    showFullDateTime: false,
                    showTaxExcluded: true,
                    paymentSectionTitleText: 'paymentSectionTitle',
                    tendertypeWithoutPayment: '',
                    callOrderApiOnCheckout: false,
                },
                cart: {
                    showRecommendationsView: {
                        showCalories: true,
                        showAddToCart: false,
                        showDescription: false,
                        showQuantityModifier: true,
                        showVeg: true,
                        showFav: true,
                        plpClickDisable: false,
                    },
                    enableApplyCoupon: false,
                    showRescheduleModalForStoreOpen: false,
                    showToastAfterItemCustomized: true,
                    showToastOnUpdateQuantity: false,
                    showToastOnRemoveItem: false,
                    showRemoveItemConfirmPopUp: false,
                    showCartBottomToast: true,
                    showRemoveAllBtn: false,
                    showEditButtonFlag: false,
                    shouldShowCustomTextSopacFlag: true,
                    navigateUsingLocalization: true,
                    showRemoveButtonForPromoItem: true,
                    isDispositionHeaderSticky: true,
                    isDispositionHeaderScrollable: false,
                    checkEditMessagePopup: true,
                    showCouponAppliedToast: false,
                    showErrorToast: false,
                    checkOutTotalValue: 'subtotal',
                    deliveryFee: false,
                    showGstValue: false,
                    cartGstText: 'cartGstIncluded',
                    removeInvalidatedCoupons: false,
                    callCreateOrder: true,
                    showEditButtonIfCustomizable: false,
                    showCustomiseBtnIfModData: true,
                    showUpdateQtyForPromoItem: true,
                    showPromosUnMetConditionToast: true,
                    showProductPromoFlag: true,
                    showPromosAppliedView: true,
                    showPromosInfoContainer: true,
                    showDiscountedPriceAfterLogin: true,
                    showDiscountText: false,
                    showErrorMessageForExpiredCoupon: false,
                    showCouponRemovalButton: false,
                    navigateToPromosTab: true,
                    offersAndDealsLinkText: 'viewAllPromos',
                    // to be removed after toggle merge
                    showToastAtEditLineItemFlag: true,
                    showRemoveAllContainerFlag: false,
                    showEditButtonCustom: true,
                    shouldShowModifierGroupsFlag: true,
                    showRecommendations: false,
                    shouldValidateStoreAndItemsAvailability: false,
                    shouldCheckIfStoreOpen: true,
                    shouldCheckIfStoreClose: true,
                    shouldValidateCheckoutButtonState: true,
                    showIndulgentAddOnsCrossCell: true,
                    shouldHideCartLabel: true,
                    shouldNavigateToMenu: true,
                    showThresholdError: true,
                    showProductEditedBanner: true,
                    qualityModifierStyle: 'addRemoveViewContainerAU',
                    itemPriceTextStyle: 'itemPriceTextAU',
                    unavailableItemPriceTextStyle: 'unavailableItemPriceTextAU',
                    removeLineItemViewContainerStyle: 'removeLineItemViewContainerAU',
                    toastImageStyle: 'toastImageAU',
                    toastTextStyle: 'removeLineItemConfirmationTextAU',
                    toastImage: 'exclamationMark',
                    toastAccessibilityLabel: 'alert',
                    subAmountContainerStyle: 'subAmountContainerAU',
                    discountRemoveButton: true,
                    discountCardView: true,
                    showAsap: false,
                    showTaxLines: false,
                    // end to be removed after toggle merge ///
                },
                more: {
                    getMoreDataLinksFromHeaderSection: true,
                    showSignInButton: true,
                    loginRedirectFromMore: '',
                    showSubHeadersInMiddle: false,
                },
                coupons: {
                    showAddToOrderBtn: true,
                    showRedeemBtn: false,
                    showViewAllPromosLink: true,
                    showMembersOnly: true,
                    showGotItBtn: true,
                    showRedeemBtnDetails: false,
                    showReviewConditions: true,
                    showLongDescription: false,
                    showLegalInfo: true,
                    cardImagePath: 'offers/card',
                    detailsImagePath: 'offers/detail',
                    shouldCheckLocalization: true,
                    signInCardText: 'kfcSignInExclusivePromos',
                    promosTitle: 'promosRewards',
                    nonLocalizedText: 'seePromosForYou',
                    shouldGetOffersAndDeals: false,
                },
                help: {
                    contentPayload: 'Support Help',
                    headLineTitle: true,
                    showNearKfc: false,
                    subHeading: false,
                    callDesc: false,
                    mainHeading: false,
                    showNeedHelpNow: true,
                    showGetBackToMe: true,
                    showNeedToTalk: false,
                    showCallUsText: false,
                    showDropUsText: true,
                    showFqaText: true,
                    showContactText: false,
                    showFaqDes: true,
                    showcontactDesc: false,
                    showCallKfcStore: true,
                    showCallRestaurant: false,
                    showSendUsMsg: true,
                    showCallText: false,
                    showContactButtonText: false,
                    showViewAllButtonText: true,
                },
                reorder: {
                    useOrderId: false,
                    showReviewOrder: true,
                    showReOrder: false,
                    showViewDetails: false,
                },
                quickReorder: {
                    checkItemAvailabilityOnLoad: true,
                    createBasketOnLoad: false,
                    callTendersDataOnLoad: false,
                    modifierFilterForIsAdded: true,
                    unAvailableItemErrorOnTopRequired: false,
                    ItemPriceChangeErrorOnTopRequired: false,
                    whenOptionRequired: false,
                    orderTypeChangeRequired: true,
                    locationChangeRequired: true,
                    restaurantChangeRequired: true,
                    itemUmAvailableWarningRequired: true,
                    continuePaymentOption: false,
                    orderAgainButtonOption: true,
                    wantToAddModifyRequired: false,
                    expandCollapseRequired: true,
                    isPaymentTypeRequired: false,
                    showAmountView: false,
                    showModifier: false,
                },
                webView: {
                    titleJSX: 'renderTitleAu',
                },
                addToCart: {
                    shouldCheckSecretMenu: true,
                },
                modal: {
                    modalStyle: 'modalStyleAu',
                },
                minorUpdateComp: {
                    bottomSheetIcon: 'iconAu',
                },
                storeSearch: {
                    tradingHours: true,
                    showSearchFieldPlaceholder: false,
                    showStoreOpenStatus: false,
                    showOrderNowString: false,
                    enableScheduleOrderNowFunctionality: false,
                    showMoreInfoText: false,
                    showSheduledOrderCta: false,
                    showSheduledOrderCtaWhenStoreClosed: false,
                    showAdditionalView: true,
                    showOrderTypeError: true,
                    asapFlagFromOloAdminRequired: false,
                    autoSelectDeliveryStore: false,
                    showStoreListForOneStore: false,
                    isAdditionalAddressRequired: false,
                    addressErrorMessage: {
                        showIcon: true,
                        headerStyle: {
                            color: '#FF2E00',
                            fontFamily: fontFamilyRegular,
                        },
                    },
                },
                address: {
                    shouldRenderEmptyStoreList: true,
                    shouldshowflatSection: true,
                    showdeliveryOptions: true,
                    showdeliveryInstructionAddress: true,
                    nickNameOptional: true,
                    nickNameMandatory: false,
                    headerForAddress: 'savedAddressHeaderTitle',
                    textForEmptyAddress: 'emptySavedStore',
                    disablePostalCodeField: true,
                },
                popNavigatorUtil: {
                    schedulrOrderTitle: 'orderMode',
                },
                pickupTracking: {
                    showTrackingHeader: true,
                    showReceiptHeader: false,
                    showPickupMethods: true,
                    showCancelOrder: true,
                    showSaveOrderBottom: true,
                    showStorePhonenumber: false,
                    showViewDetails: false,
                    showAppRating: false,
                    orderRef: 'referenceNumber',
                    showOperatingHrs: true,
                    showStoreAddress: false,
                    showDownArrow: true,
                    cancelOrderText: 'cancelOrderButtonText',
                    callSupportToCancelOrder: false,
                    enablePickupTracking: false,
                    showEmailText: false,
                    orderStatus: riderStatus,
                },
                scheduledDelivery: {
                    showKfcStoreNameForDelivery: true,
                    showScheduleDateTime: false,
                    showAusErrorMsgComponent: true,
                    showIndErrorMsgComponent: false,
                    dateFormat: 'DD/MM/YYYY',
                    initialDisplayTime: 'asap',
                    allowScheduleOrderForDispositions: [],
                    midnightOrderSupport: false,
                    showChangeCTAForRestaurant: true,
                    showStoreCardForClosedStore: false,
                    alwaysShowAsapInTimeslot: false,
                },
                deliveryTracking: {
                    displayScheduleProgressBar: false,
                    showDirections: false,
                    showStorePhoneNumber: false,
                    fetchContentfulData: false,
                    trackingUrl: 'deliveryTrackingUrl',
                    showStoreDetailsInContact: false,
                    showSMSviewInContact: true,
                    orderStatus: riderStatus,
                    riderName: 'riderName',
                    riderPhone: 'riderPhoneForCustomer',
                    custmerCareNumber: '1800 958 316',
                },
                favouriteMenu: {
                    showFavItems: false,
                    buttonValueText: 'orderAgain',
                    sectionHeaderValue: true,
                    itemButtonText: 'removeFavourites',
                    favIcon: false,
                    unavailableErrorText: false,
                    checkIfNameExists: true,
                    delDescriptionValue: true,
                    submitButtonText: 'cartRemove',
                    deleteAddressItemText: 'removedFromFav',
                    showToastOnFavouriteOrder: true,
                    getImageFromContent: true,
                    showReviewOrderButton: true,
                    closeImageStyle: true,
                    buttonContainerStyle: true,
                },
            },
        },
        hasMultipleItems: ['dipping-sauces'],
    },
    [COUNTRY_CODES.TH]: {
        ...tenantData,
        allowXLanguage: false,
        disableOrderTypeAnalytic: false,
        signUpEnabled: true,
        orderReadyDateTimeUpdate: false,
        autoSuggestionPickupFilter: ['(regions)'],
        autoSuggestionDeliveryFilter: ['address'],
        configTenantFlag: true,
        isNavigateFromPromos: false,
        isNavigateFromHome: false,
        phoneNumberValidation: false,
        dateFormat: 'DD/MM/YYYY',
        promoDateFormat: 'DD/MM/YY',
        imageCacheBurstingTag: 'gdOZD5',
        orderServDateFormat: 'YYYY-MM-DD',
        orderservTime: 'HH:mm',
        pastOrderDateformat: 'MMM D, YYYY',
        cateringMonthDateFormat: 'MMMM DD',
        cateringMinPickupTime: '06:00:00',
        postOrderDateformat: 'MMM D, YYYY',
        itemAvailabilityTime: 'HHmm',
        timeFormat: 'h:mm a',
        timeFormatcaps: 'h:mm A',
        pastOrderTimeFormat: 'h:mma',
        orderTrackingtimeFormat: 'h:mma',
        startTimeFormat: 'h:mm',
        startDateFormat: 'MMM D',
        orderServTimeFormat: 'LT',
        currencySymbol: '฿‎',
        addHope: ITEM_ADD_HOPE,
        carryBag: ITEM_CARRY_BAG,
        currencyShortName: 'THB',
        rupeeIcon: '\u0024',
        minusSign: '\u2212',
        currencyFormat: 'en-US',
        colonelsClubEnabled: true,
        currencyConversionFactor: 100,
        country: 'THAILAND',
        countryNameInDefaultLang: 'THAILAND',
        isEnabledTodayStringLiteral: true,
        is24HoursFormatEnabled: false,
        tenantId: '59dhhptudcn7hk1ogssvsb4cujvbcnh6o',
        genericMenuName: 'KFCAustraliaMenu-677-web-pickup',
        brazeEmailGroupId: '123',
        brazeSMSGroupId: '123',
        brazeSMSMarketingOption: false,
        genericCateringName: 'KFCAustraliaMenu-677-web-catering',
        kfcPhoneNumber: '+918042754444',
        allowRemoteWipeOut: true,
        minutes: 'minutes',
        kilojoule: 'kJ',
        storeClosesSoonTimerInMinutes: 45,
        maximumCartTotal: 100,
        displayPriceWithoutTax: false,
        isZeroDollarEnabled: false,
        itemVisibleThresholdPercent: 80,
        defaultLocation: {
            lat: -35,
            lng: 149,
        },
        deliveryProgressBar: 5,
        deliveryOrderStatus: {
            posCompleted: {
                status: sentToPosCompleted,
                progressIndex: 0,
                showdefault: true,
                showOrderDetails: true,
                showAddFav: true,
                title: 'orderReceived',
            },
            created: {
                status: 'delivery_created',
                progressIndex: 1,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                showAddFav: true,
                title: 'orderGettingReady',
                findingDriver: 'findingDriver',
            },
            assigned: {
                status: 'dasher_confirmed',
                progressIndex: 1,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                assignedStatus: true,
                showAddFav: true,
                title: 'foundDeliveryDriver',
                statusText: 'hasAcceptedToDeliverYourOrder',
            },
            pickedUp: {
                status: 'dasher_confirmed_store_arrival',
                progressIndex: 2,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'makingOrderFresh',
                statusText: 'IsOnHisWayToTheRestaurant',
            },
            releaseOrder: {
                status: 'release_order_for_preparation',
                progressIndex: 2,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'makingOrderFresh',
                statusText: 'IsOnHisWayToTheRestaurant',
            },
            dasherEnroute: {
                status: 'dasher_enroute_to_pickup',
                progressIndex: 2,
                displayContactCard: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'makingOrderFresh',
                statusText: 'IsOnHisWayToTheRestaurant',
            },
            outForDelivery: {
                status: 'dasher_picked_up',
                progressIndex: 3,
                displayContactCard: true,
                showMap: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'orderOnTheWay',
                statusText: 'isOnTheWay',
                collapseAccordion: true,
            },
            arrived: {
                status: 'dasher_confirmed_consumer_arrival',
                progressIndex: 4,
                displayContactCard: true,
                showMap: true,
                showdefault: true,
                displayOTP: true,
                showOrderDetails: true,
                isDriverFound: true,
                showAddFav: true,
                title: 'driverArriving',
                arrivedStatus: true,
                statusText: 'isAlmostThere',
                collapseAccordion: true,
            },
            delivered: {
                status: 'dasher_dropped_off',
                showDeliveredScreen: true,
                showAddFav: true,
            },
            cancel: {
                status: 'delivery_cancelled',
                showCancelledScreen: true,
                showOrderDetails: true,
            },
        },
        deliveryOrderStatusKeyApi: riderStatus,
        updateStoreDataFromBasket: false,
        basic: {
            allowedLanguages: [{ key: 'en-US', value: 'English', short_value: 'ENG' }],
            defaultLanguage: { key: 'en-US', value: 'Eng' },
            allowedChannels: ['web', 'app'],
            allowedServices: ['pickup', 'delivery'],
            isCheckinAllowed: false,
        },
        errorScreenBtnClose: 'Take Me Home',
        reOrderCardDateFormat: 'dddd, MMM DD',
        activeOrderDateFormat: 'dddd DD/MM/YY',
        countryCode: [COUNTRY_CODES.TH],
        maxItemCountPerLineItem: 0,
        paymentStatusMaxCallCount: 5,
        analyticsProviders: {
            web: [GTM],
            mobile: [MParticle, FullStory],
        },
        defaultAnalyticsProviders: {
            web: [GTM],
            mobile: [MParticle, FullStory],
        },
        analyticsUniqueIdentifier: EMAIL,
        deepLinkProviders: {
            mobile: [MParticleBranchKit],
        },
        deliveryAddressMapping: {
            pinCode: 'postal_code',
            country: 'country',
            state: 'administrative_area_level_1',
            city: 'locality|administrative_area_level_2',
            addressLine0: 'subpremise',
            addressLine1Prepend: 'street_number',
            addressLine1: 'route+street_address+neighborhood+sublocality_level_1+sublocality_level_2+sublocality_level_3',
            addressLine1Alt: 'sublocality+administrative_area_level_2',
            addressLine2: 'locality',
        },
        storeSearch: {
            isPolygonRequired: false,
            maxDriveTimeMins: 12,
            distanceMetrics: 'km',
            maxDeliveryDistanceMtrs: 6000,
            maxPickupDistanceMtrs: 15000,
            maxCateringDistanceMtrs: 30000,
            geohashprecision: 4,
            boundingBoxSizeMeters: 10000,
            boundingBoxSizeDivider: 1000,
            numOfStoresToShow: 10,
            numOfStoresToShowDelivery: 3,
            showScheduleOrder: false,
            calculateDistance: 1000,
            shouldCallGoogleDistanceApi: false,
        },
        savedAddressPage: {
            shouldCheckDisposition: false,
        },
        showFootercopyrightNavLinks: true,
        componentOptions: {
            ScheduledDeliveryComponent: {
                allowScheduleOrder: true,
            },
            analyticsUtils: {
                loginMethodCheck: false,
            },
            appreviewPrompt: {
                showAppReviewPrompt: false,
            },
            coupons: {
                noOfCoupopnAllowed: 1,
                showCouponCopied: true,
                couponCopiedMessage: 'Coupon Copied',
            },
            storeSelection: {
                signInLink: true,
                useMyLocation: true,
                placesSearchInput: true,
            },
            routes: {
                Home: {
                    reactnavigation: 'name',
                    reactrouter: 'path',
                    Options: {
                        showicon: true,
                        hide: true,
                    },
                    offersAndDeals: {
                        showViewDetailsButton: true,
                        showRedeemButton: true,
                    },
                    crmSignUpEnabled: false,
                },
            },
            PlpProductCard: {
                allowAddToCartButton: true,
                allowClickOnProductCard: true,
                plp_AddToCartLabel: 'Add to cart',
                plp_disableScreenClick: false,
                plp_HideAddToCartButton: false,
                plpWarningMsg: true,
            },
            checkBalance: {
                emaildisbledFlag: true,
            },
            accountSettings: {
                phoneNumberMask: '[0000] [000] [000]',
                countDownTimer: 179,
                resendTime: 30,
                dobDateFormat: 'D MMMM YYYY',
                restrictedBadWordsList: RESTRICTED_BAD_WORDS,
                termsConditionsCheckbox: false,
                marketingCommunicationCheckbox: false,
                communicationPreferenceComponent: true,
            },
            checkout: {
                phoneNumberLength: 10,
                phoneNumberMask: PHONE_NUMBER_FORMAT,
                nameCharacterLimit: 100,
                emailCharacterLimit: 100,
                displayAddressLine2: true,
                addressCharacterLimit: 100,
                phoneNumberRegExp: /^(?!00)[01]{2}(?!0+$)\d{10}$/,
                displayDeliveryTipping: false,
                tippingRegex: /^(\d*\.{0,1}\d{0,2}$)/,
            },
            payment: {
                supportGPay: false,
                paymentProvider: 'paygate',
                paygateSavedCard: false,
            },
            phoneNumberConstants: {
                phoneNumberMaxLength: 12,
                phoneNumberMinLength: 10,
                phoneNumberDigit11: 11,
                phoneNumberDigit6: 6,
                phoneNumberDigit91: '91',
                phoneNumberDigit0: '0',
                phoneNumberDigitEmpty: 0,
                phoneNumberLength: 12,
                phoneNumberMask: '[000000000000]',
                phoneRegexPattern: /(\d{4})(\d{3})(\d{3})/,
                splitPattern: '$1 $2 $3',
            },
            homePage: {
                pastorderFullOrderHistoryShowBtn: false,
            },
            cartPage: {
                cartWarningMsg: true,
                validateRemoveCoupon: false,
            },
            web: {
                global: {
                    allowOtpPopup: false,
                    supportGooglePaySpot: false,
                    showBlackStripWithOrderTracker: false,
                    showNeedhelpModal: true,
                    showSecondaryHeader: false,
                    hideOrderProgressHeader: true,
                    minLengthFullName: 2,
                    maxLengthFullName: 100,
                    minLengthFirstName: 2,
                    maxLengthFirstName: 100,
                    minLengthLastName: 2,
                    maxLengthLastName: 100,
                    maxLengthEmail: 100,
                    minLengthPhoneNumber: 10,
                    maxLengthPhoneNumber: 10,
                    validateRestrictedWords: true,
                    cateringNavigationAllowed: true,
                    showPriceWithTax: true,
                    rdpPageAllowed: true,
                    privateRouteNotMemberRedirectToHome: false,
                    formattedDeliveryAddressFilterBy: 'short_name',
                    headerContentDataWithFieldsName: false,
                    enableLocalisationErrorAnalytic: true,
                    updateValueFromDispositionNew: true,
                    loadGlobalStyleClass: true,
                    pullToRefreshEnabled: false,
                    isEnablePostalCodeSignUp: false,
                    postalCodeRegex: /^(0[289][0-9]{2})|([1-7][0-9]{3})$/,
                    showVipContent: false,
                    showVipLogo: false,
                    showVipBanner: false,
                    showPostalCode: false,
                    showTermsConditions: false,
                    showTermsUsePwa: false,
                    showMandatoryItem: false,
                    showCreateAccountTitle: false,
                    showPersonalInfoAccountTitle: false,
                    showCreateAccountList: false,
                    postalCodeFormatNumber: null,
                },
                rdpPage: {
                    rdpMap: true,
                    rdpAddress: true,
                    rdpHrsblock: true,
                    rdpAmenitiesBlk: true,
                    rdpDeliveryBlk: true,
                    rdpLickinFingerBlk: true,
                },
                pdp: {
                    productCustomizationUpsizeDropdown: false,
                    productCustomizationModifierAccordion: false,
                    productCustomizationAccordionDefaultOpen: false,
                    addToCartButton: true,
                    makeItComboButton: false,
                    showMaxBadge: true,
                    deltaPriceInAccordion: true,
                    showUpSellSection: true,
                    showCrossSellSection: false,
                    breadcrumbShowProduct: false,
                    shouldShowRecommendationCardCount: false,
                    showLegalInfo: true,
                    shouldFilterRecommendationListWithCartData: true,
                    showCartToastInPDP: false,
                    pdpToastShowDuration: 3000,
                    pdpCateringItemQuantityLimit: 999,
                    itemCountShouldAtModifierLevel: false,
                    showUpsizeDropdown: false,
                    cartErrorSingleLineMsg: false,
                },
                dispositionConfig: {
                    DELIVERY_FORM: {
                        shouldShowLocationWarning: true,
                        shouldShowDeliveryAddressLine: true,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: true,
                        shouldShowSingleStore: false,
                        shouldShowStoresList: false,
                        shouldShowSavedAddress: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: false,
                        shouldShowStoresLocation: false,
                        shouldShowMarkerWithText: false,
                        shouldIgnoreStoreList: true,
                        shouldShowKfcStoresCount: false,
                        shouldShowMapListToggleLink: false,
                        shouldShowLocationLink: true,
                        filteredTypes: ['address'],
                    },
                    PICKUP_FORM: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: ['(regions)'],
                    },
                    CATERING_FORM: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: ['(regions)'],
                    },
                    DELIVERY_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: true,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: false,
                        shouldShowSearchStore: true,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: false,
                        filteredTypes: ['address'],
                        shouldEnableConfirmButton: false,
                        ShouldShowAddDeliveryDetailsText: false,
                    },
                    PICKUP_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: ['(regions)'],
                    },
                    CATERING_STORES: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: false,
                        shouldShowSingleStore: true,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: true,
                        shouldShowSearchStore: false,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: true,
                        filteredTypes: ['(regions)'],
                    },
                    DELIVERY_SAVED: {
                        shouldShowLocationWarning: false,
                        shouldShowDeliveryAddressLine: false,
                        shouldHandleKeyPress: true,
                        shouldShowUserLocation: true,
                        shouldShowSingleStore: false,
                        shouldShowSavedAddress: false,
                        shouldShowStoresList: true,
                        shouldShowDisposition: false,
                        shouldShowSearchStore: true,
                        shouldShowStoreCardsMap: true,
                        shouldShowStoresLocation: true,
                        shouldShowMarkerWithText: true,
                        shouldIgnoreStoreList: false,
                        shouldShowKfcStoresCount: true,
                        shouldShowMapListToggleLink: true,
                        shouldShowLocationLink: false,
                        filteredTypes: ['address'],
                    },
                    enableDispositionModuleOrderTypeAnalytics: true,
                    analyticsRequiredOnStoreSelection: false,
                    enableChangeStoreEventOnChange: false,
                    enableAutoSetLocation: false,
                    enableScheduleOrder: false,
                    enableClickCollectScheduleOrder: false,
                    enableOrderModeScreen: true,
                    autoSelectDeliveryStore: false,
                    disableChangeCTAForDelivery: false,
                    apartmentDetailsRegex: /^([a-zA-Z0-9/ .,]){0,40}$/,
                },
                shouldCheckDropOffAddress: true,
                cartPage: {
                    modifierDataFlag: true,
                    notificationFlagMobile: false,
                    cartExpiredUserLastActiveTimeInvalid: true,
                    showTaxLines: false,
                    enableAddGiftCardOrVoucher: false,
                    showPromoRewardsMessage: true,
                    showCarrybagCheckbox: false,
                    showAddHopeCheckbox: false,
                    allowLoggedInMember: false,
                },
                coupons: {
                    showErrorToast: false,
                    sendViewAllDealsEvent: true,
                },
                homePage: {
                    homePageUseBrowseMenu: true,
                    homePageSkipContant: false,
                },
                plp: {
                    compactMenuPlpDisclaimerReducerData: true,
                    menuItemsFilterNotHiddenProducts: true,
                    displayLargeCategoryName: true,
                    promosRewardsImage: false,
                },
                checkout: {
                    checkoutUpdatePaymentAnalytics: false,
                    enableValidateOrderAction: true,
                    validateCateringSomeOneElseContactDetails: true,
                    enableDispatchResetOrderAction: false,
                    enableBeginCheckoutAnalyticsWithUserType: true,
                    enableDoorDashRequest: true,
                    cartDataValidateionResultNullCheck: true,
                    checkoutDisplayFullName: false,
                    showSignUpBtn: false,
                    enableContinuePayment: false,
                    checkoutDispositionFirstOption: CHECKOUT_DISPOSTION_OPTIONS_INFO.LEAVE_AT_MY_DOOR,
                    checkoutDispositionDefaultOption: CHECKOUT_DISPOSTION_OPTIONS_INFO.LEAVE_AT_MY_DOOR,
                    showGiftCardOrVoucher: false,
                    showTaxExcluded: true,
                    showPromos: true,
                },
                orderPages: {
                    displayPOSOrderId: false,
                    enableDeliveryRiderStatus: true,
                    enablePickupOrderCheckedInStatus: true,
                    enableCateringOrderCheckedInStatus: true,
                    singleOrderTrackerRedirectToPaymentSuccess: false,
                    enableGlobalHeaderTrackOrder: true,
                    orderSummaryInfoPickupClosingSoonModal: true,
                    orderSummaryInfoDetailsEnableOpenAccordioncheck: true,
                    orderSummaryInfoShowToasterSaveYourOrderCompleted: false,
                    showOrderSummaryShowRefundWithBusinessDays: false,
                    showDeliveryTrackingIFramePanel: false,
                    orderSummaryShowPickupOrderCollectionMethodPanel: true,
                    displayPastOrderCardTotal: false,
                    enableKeepOrderAnalytic: true,
                    dispalyReorderAccordianItemAmount: false,
                    dispalyReorderAccordianTotalAmount: false,
                    hideCancelOrderPanel: false,
                    enableCancelOrderCallsupportModal: false,
                    pickupTrackOrderButtonLabel: 'pickupMethods',
                    enableGlobalOrderTracking: true,
                    enableRetryCountForPickupOrderTracking: false,
                    showOrderTrackingIFrame: false,
                    showDeliveryTrackingMap: true,
                    showDeliveryOrderRaiderDetailsView: true,
                    orderTrackingProgressBarCount: 7,
                    showDeliveryDriverDetails: true,
                    enableReadytoCollectLabel: true,
                    orderTrackingProgressBarScheduleOrdersCount: 2,
                    showOrderSummaryInfoDetails: false,
                    showGiftCardOrVoucherSummary: false,
                    showPromosSummary: true,
                    deliveryProgressBarAsapOrder: {
                        isDeliveryOrderPOSCompleted: 1,
                        isDeliveryOrderCreate: 2,
                        isDeliveryOrderAssign: 3,
                        isDeliveryOrderStoreArrival: 4,
                        isDeliveryOrderPickedUp: 5,
                        isDeliveryOrderOutForDelivery: 6,
                        isDeliveryOrderArrivedOrder: 7,
                    },
                    deliveryProgressBarScheduleOrders: {
                        isDeliveryOrderPOSCompleted: 1,
                        isDeliveryOrderCreate: 2,
                        isDeliveryOrderAssign: 3,
                        isDeliveryOrderStoreArrival: 4,
                        isDeliveryOrderPickedUp: 5,
                        isDeliveryOrderOutForDelivery: 6,
                        isDeliveryOrderArrivedOrder: 7,
                    },
                    hideEstimatedDeliveryTime: {
                        isDeliveryOrderCancelledOrRefund: true,
                    },
                    hideProgressBar: {},
                    getDeliveryActualPickupTime: false,
                    showOrderName: true,
                },
                payment: {
                    paymentFailedResetOrderAndBasket: false,
                    showFailedScreenOrderAccepted: true,
                    paymentCardValidateFailed: false,
                },
                accountPage: {
                    accountSettingsUpdateCustomerInfo: true,
                    showMyPaymentMethods: false,
                    suggestStreetAddress: false,
                    suggestionFilter: ['address'],
                    addNewCreditOrDebitCard: false,
                    maxSavedCardLimit: 0,
                    validateNameRegex: /^(?=.*[a-zA-Z].*)([a-zA-Z-']{1,100})$/,
                    showSavedCardCvv: false,
                },
                restaurantDetailPage: {
                    storeNumberFormat: /([0-9]{1,2})([0-9]{4})([0-9]{4}$)/,
                },
                contactKFC: {
                    isRenderIframeinContactUs: false,
                },
                scheduledDelivery: {
                    allowScheduleOrderForDispositions: [],
                },
                giftCardPageGlobal: false,
            },
            app: {
                home: {
                    callFetchMenu: false,
                    carousel: {
                        paginationColor: 'textColor',
                        backgroundColor: Strings.black,
                    },
                    welcomeBanner: {
                        showOffersLink: false,
                        showMyAccountLink: true,
                    },
                    banner: {
                        validateUserTypeAndLoc: true,
                    },
                    marketingHero: {
                        checkLocalisationAndNavigation: true,
                    },
                },
                accountSettings: {
                    isAuthOtpRequired: true,
                    showNonEditableEmailField: true,
                    showPostalCodeField: true,
                    showDOBField: true,
                    showClonelsClubMember: false,
                    showEmailPreference: true,
                    showNotificationPreference: true,
                    showSmsPreference: false,
                    isFirstNameMandatoryField: true,
                    isLastNameMandatoryField: true,
                    isPostalCodeMandtoryField: false,
                    postalCodeLength: 4,
                    postalCodeRegEx: postalCodeRegExAU,
                    formatPostalCode: false,
                    isEmailMandatoryField: true,
                    showToolTip: true,
                    isPhoneNumberValidationEnabled: true,
                    addAdditionalAttribute: true,
                    phoneNumerText: 'mobileNumberWithAstrick',
                    isEmailPrefGroupSubscription: false,
                    brazeExternalId: BrazeExternalIds.CustomerId,
                },
                global: {
                    defaultLoaderImage: 'kfcLoaderAUGif',
                    cateringNavigationAllowed: true,
                    getImageFromContent: true,
                },
                headerComponent: {
                    navigateToHome: false,
                },
                account: {
                    showContentCards: true,
                    showLogoutModal: true,
                    addressText: 'addresses',
                    getDispositionFlag: false,
                    showMyPaymentMethods: false,
                    showAddNewCardOption: false,
                    useDefaultDispositionForFavStore: false,
                    showMaxSavedCardWarningToast: false,
                    maxSavedCardLimit: 1000,
                    limitSavedCardList: false,
                },
                orderHistory: {
                    showFavouriteItemIcon: false,
                    showOrderLookup: false,
                    showPickupMethods: true,
                    showItemDescription: false,
                    showCartLineItemImage: false,
                    viewReceiptMore: false,
                    showTrackOrderCTA: false,
                },
                SignedOutComponent: {
                    showSigninSignUpBtnAlways: true,
                },
                disposition: {
                    showDispostionWithActive: false,
                    showDispositionTimeView: false,
                    showMonthAndDate: false,
                    showKeepitModal: true,
                    dispositionButtonText: 'changeStore',
                    showDispositionHeaderStickyFlag: true,
                    showDispositionHeaderFlag: false,
                    delivery: {
                        displayTime: 'asap',
                        navigateToProductNotAvailable: false,
                        shouldGetAvailableTimeslots: false,
                    },
                    activeOrderPayload_OrderMode: '',
                    showDispositionHeaderScrollableFlag: false,
                    showNonLocalization: false,
                },
                plp: {
                    checkIsProductAvailableFlag: false,
                    checkIsProductAvailableSopacFlag: true,
                    closingTimeFlag: true,
                    showStoreOfflineFlag: true,
                    isScrollDispositionFlag: true,
                    validateViewModeType: false,
                    showAddtoCartBtn: false,
                    navigateToPDP: true,
                    showFavouriteIcon: false,
                    showPromosSection: true,
                    showGenericMenu: false,
                    showLegalInfo: true,
                    getImageFromContent: true,
                    showProductDescription: false,
                    showFoodType: false,
                    showSecretMenu: true,
                    showCardBadge: false,
                    modelButtonText: 'BrowseStoreMenu',
                    showItemDetailsMultiline: false,
                },
                pdp: {
                    getImageFromContent: true,
                    showLegalInfo: true,
                    showAllergyNutrition: true,
                    showDispositionHeaderFlag: true,
                    getMealOptionsFromContent: true,
                    mealOptionsTitleTxt: 'mealOptions',
                    showHeader: true,
                },
                checkout: {
                    showCloseModalAndCloseSoonModal: false,
                    isProfileRequired: false,
                    isHOCRequired: false,
                    showSignUpBtn: true,
                    showMemberWarningMessage: true,
                    showContactInfo: false,
                    showOrderSummary: true,
                    showTimeSlot: false,
                    addressLineRequired: false,
                    paymentType: 'integrated',
                    paymentProvider: 'braintree',
                    showGuestCheckout: false,
                    showDeliveryInstructionsAlways: true,
                    passDeliveryPartnerForPickup: false,
                    passDeliveryPartnerForDeliveryFromOS: false,
                    defaultDeliveryPartner: '',
                    showFullDateTime: false,
                    showTaxExcluded: true,
                    paymentSectionTitleText: 'paymentSectionTitle',
                    tendertypeWithoutPayment: '',
                    callOrderApiOnCheckout: false,
                },
                cart: {
                    showRecommendationsView: {
                        showCalories: true,
                        showAddToCart: false,
                        showDescription: false,
                        showQuantityModifier: true,
                        showVeg: true,
                        showFav: true,
                        plpClickDisable: false,
                    },
                    enableApplyCoupon: false,
                    showRescheduleModalForStoreOpen: false,
                    showToastAfterItemCustomized: true,
                    showToastOnUpdateQuantity: false,
                    showToastOnRemoveItem: false,
                    showRemoveItemConfirmPopUp: false,
                    showCartBottomToast: true,
                    showRemoveAllBtn: false,
                    showEditButtonFlag: false,
                    shouldShowCustomTextSopacFlag: true,
                    navigateUsingLocalization: true,
                    showRemoveButtonForPromoItem: true,
                    isDispositionHeaderSticky: true,
                    isDispositionHeaderScrollable: false,
                    checkEditMessagePopup: true,
                    showCouponAppliedToast: false,
                    showErrorToast: false,
                    checkOutTotalValue: 'subtotal',
                    deliveryFee: false,
                    showGstValue: false,
                    cartGstText: 'cartGstIncluded',
                    removeInvalidatedCoupons: false,
                    callCreateOrder: true,
                    showEditButtonIfCustomizable: false,
                    showCustomiseBtnIfModData: true,
                    showUpdateQtyForPromoItem: true,
                    showPromosUnMetConditionToast: true,
                    showProductPromoFlag: true,
                    showPromosAppliedView: true,
                    showPromosInfoContainer: true,
                    showDiscountedPriceAfterLogin: true,
                    showDiscountText: false,
                    showErrorMessageForExpiredCoupon: false,
                    showCouponRemovalButton: false,
                    navigateToPromosTab: true,
                    offersAndDealsLinkText: 'viewAllPromos',
                    // to be removed after toggle merge
                    showToastAtEditLineItemFlag: true,
                    showRemoveAllContainerFlag: false,
                    showEditButtonCustom: true,
                    shouldShowModifierGroupsFlag: true,
                    showRecommendations: false,
                    shouldValidateStoreAndItemsAvailability: false,
                    shouldCheckIfStoreOpen: true,
                    shouldCheckIfStoreClose: true,
                    shouldValidateCheckoutButtonState: true,
                    showIndulgentAddOnsCrossCell: true,
                    shouldHideCartLabel: true,
                    shouldNavigateToMenu: true,
                    showThresholdError: true,
                    showProductEditedBanner: true,
                    qualityModifierStyle: 'addRemoveViewContainerAU',
                    itemPriceTextStyle: 'itemPriceTextAU',
                    unavailableItemPriceTextStyle: 'unavailableItemPriceTextAU',
                    removeLineItemViewContainerStyle: 'removeLineItemViewContainerAU',
                    toastImageStyle: 'toastImageAU',
                    toastTextStyle: 'removeLineItemConfirmationTextAU',
                    toastImage: 'exclamationMark',
                    toastAccessibilityLabel: 'alert',
                    subAmountContainerStyle: 'subAmountContainerAU',
                    discountRemoveButton: true,
                    discountCardView: true,
                    showAsap: false,
                    showTaxLines: false,
                    // end to be removed after toggle merge ///
                },
                more: {
                    getMoreDataLinksFromHeaderSection: true,
                    showSignInButton: true,
                    loginRedirectFromMore: '',
                    showSubHeadersInMiddle: false,
                },
                coupons: {
                    showAddToOrderBtn: true,
                    showRedeemBtn: false,
                    showViewAllPromosLink: true,
                    showMembersOnly: true,
                    showGotItBtn: true,
                    showRedeemBtnDetails: false,
                    showReviewConditions: true,
                    showLongDescription: false,
                    showLegalInfo: true,
                    cardImagePath: 'offers/card',
                    detailsImagePath: 'offers/detail',
                    shouldCheckLocalization: true,
                    signInCardText: 'kfcSignInExclusivePromos',
                    promosTitle: 'promosRewards',
                    nonLocalizedText: 'seePromosForYou',
                    shouldGetOffersAndDeals: false,
                },
                help: {
                    contentPayload: 'Support Help',
                    headLineTitle: true,
                    showNearKfc: false,
                    subHeading: false,
                    callDesc: false,
                    mainHeading: false,
                    showNeedHelpNow: true,
                    showGetBackToMe: true,
                    showNeedToTalk: false,
                    showCallUsText: false,
                    showDropUsText: true,
                    showFqaText: true,
                    showContactText: false,
                    showFaqDes: true,
                    showcontactDesc: false,
                    showCallKfcStore: true,
                    showCallRestaurant: false,
                    showSendUsMsg: true,
                    showCallText: false,
                    showContactButtonText: false,
                    showViewAllButtonText: true,
                },
                reorder: {
                    useOrderId: false,
                    showReviewOrder: true,
                    showReOrder: false,
                    showViewDetails: false,
                },
                quickReorder: {
                    checkItemAvailabilityOnLoad: true,
                    createBasketOnLoad: false,
                    callTendersDataOnLoad: false,
                    modifierFilterForIsAdded: true,
                    unAvailableItemErrorOnTopRequired: false,
                    ItemPriceChangeErrorOnTopRequired: false,
                    whenOptionRequired: false,
                    orderTypeChangeRequired: true,
                    locationChangeRequired: true,
                    restaurantChangeRequired: true,
                    itemUmAvailableWarningRequired: true,
                    continuePaymentOption: false,
                    orderAgainButtonOption: true,
                    wantToAddModifyRequired: false,
                    expandCollapseRequired: true,
                    isPaymentTypeRequired: false,
                    showAmountView: false,
                    showModifier: false,
                },
                webView: {
                    titleJSX: 'renderTitleAu',
                },
                addToCart: {
                    shouldCheckSecretMenu: true,
                },
                modal: {
                    modalStyle: 'modalStyleAu',
                },
                minorUpdateComp: {
                    bottomSheetIcon: 'iconAu',
                },
                storeSearch: {
                    tradingHours: true,
                    showSearchFieldPlaceholder: false,
                    showStoreOpenStatus: false,
                    showOrderNowString: false,
                    enableScheduleOrderNowFunctionality: false,
                    showMoreInfoText: false,
                    showSheduledOrderCta: false,
                    showSheduledOrderCtaWhenStoreClosed: false,
                    showAdditionalView: true,
                    showOrderTypeError: true,
                    asapFlagFromOloAdminRequired: false,
                    autoSelectDeliveryStore: false,
                    showStoreListForOneStore: false,
                    isAdditionalAddressRequired: false,
                    addressErrorMessage: {
                        showIcon: true,
                        headerStyle: {
                            color: '#FF2E00',
                            fontFamily: fontFamilyRegular,
                        },
                    },
                },
                address: {
                    shouldRenderEmptyStoreList: true,
                    shouldshowflatSection: true,
                    showdeliveryOptions: true,
                    showdeliveryInstructionAddress: true,
                    nickNameOptional: true,
                    nickNameMandatory: false,
                    headerForAddress: 'savedAddressHeaderTitle',
                    textForEmptyAddress: 'emptySavedStore',
                    disablePostalCodeField: true,
                },
                popNavigatorUtil: {
                    schedulrOrderTitle: 'orderMode',
                },
                pickupTracking: {
                    showTrackingHeader: true,
                    showReceiptHeader: false,
                    showPickupMethods: true,
                    showCancelOrder: true,
                    showSaveOrderBottom: true,
                    showStorePhonenumber: false,
                    showViewDetails: false,
                    showAppRating: false,
                    orderRef: 'referenceNumber',
                    showOperatingHrs: true,
                    showStoreAddress: false,
                    showDownArrow: true,
                    cancelOrderText: 'cancelOrderButtonText',
                    callSupportToCancelOrder: false,
                    enablePickupTracking: false,
                    showEmailText: false,
                    orderStatus: riderStatus,
                },
                scheduledDelivery: {
                    showKfcStoreNameForDelivery: true,
                    showScheduleDateTime: false,
                    showAusErrorMsgComponent: true,
                    showIndErrorMsgComponent: false,
                    dateFormat: 'DD/MM/YYYY',
                    initialDisplayTime: 'asap',
                    allowScheduleOrderForDispositions: [],
                    midnightOrderSupport: false,
                    showChangeCTAForRestaurant: true,
                    showStoreCardForClosedStore: false,
                    alwaysShowAsapInTimeslot: false,
                },
                deliveryTracking: {
                    displayScheduleProgressBar: false,
                    showDirections: false,
                    showStorePhoneNumber: false,
                    fetchContentfulData: false,
                    trackingUrl: 'deliveryTrackingUrl',
                    showStoreDetailsInContact: false,
                    showSMSviewInContact: true,
                    orderStatus: riderStatus,
                    riderName: 'riderName',
                    riderPhone: 'riderPhoneForCustomer',
                    custmerCareNumber: '1800 958 316',
                },
                favouriteMenu: {
                    showFavItems: false,
                    buttonValueText: 'orderAgain',
                    sectionHeaderValue: true,
                    itemButtonText: 'removeFavourites',
                    favIcon: false,
                    unavailableErrorText: false,
                    checkIfNameExists: true,
                    delDescriptionValue: true,
                    submitButtonText: 'cartRemove',
                    deleteAddressItemText: 'removedFromFav',
                    showToastOnFavouriteOrder: true,
                    getImageFromContent: true,
                    showReviewOrderButton: true,
                    closeImageStyle: true,
                    buttonContainerStyle: true,
                },
            },
        },
        hasMultipleItems: ['dipping-sauces'],
    },
};
export const getGenericMenuName = (param) => {
    try {
        const result = JSON.parse(param);
        return result.reduce((obj, item) => (item.lang === App.envVars?.language ? item.value : result[0].value), '');
    }
    catch (e) {
        return param;
    }
};
const tenantReducer = (state = tenantData, action) => {
    switch (action.type) {
        case GET_TENANT_CONFIG:
            return {
                ...state,
                ...initialState[action?.country],
            };
        case UPDATE_TENANT_CONFIG:
            return {
                ...state,
                loading: true,
                error: false,
            };
        case UPDATE_TENANT_CONFIG_SUCCESS:
            return {
                ...state,
                authoredContent: {
                    ...state.authoredContent,
                    appUpdate: {
                        ...state.authoredContent?.appUpdate,
                        minSupportedVersion: {
                            imageVersion: action.response.imageversion || '1.00',
                        },
                    },
                },
                imageVersion: action.response?.imageversion || '1.00',
                mobilesecretmenuname: action.response?.mobilesecretmenuname,
                secretmenutime: action.response?.secretmenutime,
                ispolygonrequired: action.response?.ispolygonrequired || false,
                orderstatusnotifications: action.response?.orderstatusnotifications || false,
                cateringmaxorderfuturedaycount: action.response?.cateringmaxorderfuturedaycount || '6',
                maxNoOfVoucher: action.response?.maxnoofvoucher || 5,
                cateringminorderdaycount: action.response?.cateringminorderdaycount || '1',
                mobilecontactlessdeliveryenabled: action.response?.mobilecontactlessdeliveryenabled || true,
                storelocatormaxreturncount: action.response?.storelocatormaxreturncount || '10',
                buffertimepmdelivery: action.response?.buffertimepmdelivery || '30',
                buffertimepmpickup: action.response?.buffertimepmpickup || '30',
                accountdashboardpreviousordercount: action.response?.accountdashboardpreviousordercount || '3',
                secondarycontact: action.response?.secondarycontact,
                loading: false,
                error: false,
                genericMenuName: getGenericMenuName(config(GENERIC_MENU_NAME)),
                genericCateringName: config(GENERIC_MENU_NAME_CATERING),
                brazeEmailGroupId: config(BRAZE_EMAIL_SUBSCRIPTION_GROUP_ID),
                brazeSMSGroupId: config(BRAZE_SMS_SUBSCRIPTION_GROUP_ID),
            };
        case UPDATE_TENANT_CONFIG_ERROR:
            return {
                ...state,
                loading: false,
                error: true,
            };
        case SETLOCATION_NAVIGATION:
            return {
                ...state,
                isNavigateFromPromos: action.payload,
            };
        case SETLOCATION_HOME_NAVIGATION:
            return {
                ...state,
                isNavigateFromHome: action.payload,
            };
        default:
            return { ...state };
    }
};
export default tenantReducer;
